"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// ../types/dist/index.js
var require_dist = __commonJS({
  "../types/dist/index.js"(exports, module2) {
    "use strict";
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames2 = Object.getOwnPropertyNames;
    var __hasOwnProp2 = Object.prototype.hasOwnProperty;
    var __export2 = (target, all) => {
      for (var name in all)
        __defProp2(target, name, { get: all[name], enumerable: true });
    };
    var __copyProps2 = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames2(from))
          if (!__hasOwnProp2.call(to, key) && key !== except)
            __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
      }
      return to;
    };
    var __toCommonJS2 = (mod) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod);
    var src_exports2 = {};
    __export2(src_exports2, {
      ADMIN_ROLES: () => ADMIN_ROLES3,
      BACKOFFICE_CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS: () => BACKOFFICE_CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS,
      BRUTE_INCOME_TYPES: () => BRUTE_INCOME_TYPES3,
      CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS: () => CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS,
      CLIENT_DIGITAL_DOSSIER_SECTIONS_STATUS: () => CLIENT_DIGITAL_DOSSIER_SECTIONS_STATUS,
      COMPANY_ACTIVITIES: () => COMPANY_ACTIVITIES3,
      COMPANY_STATUSES: () => COMPANY_STATUSES2,
      COMPANY_TYPES: () => COMPANY_TYPES5,
      CREDITOR_INSPECTION_RIGHTS: () => CREDITOR_INSPECTION_RIGHTS2,
      CROP_PLEDGE_USER_ROLES: () => CROP_PLEDGE_USER_ROLES,
      CURRENCIES: () => CURRENCIES4,
      DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS: () => DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS2,
      DIGITAL_DOSSIER_SECTIONS: () => DIGITAL_DOSSIER_SECTIONS2,
      DIGITAL_DOSSIER_STATUS: () => DIGITAL_DOSSIER_STATUS2,
      DIGITAL_DOSSIER_SUBSECTIONS: () => DIGITAL_DOSSIER_SUBSECTIONS,
      DOCUMENT_TYPES: () => DOCUMENT_TYPES,
      ERROR_CODES: () => ERROR_CODES,
      EXCHANGES: () => EXCHANGES3,
      EXPLOITATION_TYPES: () => EXPLOITATION_TYPES2,
      FILE_MIME_TYPES: () => FILE_MIME_TYPES2,
      HttpStatus: () => HttpStatus,
      IDENTITY_DOCUMENT_TYPES: () => IDENTITY_DOCUMENT_TYPES4,
      IVA_CONDITION: () => IVA_CONDITION3,
      LEASE_CONTRACT_TYPES: () => LEASE_CONTRACT_TYPES2,
      MARITAL_STATUSES: () => MARITAL_STATUSES3,
      NATIONALITIES: () => NATIONALITIES3,
      OWNERSHIP_TYPES: () => OWNERSHIP_TYPES4,
      PLEDGE_CROP_CLASSES: () => PLEDGE_CROP_CLASSES2,
      PLEDGE_CROP_DEGREES: () => PLEDGE_CROP_DEGREES2,
      PLEDGE_SECTIONS: () => PLEDGE_SECTIONS,
      PLEDGE_SECTION_STATUSES: () => PLEDGE_SECTION_STATUSES,
      PLEDGE_STATUSES: () => PLEDGE_STATUSES2,
      POWER_OF_ATTORNEY_EXCHANGES: () => POWER_OF_ATTORNEY_EXCHANGES2,
      PRODUCTS: () => PRODUCTS3,
      PROFIT_TYPES: () => PROFIT_TYPES3,
      PROVINCES: () => PROVINCES3,
      QUERY_STATUSES: () => QUERY_STATUSES,
      REPRESENTATIVE_POSITIONS: () => REPRESENTATIVE_POSITIONS4,
      RUCA_NOT_CURRENT_WARNING: () => RUCA_NOT_CURRENT_WARNING,
      RUCA_STATUSES: () => RUCA_STATUSES3,
      SEARCH_DIGITAL_DOSSIER_ACTIONS: () => SEARCH_DIGITAL_DOSSIER_ACTIONS,
      SEARCH_DIGITAL_DOSSIER_STATUS: () => SEARCH_DIGITAL_DOSSIER_STATUS,
      SIGNATURE_LEVELS: () => SIGNATURE_LEVELS2,
      SISA_ACTIVITIES: () => SISA_ACTIVITIES2,
      SISA_SCORINGS: () => SISA_SCORINGS2,
      USER_COMPANY_STATUSES: () => USER_COMPANY_STATUSES2,
      USER_ROLES: () => USER_ROLES3,
      USER_STATUSES: () => USER_STATUSES3,
      USER_TYPES: () => USER_TYPES,
      VALIDATION_STATUSES: () => VALIDATION_STATUSES3,
      VIEWER_DIGITAL_DOSSIER_GENERAL_STATUS: () => VIEWER_DIGITAL_DOSSIER_GENERAL_STATUS,
      YES_NO_OPTIONS: () => YES_NO_OPTIONS6,
      adminRoles: () => adminRoles,
      backofficeClientDigitalDossierGeneralStatus: () => backofficeClientDigitalDossierGeneralStatus,
      bruteIncomeTypes: () => bruteIncomeTypes,
      clientDigitalDossierGeneralStatus: () => clientDigitalDossierGeneralStatus,
      clientDigitalDossierSectionsStatus: () => clientDigitalDossierSectionsStatus,
      companyActivities: () => companyActivities,
      companyStatuses: () => companyStatuses,
      companyTypes: () => companyTypes,
      creditorInspectionRights: () => creditorInspectionRights,
      cropPledgeUserRoles: () => cropPledgeUserRoles,
      currencies: () => currencies,
      defaultMimeTypes: () => defaultMimeTypes,
      digitalDossierAccessRequestStatuses: () => digitalDossierAccessRequestStatuses,
      digitalDossierSections: () => digitalDossierSections,
      digitalDossierStatus: () => digitalDossierStatus,
      digitalDossierSubsection: () => digitalDossierSubsection,
      documentTypes: () => documentTypes,
      exchanges: () => exchanges,
      exploitationTypes: () => exploitationTypes,
      fileMimeTypes: () => fileMimeTypes,
      geoDocumentationMimeTypes: () => geoDocumentationMimeTypes,
      identityDocumentTypes: () => identityDocumentTypes,
      ivaCondition: () => ivaCondition,
      leaseContractTypes: () => leaseContractTypes,
      maritalStatuses: () => maritalStatuses,
      nationalityTypes: () => nationalityTypes,
      ownershipTypes: () => ownershipTypes,
      pledgeCropClasses: () => pledgeCropClasses,
      pledgeCropDegreees: () => pledgeCropDegreees,
      pledgeSectionStatuses: () => pledgeSectionStatuses,
      pledgeSections: () => pledgeSections,
      pledgeStatuses: () => pledgeStatuses,
      powerOfAttorneyExchanges: () => powerOfAttorneyExchanges,
      products: () => products,
      profitTypes: () => profitTypes,
      provinces: () => provinces,
      queryStatuses: () => queryStatuses,
      representativePositions: () => representativePositions,
      rucaNotCurrentWarnings: () => rucaNotCurrentWarnings,
      rucaStatuses: () => rucaStatuses,
      searchDigitalDossierActions: () => searchDigitalDossierActions,
      searchDigitalDossierStatuses: () => searchDigitalDossierStatuses,
      signatureLevels: () => signatureLevels,
      sisaActivities: () => sisaActivities,
      sisaScorings: () => sisaScorings,
      userCompanyStatuses: () => userCompanyStatuses,
      userRoles: () => userRoles,
      userStatuses: () => userStatuses,
      userTypes: () => userTypes,
      validationStatuses: () => validationStatuses,
      viewerDigitalDossierGeneralStatus: () => viewerDigitalDossierGeneralStatus,
      yesNoOptions: () => yesNoOptions
    });
    module2.exports = __toCommonJS2(src_exports2);
    var ADMIN_ROLES3 = {
      MANAGER: "MANAGER",
      VALIDATOR: "VALIDATOR"
    };
    var adminRoles = Object.values(ADMIN_ROLES3);
    var BRUTE_INCOME_TYPES3 = {
      LOCAL_JURISDICTION: "LOCAL_JURISDICTION",
      MULTILATERAL_AGREEMENT: "MULTILATERAL_AGREEMENT",
      EXEMPT: "EXEMPT"
    };
    var bruteIncomeTypes = Object.values(BRUTE_INCOME_TYPES3);
    var COMPANY_ACTIVITIES3 = {
      PRODUCER: "PRODUCER",
      RUNNER: "RUNNER",
      CEREAL_MARKET_AT_THE_END: "CEREAL_MARKET_AT_THE_END",
      OPERATOR_WITH_PLANT: "OPERATOR_WITH_PLANT",
      OPERATOR_WITHOUT_PLANT: "OPERATOR_WITHOUT_PLANT",
      EXCHANGER: "EXCHANGER"
    };
    var companyActivities = Object.values(COMPANY_ACTIVITIES3);
    var COMPANY_STATUSES2 = {
      ACTIVE: "ACTIVE",
      INACTIVE: "INACTIVE"
    };
    var companyStatuses = Object.values(COMPANY_STATUSES2);
    var COMPANY_TYPES5 = {
      PF: "PF",
      // Persona fisica
      SH: "SH",
      // Sociedades de hecho
      SA: "SA",
      // Sociedad anonima
      SRL: "SRL",
      // Sociedad responsabildiad limitada
      SAS: "SAS",
      // Sociedad anonima simplificada
      SAU: "SAU",
      // Sociedad anonima unipersonal
      COOP: "COOP",
      // Cooperativa
      AS: "AS",
      // Asociaciones civiles
      FUND: "FUND",
      // Fundaciones
      FID: "FID",
      // Fideicomisos
      OTHER: "OTHER"
      // Otro
    };
    var companyTypes = Object.values(COMPANY_TYPES5);
    var CURRENCIES4 = {
      ARS: "ARS",
      USD: "USD"
    };
    var currencies = Object.values(CURRENCIES4);
    var CREDITOR_INSPECTION_RIGHTS2 = {
      BROAD: "BROAD",
      LIMITED: "LIMITED"
    };
    var creditorInspectionRights = Object.values(
      CREDITOR_INSPECTION_RIGHTS2
    );
    var CROP_PLEDGE_USER_ROLES = {
      DEBTOR: "DEBTOR",
      BACKOFFICE: "BACKOFFICE",
      CREDITOR: "CREDITOR"
    };
    var cropPledgeUserRoles = Object.values(CROP_PLEDGE_USER_ROLES);
    var DOCUMENT_TYPES = {
      // GENERAL
      IGJ: "IGJ",
      // BANKING
      CBU: "CBU",
      // TAXES
      CUIT: "CUIT",
      IIBB: "IIBB",
      CM05: "CM05",
      PROFITS: "PROFITS",
      IVA: "IVA",
      EXEMPTIONS: "EXEMPTIONS",
      // DOCUMENTATION
      SISA: "SISA",
      PRODUCTION_CAPACITY: "PRODUCTION_CAPACITY",
      STORAGE_CAPACITY: "STORAGE_CAPACITY",
      BALANCE_SHEET: "BALANCE_SHEET",
      OWNER_ID_CARD: "OWNER_ID_CARD",
      STATUTE: "STATUTE",
      STATUTE_CHANGE: "STATUTE_CHANGE",
      ASSEMBLY_BOARD_MINUTES: "ASSEMBLY_BOARD_MINUTES",
      POWERS_OF_ATTORNEY: "POWERS_OF_ATTORNEY",
      ADDITIONAL_FORMS_AND_DOCS_DOCUMENT: "ADDITIONAL_FORMS_AND_DOCS_DOCUMENT",
      // REPRESENTANTS
      REPRESENTATIVE_ID_CARD: "REPRESENTATIVE_ID_CARD",
      SIGNUP_PERMISSION: "SIGNUP_PERMISSION",
      //EQUITY
      ADDITIONAL_EQUITY_DOCUMENT: "ADDITIONAL_EQUITY_DOCUMENT",
      // OTHER
      UNKNOWN: "UNKNOWN",
      // GEOLOCATION
      GEOLOCATION: "GEOLOCATION",
      // CONTRACTS:
      COMPANY_QUERY_LOAD_CONTRACT: "COMPANY_QUERY_LOAD_CONTRACT",
      // CROP PLEDGE
      LOAN_CONTRACT: "LOAN_CONTRACT",
      ADDITIONAL_CROP_PLEDGE_DOCUMENT: "ADDITIONAL_CROP_PLEDGE_DOCUMENT",
      CARBON_ANALYSIS: "CARBON_ANALYSIS",
      DOMAIN_REPORT: "DOMAIN_REPORT",
      MODIFICATION_FORM: "MODIFICATION_FORM",
      REGISTERED_PLEDGE: "REGISTERED_PLEDGE",
      DEREGISTRATION_OF_PLEDGE: "DEREGISTRATION_OF_PLEDGE",
      ADDITIONAL_CROP_PLEDGE_FARM_DOCUMENT: "ADDITIONAL_CROP_PLEDGE_FARM_DOCUMENT",
      PLEDGE_REGISTRATION_FORM_TEMPLATE: "PLEDGE_REGISTRATION_FORM_TEMPLATE"
    };
    var documentTypes = Object.values(DOCUMENT_TYPES);
    var DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS2 = {
      PENDING: "PENDING",
      APPROVED: "APPROVED",
      REJECTED: "REJECTED",
      EXPIRED: "EXPIRED",
      REVOKED: "REVOKED"
    };
    var digitalDossierAccessRequestStatuses = Object.values(
      DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS2
    );
    var DIGITAL_DOSSIER_STATUS2 = {
      PENDING_DATA_UPLOAD_CLIENT: "PENDING_DATA_UPLOAD_CLIENT",
      PENDING_DATA_UPLOAD_BACKOFFICE: "PENDING_DATA_UPLOAD_BACKOFFICE",
      PENDING_APPROVAL: "PENDING_APPROVAL",
      APPROVED: "APPROVED"
    };
    var digitalDossierStatus = Object.values(DIGITAL_DOSSIER_STATUS2);
    var CLIENT_DIGITAL_DOSSIER_SECTIONS_STATUS = {
      PENDING_DATA_UPLOAD: "PENDING_DATA_UPLOAD",
      PENDING_APPROVAL: "PENDING_APPROVAL",
      PENDING_REVIEW: "PENDING_REVIEW",
      APPROVED: "APPROVED"
    };
    var clientDigitalDossierSectionsStatus = Object.values(
      CLIENT_DIGITAL_DOSSIER_SECTIONS_STATUS
    );
    var CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS = {
      INFORMATION_EXPIRED: "INFORMATION_EXPIRED",
      RUCA_EXPIRED: "RUCA_EXPIRED",
      APPROVED: "APPROVED"
    };
    var clientDigitalDossierGeneralStatus = Object.values(
      CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS
    );
    var BACKOFFICE_CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS = {
      ...DIGITAL_DOSSIER_STATUS2,
      INFORMATION_EXPIRED: "INFORMATION_EXPIRED",
      RUCA_EXPIRED: "RUCA_EXPIRED",
      APPROVED: "APPROVED"
    };
    var backofficeClientDigitalDossierGeneralStatus = Object.values(
      BACKOFFICE_CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS
    );
    var VIEWER_DIGITAL_DOSSIER_GENERAL_STATUS = {
      INFORMATION_EXPIRED: "INFORMATION_EXPIRED",
      RUCA_EXPIRED: "RUCA_EXPIRED",
      APPROVED: "APPROVED"
    };
    var viewerDigitalDossierGeneralStatus = Object.values(
      VIEWER_DIGITAL_DOSSIER_GENERAL_STATUS
    );
    var DIGITAL_DOSSIER_SECTIONS2 = {
      DIGITAL_DOSSIER: "DIGITAL_DOSSIER",
      CONTACT_INFORMATION: "CONTACT_INFORMATION",
      DECLARED_JURISDICTIONS: "DECLARED_JURISDICTIONS",
      ASSET_INFORMATION: "ASSET_INFORMATION"
    };
    var digitalDossierSections = Object.values(DIGITAL_DOSSIER_SECTIONS2);
    var DIGITAL_DOSSIER_SUBSECTIONS = {
      GENERAL_INFO: "GENERAL_INFO",
      TAX_INFO: "TAX_INFO",
      BANKING_INFO: "BANKING_INFO",
      FORMS_AND_DOCS: "FORMS_AND_DOCS",
      LEGAL_REPRESENTANTS: "LEGAL_REPRESENTANTS"
    };
    var digitalDossierSubsection = Object.values(
      DIGITAL_DOSSIER_SUBSECTIONS
    );
    var EXCHANGES3 = {
      BCBA: "BCBA"
    };
    var exchanges = Object.values(EXCHANGES3);
    var EXPLOITATION_TYPES2 = {
      AGRICULTURAL: "AGRICULTURAL",
      LIVE_STOCK: "LIVE_STOCK",
      MIXED: "MIXED"
    };
    var exploitationTypes = Object.values(EXPLOITATION_TYPES2);
    var FILE_MIME_TYPES2 = {
      JPEG: "image/jpeg",
      PNG: "image/png",
      PDF: "application/pdf",
      KMZ: "application/vnd.google-earth.kmz",
      GEOJSON: "application/geo+json",
      JSON: "application/json"
    };
    var fileMimeTypes = Object.values(FILE_MIME_TYPES2);
    var defaultMimeTypes = {
      [FILE_MIME_TYPES2.JPEG]: [".jpeg", ".jpg"],
      [FILE_MIME_TYPES2.PNG]: [".png"],
      [FILE_MIME_TYPES2.PDF]: [".pdf"]
    };
    var geoDocumentationMimeTypes = {
      [FILE_MIME_TYPES2.KMZ]: [".kmz"],
      [FILE_MIME_TYPES2.GEOJSON]: [".geojson", ".json"]
    };
    var HttpStatus = /* @__PURE__ */ ((HttpStatus2) => {
      HttpStatus2[HttpStatus2["CONTINUE"] = 100] = "CONTINUE";
      HttpStatus2[HttpStatus2["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
      HttpStatus2[HttpStatus2["PROCESSING"] = 102] = "PROCESSING";
      HttpStatus2[HttpStatus2["EARLYHINTS"] = 103] = "EARLYHINTS";
      HttpStatus2[HttpStatus2["OK"] = 200] = "OK";
      HttpStatus2[HttpStatus2["CREATED"] = 201] = "CREATED";
      HttpStatus2[HttpStatus2["ACCEPTED"] = 202] = "ACCEPTED";
      HttpStatus2[HttpStatus2["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
      HttpStatus2[HttpStatus2["NO_CONTENT"] = 204] = "NO_CONTENT";
      HttpStatus2[HttpStatus2["RESET_CONTENT"] = 205] = "RESET_CONTENT";
      HttpStatus2[HttpStatus2["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
      HttpStatus2[HttpStatus2["AMBIGUOUS"] = 300] = "AMBIGUOUS";
      HttpStatus2[HttpStatus2["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
      HttpStatus2[HttpStatus2["FOUND"] = 302] = "FOUND";
      HttpStatus2[HttpStatus2["SEE_OTHER"] = 303] = "SEE_OTHER";
      HttpStatus2[HttpStatus2["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
      HttpStatus2[HttpStatus2["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
      HttpStatus2[HttpStatus2["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
      HttpStatus2[HttpStatus2["BAD_REQUEST"] = 400] = "BAD_REQUEST";
      HttpStatus2[HttpStatus2["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
      HttpStatus2[HttpStatus2["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
      HttpStatus2[HttpStatus2["FORBIDDEN"] = 403] = "FORBIDDEN";
      HttpStatus2[HttpStatus2["NOT_FOUND"] = 404] = "NOT_FOUND";
      HttpStatus2[HttpStatus2["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
      HttpStatus2[HttpStatus2["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
      HttpStatus2[HttpStatus2["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
      HttpStatus2[HttpStatus2["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
      HttpStatus2[HttpStatus2["CONFLICT"] = 409] = "CONFLICT";
      HttpStatus2[HttpStatus2["GONE"] = 410] = "GONE";
      HttpStatus2[HttpStatus2["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
      HttpStatus2[HttpStatus2["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
      HttpStatus2[HttpStatus2["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
      HttpStatus2[HttpStatus2["URI_TOO_LONG"] = 414] = "URI_TOO_LONG";
      HttpStatus2[HttpStatus2["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
      HttpStatus2[HttpStatus2["REQUESTED_RANGE_NOT_SATISFIABLE"] = 416] = "REQUESTED_RANGE_NOT_SATISFIABLE";
      HttpStatus2[HttpStatus2["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
      HttpStatus2[HttpStatus2["I_AM_A_TEAPOT"] = 418] = "I_AM_A_TEAPOT";
      HttpStatus2[HttpStatus2["MISDIRECTED"] = 421] = "MISDIRECTED";
      HttpStatus2[HttpStatus2["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
      HttpStatus2[HttpStatus2["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
      HttpStatus2[HttpStatus2["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
      HttpStatus2[HttpStatus2["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
      HttpStatus2[HttpStatus2["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
      HttpStatus2[HttpStatus2["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
      HttpStatus2[HttpStatus2["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
      HttpStatus2[HttpStatus2["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
      HttpStatus2[HttpStatus2["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
      HttpStatus2[HttpStatus2["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
      return HttpStatus2;
    })(HttpStatus || {});
    var IDENTITY_DOCUMENT_TYPES4 = {
      DNI: "DNI",
      ENROLAMIENTO: "ENROLAMIENTO",
      PASSPORT: "PASSPORT"
    };
    var identityDocumentTypes = Object.values(IDENTITY_DOCUMENT_TYPES4);
    var IVA_CONDITION3 = {
      IVA_REGISTERED_RESPONSIBLE: "IVA_REGISTERED_RESPONSIBLE",
      IVA_EXEMPT_SUBJECT: "IVA_EXEMPT_SUBJECT",
      MONOTAX_RESPONSIBLE: "MONOTAX_RESPONSIBLE",
      UNCATEGORIZED_SUBJECT: "UNCATEGORIZED_SUBJECT",
      FOREIGN_SUPPLIER: "FOREIGN_SUPPLIER",
      FOREIGN_CLIENT: "FOREIGN_CLIENT",
      IVA_RELEASED: "IVA_RELEASED",
      MONOTRIBUTIST_SOCIAL: "MONOTRIBUTIST_SOCIAL",
      IVA_NOT_REACHED: "IVA_NOT_REACHED",
      PROMOTED_INDEPENDENT_WORKER_MONOTRIBUTIST: "PROMOTED_INDEPENDENT_WORKER_MONOTRIBUTIST"
    };
    var ivaCondition = Object.values(IVA_CONDITION3);
    var LEASE_CONTRACT_TYPES2 = {
      LEASE: "LEASE",
      ACCIDENTAL_LEASE: "ACCIDENTAL_LEASE",
      SHARECROPPING: "SHARECROPPING",
      ACCIDENTAL_SHARECROPPING: "ACCIDENTAL_SHARECROPPING",
      PERCENTAGE_BASED_FARMING: "PERCENTAGE_BASED_FARMING",
      ASSOCIATIVE: "ASSOCIATIVE",
      FREE_TRANSFER_WITH_USUFRUCT_RIGHTS: "FREE_TRANSFER_WITH_USUFRUCT_RIGHTS",
      PAID_TRANSFER_WITH_USUFRUCT_RIGHTS: "PAID_TRANSFER_WITH_USUFRUCT_RIGHTS",
      JOINT_EXPLOITATION_CONTRACT: "JOINT_EXPLOITATION_CONTRACT",
      OTHER: "OTHER"
    };
    var leaseContractTypes = Object.values(LEASE_CONTRACT_TYPES2);
    var MARITAL_STATUSES3 = {
      SINGLE: "SINGLE",
      MARRIED: "MARRIED",
      DIVORCED: "DIVORCED",
      WIDOWED: "WIDOWED"
    };
    var maritalStatuses = Object.values(MARITAL_STATUSES3);
    var NATIONALITIES3 = {
      ARGENTINE: "ARGENTINE",
      AFGHAN: "AFGHAN",
      ALBANIAN: "ALBANIAN",
      ALGERIAN: "ALGERIAN",
      AMERICAN: "AMERICAN",
      ANDORRAN: "ANDORRAN",
      ANGOLAN: "ANGOLAN",
      ARMENIAN: "ARMENIAN",
      AUSTRALIAN: "AUSTRALIAN",
      AUSTRIAN: "AUSTRIAN",
      AZERBAIJANI: "AZERBAIJANI",
      BAHAMIAN: "BAHAMIAN",
      BAHRAINI: "BAHRAINI",
      BANGLADESHI: "BANGLADESHI",
      BARBADIAN: "BARBADIAN",
      BELARUSIAN: "BELARUSIAN",
      BELGIAN: "BELGIAN",
      BELIZEAN: "BELIZEAN",
      BENINESE: "BENINESE",
      BHUTANESE: "BHUTANESE",
      BOLIVIAN: "BOLIVIAN",
      BOSNIAN: "BOSNIAN",
      BRAZILIAN: "BRAZILIAN",
      BRITISH: "BRITISH",
      BRUNEIAN: "BRUNEIAN",
      BULGARIAN: "BULGARIAN",
      BURKINABE: "BURKINABE",
      BURMESE: "BURMESE",
      BURUNDIAN: "BURUNDIAN",
      CAMBODIAN: "CAMBODIAN",
      CAMEROONIAN: "CAMEROONIAN",
      CANADIAN: "CANADIAN",
      CAPE_VERDEAN: "CAPE_VERDEAN",
      CENTRAL_AFRICAN: "CENTRAL_AFRICAN",
      CHADIAN: "CHADIAN",
      CHILEAN: "CHILEAN",
      CHINESE: "CHINESE",
      COLOMBIAN: "COLOMBIAN",
      COMORIAN: "COMORIAN",
      CONGOLESE: "CONGOLESE",
      COSTA_RICAN: "COSTA_RICAN",
      CROATIAN: "CROATIAN",
      CUBAN: "CUBAN",
      CYPRIOT: "CYPRIOT",
      CZECH: "CZECH",
      DANISH: "DANISH",
      DJIBOUTIAN: "DJIBOUTIAN",
      DOMINICAN: "DOMINICAN",
      DUTCH: "DUTCH",
      EAST_TIMORESE: "EAST_TIMORESE",
      ECUADOREAN: "ECUADOREAN",
      EGYPTIAN: "EGYPTIAN",
      EMIRATI: "EMIRATI",
      EQUATORIAL_GUINEAN: "EQUATORIAL_GUINEAN",
      ERITREAN: "ERITREAN",
      ESTONIAN: "ESTONIAN",
      ETHIOPIAN: "ETHIOPIAN",
      FIJIAN: "FIJIAN",
      FILIPINO: "FILIPINO",
      FINNISH: "FINNISH",
      FRENCH: "FRENCH",
      GABONESE: "GABONESE",
      GAMBIAN: "GAMBIAN",
      GEORGIAN: "GEORGIAN",
      GERMAN: "GERMAN",
      GHANAIAN: "GHANAIAN",
      GREEK: "GREEK",
      GRENADIAN: "GRENADIAN",
      GUATEMALAN: "GUATEMALAN",
      GUINEAN: "GUINEAN",
      GUINEA_BISSAUAN: "GUINEA_BISSAUAN",
      GUYANESE: "GUYANESE",
      HAITIAN: "HAITIAN",
      HONDURAN: "HONDURAN",
      HUNGARIAN: "HUNGARIAN",
      ICELANDER: "ICELANDER",
      INDIAN: "INDIAN",
      INDONESIAN: "INDONESIAN",
      IRANIAN: "IRANIAN",
      IRAQI: "IRAQI",
      IRISH: "IRISH",
      ISRAELI: "ISRAELI",
      ITALIAN: "ITALIAN",
      IVORIAN: "IVORIAN",
      JAMAICAN: "JAMAICAN",
      JAPANESE: "JAPANESE",
      JORDANIAN: "JORDANIAN",
      KAZAKH: "KAZAKH",
      KENYAN: "KENYAN",
      KIRIBATI: "KIRIBATI",
      KOREAN: "KOREAN",
      KUWAITI: "KUWAITI",
      KYRGYZ: "KYRGYZ",
      LAOTIAN: "LAOTIAN",
      LATVIAN: "LATVIAN",
      LEBANESE: "LEBANESE",
      LESOTHO: "LESOTHO",
      LIBERIAN: "LIBERIAN",
      LIBYAN: "LIBYAN",
      LIECHTENSTEINER: "LIECHTENSTEINER",
      LITHUANIAN: "LITHUANIAN",
      LUXEMBOURGISH: "LUXEMBOURGISH",
      MACEDONIAN: "MACEDONIAN",
      MALAGASY: "MALAGASY",
      MALAWIAN: "MALAWIAN",
      MALAYSIAN: "MALAYSIAN",
      MALDIVIAN: "MALDIVIAN",
      MALIEN: "MALIEN",
      MALTESE: "MALTESE",
      MARSHALLESE: "MARSHALLESE",
      MAURITANIAN: "MAURITANIAN",
      MAURITIAN: "MAURITIAN",
      MEXICAN: "MEXICAN",
      MICRONESIAN: "MICRONESIAN",
      MOLDOVAN: "MOLDOVAN",
      MONACAN: "MONACAN",
      MONGOLIAN: "MONGOLIAN",
      MONTENEGRIN: "MONTENEGRIN",
      MOROCCAN: "MOROCCAN",
      MOZAMBICAN: "MOZAMBICAN",
      NAMIBIAN: "NAMIBIAN",
      NAURUAN: "NAURUAN",
      NEPALESE: "NEPALESE",
      NEW_ZEALANDER: "NEW_ZEALANDER",
      NICARAGUAN: "NICARAGUAN",
      NIGERIAN: "NIGERIAN",
      NIGERIEN: "NIGERIEN",
      NORTH_KOREAN: "NORTH_KOREAN",
      NORWEGIAN: "NORWEGIAN",
      OMANI: "OMANI",
      PAKISTANI: "PAKISTANI",
      PALAUAN: "PALAUAN",
      PALESTINIAN: "PALESTINIAN",
      PANAMANIAN: "PANAMANIAN",
      PAPUA_NEW_GUINEAN: "PAPUA_NEW_GUINEAN",
      PARAGUAYAN: "PARAGUAYAN",
      PERUVIAN: "PERUVIAN",
      POLISH: "POLISH",
      PORTUGUESE: "PORTUGUESE",
      QATARI: "QATARI",
      ROMANIAN: "ROMANIAN",
      RUSSIAN: "RUSSIAN",
      RWANDAN: "RWANDAN",
      SAINT_KITTS_AND_NEVIS: "SAINT_KITTS_AND_NEVIS",
      SAINT_LUCIAN: "SAINT_LUCIAN",
      SAINT_VINCENTIAN: "SAINT_VINCENTIAN",
      SAMOAN: "SAMOAN",
      SAN_MARINESE: "SAN_MARINESE",
      SAO_TOMEAN: "SAO_TOMEAN",
      SAUDI: "SAUDI",
      SCOTTISH: "SCOTTISH",
      SENEGALESE: "SENEGALESE",
      SERBIAN: "SERBIAN",
      SEYCHELLOIS: "SEYCHELLOIS",
      SIERRA_LEONEAN: "SIERRA_LEONEAN",
      SINGAPOREAN: "SINGAPOREAN",
      SLOVAK: "SLOVAK",
      SLOVENIAN: "SLOVENIAN",
      SOLOMON_ISLANDER: "SOLOMON_ISLANDER",
      SOMALI: "SOMALI",
      SOUTH_AFRICAN: "SOUTH_AFRICAN",
      SOUTH_KOREAN: "SOUTH_KOREAN",
      SOUTH_SUDANESE: "SOUTH_SUDANESE",
      SPANISH: "SPANISH",
      SRI_LANKAN: "SRI_LANKAN",
      SUDANESE: "SUDANESE",
      SURINAMER: "SURINAMER",
      SWAZI: "SWAZI",
      SWEDISH: "SWEDISH",
      SWISS: "SWISS",
      SYRIAN: "SYRIAN",
      TAIWANESE: "TAIWANESE",
      TAJIK: "TAJIK",
      TANZANIAN: "TANZANIAN",
      THAI: "THAI",
      TOGOLESE: "TOGOLESE",
      TONGAN: "TONGAN",
      TRINIDADIAN: "TRINIDADIAN",
      TUNISIAN: "TUNISIAN",
      TURKISH: "TURKISH",
      TURKMEN: "TURKMEN",
      TUVALUAN: "TUVALUAN",
      UGANDAN: "UGANDAN",
      UKRAINIAN: "UKRAINIAN",
      URUGUAYAN: "URUGUAYAN",
      UZBEK: "UZBEK",
      VANUATUAN: "VANUATUAN",
      VATICAN: "VATICAN",
      VENEZUELAN: "VENEZUELAN",
      VIETNAMESE: "VIETNAMESE",
      WELSH: "WELSH",
      YEMENI: "YEMENI",
      ZAMBIAN: "ZAMBIAN",
      ZIMBABWEAN: "ZIMBABWEAN"
    };
    var nationalityTypes = Object.values(NATIONALITIES3);
    var OWNERSHIP_TYPES4 = {
      OWN: "OWN",
      THIRD_PARTY: "THIRD_PARTY"
    };
    var ownershipTypes = Object.values(OWNERSHIP_TYPES4);
    var PROFIT_TYPES3 = {
      REGISTERED: "REGISTERED",
      NOT_REGISTERED: "NOT_REGISTERED",
      EXEMPT: "EXEMPT"
    };
    var profitTypes = Object.values(PROFIT_TYPES3);
    var POWER_OF_ATTORNEY_EXCHANGES2 = {
      GRAIN_EXCHANGE_BUENOS_AIRES: "GRAIN_EXCHANGE_BUENOS_AIRES",
      GRAIN_EXCHANGE_BAHIA_BLANCA: "GRAIN_EXCHANGE_BAHIA_BLANCA",
      GRAIN_EXCHANGE_ENTRE_RIOS: "GRAIN_EXCHANGE_ENTRE_RIOS",
      GRAIN_EXCHANGE_CORDOBA: "GRAIN_EXCHANGE_CORDOBA",
      GRAIN_EXCHANGE_CHACO: "GRAIN_EXCHANGE_CHACO",
      STOCK_EXCHANGE_ROSARIO: "STOCK_EXCHANGE_ROSARIO",
      STOCK_EXCHANGE_SANTA_FE: "STOCK_EXCHANGE_SANTA_FE"
    };
    var powerOfAttorneyExchanges = Object.values(
      POWER_OF_ATTORNEY_EXCHANGES2
    );
    var PRODUCTS3 = {
      COTTON: "COTTON",
      RICE: "RICE",
      BARLEY: "BARLEY",
      SUNFLOWER: "SUNFLOWER",
      CORN: "CORN",
      PEANUTS: "PEANUTS",
      SOY: "SOY",
      SORGHUM: "SORGHUM",
      WHEAT: "WHEAT",
      OTHER: "OTHER"
    };
    var products = Object.values(PRODUCTS3);
    var PROVINCES3 = {
      BUENOS_AIRES: "BUENOS_AIRES",
      CAPITAL_FEDERAL: "CAPITAL_FEDERAL",
      CATAMARCA: "CATAMARCA",
      CHACO: "CHACO",
      CHUBUT: "CHUBUT",
      CORDOBA: "CORDOBA",
      CORRIENTES: "CORRIENTES",
      ENTRE_RIOS: "ENTRE_RIOS",
      FORMOSA: "FORMOSA",
      JUJUY: "JUJUY",
      LA_PAMPA: "LA_PAMPA",
      LA_RIOJA: "LA_RIOJA",
      MENDOZA: "MENDOZA",
      MISIONES: "MISIONES",
      NEUQUEN: "NEUQUEN",
      RIO_NEGRO: "RIO_NEGRO",
      SALTA: "SALTA",
      SAN_JUAN: "SAN_JUAN",
      SAN_LUIS: "SAN_LUIS",
      SANTA_CRUZ: "SANTA_CRUZ",
      SANTA_FE: "SANTA_FE",
      SANTIAGO_DEL_ESTERO: "SANTIAGO_DEL_ESTERO",
      TIERRA_DEL_FUEGO: "TIERRA_DEL_FUEGO",
      TUCUMAN: "TUCUMAN"
    };
    var provinces = Object.values(PROVINCES3);
    var PLEDGE_CROP_CLASSES2 = {
      FIXED: "FIXED",
      FLOATING: "FLOATING"
    };
    var pledgeCropClasses = Object.values(PLEDGE_CROP_CLASSES2);
    var PLEDGE_CROP_DEGREES2 = {
      FIRST_DEGREE: "FIRST_DEGREE"
    };
    var pledgeCropDegreees = Object.values(PLEDGE_CROP_DEGREES2);
    var PLEDGE_STATUSES2 = {
      PENDING_DEBTOR_LOAD: "PENDING_DEBTOR_LOAD",
      PENDING_BOLSA_LOAD: "PENDING_BOLSA_LOAD",
      PENDING_CREDITOR_LOAD: "PENDING_CREDITOR_LOAD",
      PENDING_BOLSA_FARM_LOAD: "PENDING_BOLSA_FARM_LOAD",
      PENDING_DEBTOR_DOCUMENTATION_LOAD: "PENDING_DEBTOR_DOCUMENTATION_LOAD",
      PENDING_BOLSA_APPROVAL: "PENDING_BOLSA_APPROVAL",
      PENDING_CREDITOR_APPROVAL: "PENDING_CREDITOR_APPROVAL",
      PENDING_REGISTRATION: "PENDING_REGISTRATION",
      PENDING_REGISTRATION_BLOCKCHAIN: "PENDING_REGISTRATION_BLOCKCHAIN",
      REGISTERED: "REGISTERED",
      PENDING_RELEASE: "PENDING_RELEASE",
      RELEASED: "RELEASED",
      REJECTED: "REJECTED"
    };
    var pledgeStatuses = Object.values(PLEDGE_STATUSES2);
    var PLEDGE_SECTION_STATUSES = {
      PENDING_DEBTOR_LOAD: "PENDING_DEBTOR_LOAD",
      PENDING_BOLSA_LOAD: "PENDING_BOLSA_LOAD",
      PENDING_CREDITOR_LOAD: "PENDING_CREDITOR_LOAD",
      PENDING_BOLSA_APPROVAL: "PENDING_BOLSA_APPROVAL",
      PENDING_CREDITOR_APPROVAL: "PENDING_CREDITOR_APPROVAL",
      APPROVED: "APPROVED"
    };
    var pledgeSectionStatuses = Object.values(PLEDGE_SECTION_STATUSES);
    var PLEDGE_SECTIONS = {
      FARM_INFORMATION: "FARM_INFORMATION",
      DEBTOR_INFORMATION: "DEBTOR_INFORMATION",
      CREDITOR_INFORMATION: "CREDITOR_INFORMATION",
      DOCUMENTATION: "DOCUMENTATION",
      PLEDGE_INFORMATION: "PLEDGE_INFORMATION",
      INSURANCE: "INSURANCE"
    };
    var pledgeSections = Object.values(PLEDGE_SECTIONS);
    var QUERY_STATUSES = {
      IN_PROGRESS: "IN_PROGRESS",
      REJECTED: "REJECTED",
      APPROVED: "APPROVED"
    };
    var queryStatuses = Object.values(QUERY_STATUSES);
    var REPRESENTATIVE_POSITIONS4 = {
      PRESIDENT: "PRESIDENT",
      PROXY: "PROXY",
      INCUMBENT: "INCUMBENT",
      MANAGING_PARTNER: "MANAGING_PARTNER",
      OTHER: "OTHER"
    };
    var representativePositions = Object.values(REPRESENTATIVE_POSITIONS4);
    var RUCA_STATUSES3 = {
      CURRENT: "CURRENT",
      NOT_CURRENT: "NOT_CURRENT"
    };
    var rucaStatuses = Object.values(RUCA_STATUSES3);
    var RUCA_NOT_CURRENT_WARNING = {
      CLIENT_DOSSIER_REMAINS_ACTIVE: "CLIENT_DOSSIER_REMAINS_ACTIVE",
      CLIENT_DOSSIER_REMAINS_EXPIRED: "CLIENT_DOSSIER_REMAINS_EXPIRED",
      VIEWER_DOSSIER_REMAINS_ACTIVE: "VIEWER_DOSSIER_REMAINS_ACTIVE",
      VIEWER_DOSSIER_REMAINS_EXPIRED: "VIEWER_DOSSIER_REMAINS_EXPIRED"
    };
    var rucaNotCurrentWarnings = Object.values(RUCA_NOT_CURRENT_WARNING);
    var SIGNATURE_LEVELS2 = {
      ZERO: "ZERO",
      ONE: "ONE",
      TWO: "TWO",
      THREE: "THREE",
      NINE: "NINE"
    };
    var signatureLevels = Object.values(SIGNATURE_LEVELS2);
    var SISA_ACTIVITIES2 = {
      PRODUCER: "PRODUCER",
      BROKER: "BROKER",
      FUTURES_GRAIN_MARKET: "FUTURES_GRAIN_MARKET",
      OPERATOR_WITH_A_PLANT: "OPERATOR_WITH_A_PLANT",
      OPERATOR_WITHOUT_A_PLANT: "OPERATOR_WITHOUT_A_PLANT",
      BARTERER: "BARTERER"
    };
    var sisaActivities = Object.values(SISA_ACTIVITIES2);
    var SISA_SCORINGS2 = {
      SITUATION_1: "SITUATION_1",
      SITUATION_2: "SITUATION_2",
      SITUATION_3: "SITUATION_3"
    };
    var sisaScorings = Object.values(SISA_SCORINGS2);
    var SEARCH_DIGITAL_DOSSIER_STATUS = {
      PENDING: "PENDING",
      AVAILABLE: "AVAILABLE"
    };
    var searchDigitalDossierStatuses = Object.values(
      SEARCH_DIGITAL_DOSSIER_STATUS
    );
    var SEARCH_DIGITAL_DOSSIER_ACTIONS = {
      VIEW: "VIEW",
      REQUEST_ACCESS: "REQUEST_ACCESS"
    };
    var searchDigitalDossierActions = Object.values(
      SEARCH_DIGITAL_DOSSIER_ACTIONS
    );
    var USER_COMPANY_STATUSES2 = {
      ACTIVE: "ACTIVE",
      INACTIVE: "INACTIVE"
    };
    var userCompanyStatuses = Object.values(USER_COMPANY_STATUSES2);
    var USER_ROLES3 = {
      CLIENT: "CLIENT"
    };
    var userRoles = Object.values(USER_ROLES3);
    var USER_STATUSES3 = {
      ACTIVE: "ACTIVE",
      INACTIVE: "INACTIVE"
    };
    var userStatuses = Object.values(USER_STATUSES3);
    var USER_TYPES = {
      EXPLORER: "EXPLORER",
      BACKOFFICE: "BACKOFFICE"
    };
    var userTypes = Object.values(USER_TYPES);
    var VALIDATION_STATUSES3 = {
      INCOMPLETE: "INCOMPLETE",
      PENDING_APPROVAL: "PENDING_APPROVAL",
      PENDING_CHANGE_REQUEST: "PENDING_CHANGE_REQUEST",
      REJECTED: "REJECTED",
      APPROVED: "APPROVED"
    };
    var validationStatuses = Object.values(VALIDATION_STATUSES3);
    var YES_NO_OPTIONS6 = {
      YES: "YES",
      NO: "NO"
    };
    var yesNoOptions = Object.values(YES_NO_OPTIONS6);
    var ERROR_CODES = {
      // 400
      VALIDATION_ERROR: "VALIDATION_ERROR",
      CANNOT_SHARE_CERTIFICATES_FROM_ANOTHER_COMPANY: "CANNOT_SHARE_CERTIFICATES_FROM_ANOTHER_COMPANY",
      CANNOT_SHARE_CERTIFICATES_WITH_YOURSELF: "CANNOT_SHARE_CERTIFICATES_WITH_YOURSELF",
      CANNOT_APPROVE_FACILITY_WITHOUT_AFFIDAVIT: "CANNOT_APPROVE_FACILITY_WITHOUT_AFFIDAVIT",
      // 401
      MISSING_CREDENTIALS: "MISSING_CREDENTIALS",
      INVALID_TOKEN: "INVALID_TOKEN",
      // 403
      FORBIDDEN_RESOURCE: "FORBIDDEN_RESOURCE",
      // 404
      RECORD_NOT_FOUND: "RECORD_NOT_FOUND",
      // 409
      EMAIL_ALREADY_EXISTS: "EMAIL_ALREADY_EXISTS",
      FISCAL_ID_IN_USE: "FISCAL_ID_IN_USE",
      DUPLICATED_ENTITY: "DUPLICATED_ENTITY",
      EMPTY_FILE: "EMPTY_FILE",
      USER_ALREADY_EXISTS: "USER_ALREADY_EXISTS",
      CUIT_MUST_BE_11_DIGITS: "CUIT_MUST_BE_11_DIGITS",
      CUIT_INVALID: "CUIT_INVALID",
      CUIT_NOT_FOUND_IN_AFIP: "CUIT_NOT_FOUND_IN_AFIP",
      COMPANY_ALREADY_EXISTS: "COMPANY_ALREADY_EXISTS",
      SNAPSHOT_ALREADY_REJECTED: "SNAPSHOT_ALREADY_REJECTED",
      SNAPSHOT_MUST_BE_PENDING_APPROVAL: "SNAPSHOT_MUST_BE_PENDING_APPROVAL",
      SNAPSHOT_PREVIOUSLY_REJECTED_OR_APPROVED: "SNAPSHOT_PREVIOUSLY_REJECTED_OR_APPROVED",
      SNAPSHOT_NON_ACTIVE: "SNAPSHOT_NON_ACTIVE",
      SNAPSHOT_WITH_MISSING_INFORMATION: "SNAPSHOT_WITH_MISSING_INFORMATION",
      COMPANY_MISSING_A_CERTIFIED_DIGITAL_DOSSIER: "COMPANY_MISSING_A_CERTIFIED_DIGITAL_DOSSIER",
      COMPANY_DOES_NOT_HAVE_AVAILABLE_QUERIES: "COMPANY_DOES_NOT_HAVE_AVAILABLE_QUERIES",
      SIGNUP_REQUEST_ALREADY_REJECTED: "SIGNUP_REQUEST_ALREADY_REJECTED",
      SIGNUP_REQUEST_ALREADY_APPROVED: "SIGNUP_REQUEST_ALREADY_APPROVED",
      SIGNUP_REQUEST_NOT_IN_A_PENDING_APPROVAL_STATUS: "SIGNUP_REQUEST_NOT_IN_A_PENDING_APPROVAL_STATUS",
      SIGNUP_REQUEST_NOT_IN_A_PENDING_CHANGE_REQUEST_STATUS: "SIGNUP_REQUEST_NOT_IN_A_PENDING_CHANGE_REQUEST_STATUS",
      SNAPSHOT_ALREADY_APPROVED: "SNAPSHOT_ALREADY_APPROVED",
      // 422
      MALFORMED_REQUEST: "MALFORMED_REQUEST",
      PROCESSING_ERROR: "PROCESSING_ERROR",
      NOT_YET_SUPPORTED: "NOT_YET_SUPPORTED",
      CERTIFICATE_REQUEST_ALREADY_IN_PROGRESS: "CERTIFICATE_REQUEST_ALREADY_IN_PROGRESS",
      BRUTE_INCOME_LOCAL_JURISDICTION_MUST_HAVE_SINGLE_JURISDICTION: "BRUTE_INCOME_LOCAL_JURISDICTION_MUST_HAVE_SINGLE_JURISDICTION",
      BRUTE_INCOME_MULTILATERAL_AGREEMENT_MUST_HAVE_AT_LEAST_ONE_JURISDICTION: "BRUTE_INCOME_MULTILATERAL_AGREEMENT_MUST_HAVE_AT_LEAST_ONE_JURISDICTION",
      BRUTE_INCOME_EXEMPT_MUST_NOT_HAVE_JURISDICTIONS: "BRUTE_INCOME_EXEMPT_MUST_NOT_HAVE_JURISDICTIONS",
      UPDATES_NOT_TRIGGERED_CHANGES: "UPDATES_NOT_TRIGGERED_CHANGES",
      CROP_PLEDGE_NO_DIGITAL_DOSSIER: "CROP_PLEDGE_NO_DIGITAL_DOSSIER",
      CROP_PLEDGE_NO_COMPANY_CONTACT_INFORMATION: "CROP_PLEDGE_NO_COMPANY_CONTACT_INFORMATION",
      CROP_PLEDGE_COMPANY_IS_NOT_PRODUCER: "CROP_PLEDGE_COMPANY_IS_NOT_PRODUCER",
      CROP_PLEDGE_NO_PHONE_NUMBER: "CROP_PLEDGE_NO_PHONE_NUMBER",
      CROP_PLEDGE_NO_EMAIL: "CROP_PLEDGE_NO_EMAIL",
      CROP_PLEDGE_NO_CP: "CROP_PLEDGE_NO_CP",
      CROP_PLEDGE_NO_INCUMBENT: "CROP_PLEDGE_NO_INCUMBENT",
      CROP_PLEDGE_CANT_USE_OWN_COMPANY: "CROP_PLEDGE_CANT_USE_OWN_COMPANY",
      CROP_PLEDGE_COMPANY_NOT_FOUND: "CROP_PLEDGE_COMPANY_NOT_FOUND",
      CROP_PLEDGE_CREDITOR_INFORMATION_NOT_FOUND: "CROP_PLEDGE_CREDITOR_INFORMATION_NOT_FOUND",
      CROP_PLEDGE_FARM_INFORMATION_NOT_FOUND: "CROP_PLEDGE_FARM_INFORMATION_NOT_FOUND",
      CROP_PLEDGE_USER_IS_NOT_CREDITOR: "CROP_PLEDGE_USER_IS_NOT_CREDITOR",
      CROP_PLEDGE_NOT_IN_CREDITOR_APPROVAL_STATUS: "CROP_PLEDGE_NOT_IN_CREDITOR_APPROVAL_STATUS",
      CROP_PLEDGE_SECTIONS_NOT_IN_APPROVED_STATUS: "CROP_PLEDGE_SECTIONS_NOT_IN_APPROVED_STATUS",
      CROP_PLEDGE_INVALID_STAGE: "CROP_PLEDGE_INVALID_STAGE",
      CROP_PLEDGE_INVALID_CREDITOR_SELECTION: "CROP_PLEDGE_INVALID_CREDITOR_SELECTION",
      // 500
      INTERNAL_SERVER_ERROR: "INTERNAL_SERVER_ERROR",
      ERROR_SENDING_EMAIL: "ERROR_SENDING_EMAIL",
      ERROR_UPLOADING_FILE: "ERROR_UPLOADING_FILE",
      ERROR_DELETING_FILE: "ERROR_DELETING_FILE",
      ERROR_FETCHING_FILE: "ERROR_FETCHING_FILE",
      ERR_NETWORK: "ERR_NETWORK"
    };
  }
});

// src/index.ts
var src_exports = {};
__export(src_exports, {
  CertificateRequestsSortBy: () => CertificateRequestsSortBy,
  CertificateShareRequestsSortBy: () => CertificateShareRequestsSortBy,
  CertificateViewersSortBy: () => CertificateViewersSortBy,
  SortOrder: () => SortOrder,
  TRANSACTION_STATUS: () => TRANSACTION_STATUS,
  getBackofficeRequestChangesDigitalDossierDto: () => getBackofficeRequestChangesDigitalDossierDto,
  getBackofficeUpdateCropPledgeCreditorInformationDto: () => getBackofficeUpdateCropPledgeCreditorInformationDto,
  getBackofficeUpdateDigitalDossierBankAccountDto: () => getBackofficeUpdateDigitalDossierBankAccountDto,
  getBackofficeUpdateDigitalDossierBankingInformationDto: () => getBackofficeUpdateDigitalDossierBankingInformationDto,
  getBackofficeUpdateDigitalDossierGeneralInformationDto: () => getBackofficeUpdateDigitalDossierGeneralInformationDto,
  getBackofficeUpdateDigitalDossierTaxInformationDto: () => getBackofficeUpdateDigitalDossierTaxInformationDto,
  getBackofficeUpsertCropPledgeDocumentationDto: () => getBackofficeUpsertCropPledgeDocumentationDto,
  getBackofficeUpsertCropPledgeFarmInformationDto: () => getBackofficeUpsertCropPledgeFarmInformationDto,
  getBackofficeUpsertCropPledgeInformationDto: () => getBackofficeUpsertCropPledgeInformationDto,
  getBackofficeUpsertCropPledgeInsuranceInformationDto: () => getBackofficeUpsertCropPledgeInsuranceInformationDto,
  getBackofficeUpsertCropPledgeLotAffidavitDto: () => getBackofficeUpsertCropPledgeLotAffidavitDto,
  getBackofficeUpsertCropPledgeLotInformationDto: () => getBackofficeUpsertCropPledgeLotInformationDto,
  getBackofficeUpsertDigitalDossierFormsAndDocsInformationDto: () => getBackofficeUpsertDigitalDossierFormsAndDocsInformationDto,
  getBackofficeUpsertDigitalDossierLegalRepresentantDto: () => getBackofficeUpsertDigitalDossierLegalRepresentantDto,
  getBackofficeUpsertDigitalDossierLegalRepresentantInformationDto: () => getBackofficeUpsertDigitalDossierLegalRepresentantInformationDto,
  getBackofficeUpsertDigitalDossierRepresentantCurrencyCapDto: () => getBackofficeUpsertDigitalDossierRepresentantCurrencyCapDto,
  getBackofficeUpsertDigitalDossierRepresentantProductCapDto: () => getBackofficeUpsertDigitalDossierRepresentantProductCapDto,
  getBackofficeUpsertProductiveFacilityDto: () => getBackofficeUpsertProductiveFacilityDto,
  getBackofficeUpsertStorageFacilityDto: () => getBackofficeUpsertStorageFacilityDto,
  getChangeRequestSignupDto: () => getChangeRequestSignupDto,
  getChangeRequestUpdateLegalRepDocumentDto: () => getChangeRequestUpdateLegalRepDocumentDto,
  getChangeRequestUpdateLegalRepDto: () => getChangeRequestUpdateLegalRepDto,
  getCommonSetCropPledgeCreditorDto: () => getCommonSetCropPledgeCreditorDto,
  getCommonUpdateCropPledgeCreditorInformationDto: () => getCommonUpdateCropPledgeCreditorInformationDto,
  getCommonUpdateCropPledgeDebtorInformationDto: () => getCommonUpdateCropPledgeDebtorInformationDto,
  getCommonUpsertCropPledgeFarmDocumentationDto: () => getCommonUpsertCropPledgeFarmDocumentationDto,
  getCommonUpsertCropPledgeFarmInformationDto: () => getCommonUpsertCropPledgeFarmInformationDto,
  getCommonUpsertCropPledgeLotAffidavitDto: () => getCommonUpsertCropPledgeLotAffidavitDto,
  getCommonUpsertCropPledgeLotInformationDto: () => getCommonUpsertCropPledgeLotInformationDto,
  getCommonUpsertProductiveAffidavitDto: () => getCommonUpsertProductiveAffidavitDto,
  getCommonUpsertProductiveFacilityDto: () => getCommonUpsertProductiveFacilityDto,
  getCommonUpsertStorageAffidavitDto: () => getCommonUpsertStorageAffidavitDto,
  getCommonUpsertStorageFacilityDto: () => getCommonUpsertStorageFacilityDto,
  getCreateAdminDto: () => getCreateAdminDto,
  getCreateBase64DocumentDto: () => getCreateBase64DocumentDto,
  getCreateCompanyDocumentDto: () => getCreateCompanyDocumentDto,
  getCreateCompanyDto: () => getCreateCompanyDto,
  getCreateCompanyQueriesLoadHistoryDto: () => getCreateCompanyQueriesLoadHistoryDto,
  getCreateLegalRepresentativeDto: () => getCreateLegalRepresentativeDto,
  getCreateSignupDto: () => getCreateSignupDto,
  getCreateUserCompanyDto: () => getCreateUserCompanyDto,
  getCreateUserDto: () => getCreateUserDto,
  getDigitalDossiersDto: () => getDigitalDossiersDto,
  getExplorerCreateAccessRequestDto: () => getExplorerCreateAccessRequestDto,
  getExplorerForwardSignUpDocumentDto: () => getExplorerForwardSignUpDocumentDto,
  getExplorerRejectCropPledgeDto: () => getExplorerRejectCropPledgeDto,
  getExplorerSearchDossierDto: () => getExplorerSearchDossierDto,
  getExplorerUpdateAccessRequestDto: () => getExplorerUpdateAccessRequestDto,
  getExplorerUpdateDigitalDossierFormDocsDto: () => getExplorerUpdateDigitalDossierFormDocsDto,
  getExplorerUpdateDigitalDossierGeneralInformationDto: () => getExplorerUpdateDigitalDossierGeneralInformationDto,
  getExplorerUpdateDigitalDossierLegalRepresentativeInformationDto: () => getExplorerUpdateDigitalDossierLegalRepresentativeInformationDto,
  getExplorerUpdateDigitalDossierTaxInformationDto: () => getExplorerUpdateDigitalDossierTaxInformationDto,
  getExplorerUpdateLegalRepresentativeDto: () => getExplorerUpdateLegalRepresentativeDto,
  getExplorerUpdateSignupDto: () => getExplorerUpdateSignupDto,
  getExplorerUpsertCropPledgeDocumentationDto: () => getExplorerUpsertCropPledgeDocumentationDto,
  getExplorerUpsertCropPledgeFarmDocumentationDto: () => getExplorerUpsertCropPledgeFarmDocumentationDto,
  getExplorerUpsertCropPledgeLFarmInformationDto: () => getExplorerUpsertCropPledgeLFarmInformationDto,
  getExplorerUpsertCropPledgeLotAffidavitDto: () => getExplorerUpsertCropPledgeLotAffidavitDto,
  getExplorerUpsertCropPledgeLotInformationDto: () => getExplorerUpsertCropPledgeLotInformationDto,
  getExplorerUpsertDigitalDossierBankAccountDto: () => getExplorerUpsertDigitalDossierBankAccountDto,
  getExplorerUpsertDigitalDossierBankingInformationDto: () => getExplorerUpsertDigitalDossierBankingInformationDto,
  getExplorerUpsertDigitalDossierFormsAndDocsInformationDto: () => getExplorerUpsertDigitalDossierFormsAndDocsInformationDto,
  getExplorerUpsertDigitalDossierLegalRepresentantDto: () => getExplorerUpsertDigitalDossierLegalRepresentantDto,
  getExplorerUpsertDigitalDossierLegalRepresentantInformationDto: () => getExplorerUpsertDigitalDossierLegalRepresentantInformationDto,
  getOptionalUpsertBase64ExtendedDocumentDto: () => getOptionalUpsertBase64ExtendedDocumentDto,
  getPaginatedCropPledgesDto: () => getPaginatedCropPledgesDto,
  getPaginatedSearchDto: () => getPaginatedSearchDto,
  getReceivedAccessRequestsDto: () => getReceivedAccessRequestsDto,
  getRejectSignupRequestDto: () => getRejectSignupRequestDto,
  getSentAccessRequestsDto: () => getSentAccessRequestsDto,
  getSignupRequestAdminAvailabilityDto: () => getSignupRequestAdminAvailabilityDto,
  getSignupRequestsDto: () => getSignupRequestsDto,
  getUpdateAdminDto: () => getUpdateAdminDto,
  getUpdateCompanyDocumentDto: () => getUpdateCompanyDocumentDto,
  getUpdateCompanyDto: () => getUpdateCompanyDto,
  getUpdateSignupLegalRepresentativeDto: () => getUpdateSignupLegalRepresentativeDto,
  getUpdateSignupRequestDto: () => getUpdateSignupRequestDto,
  getUpdateSignupUserDto: () => getUpdateSignupUserDto,
  getUpdateUserDto: () => getUpdateUserDto,
  getUpdateUserProfileDto: () => getUpdateUserProfileDto,
  getUpsertBackofficeCompanyContactInformationDto: () => getUpsertBackofficeCompanyContactInformationDto,
  getUpsertBackofficeCompanyEquityInformationDto: () => getUpsertBackofficeCompanyEquityInformationDto,
  getUpsertBase64DocumentDto: () => getUpsertBase64DocumentDto,
  getUpsertBase64ExtendedDocumentDto: () => getUpsertBase64ExtendedDocumentDto,
  getUpsertCompanyContactInformationDto: () => getUpsertCompanyContactInformationDto,
  getUpsertCompanyEquityInformationDto: () => getUpsertCompanyEquityInformationDto,
  transactionStatus: () => transactionStatus
});
module.exports = __toCommonJS(src_exports);

// src/dtos/backoffice/admins/create-admin.dto.ts
var import_types = __toESM(require_dist());
var import_class_validator = require("class-validator");
var getCreateAdminDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class CreateAdminDto {
  }
  __decorateClass([
    (0, import_class_validator.IsString)(),
    (0, import_class_validator.MinLength)(2, {
      message: isFrontend ? "errorCode.createAdmin.firstName.minLength" : "At least 2 characters long"
    }),
    ApiProperty({
      description: "User first name: required and must be at least 2 characters long.",
      required: true,
      type: String
    })
  ], CreateAdminDto.prototype, "firstName", 2);
  __decorateClass([
    (0, import_class_validator.IsString)(),
    (0, import_class_validator.MinLength)(2, {
      message: isFrontend ? "errorCode.createAdmin.lastName.minLength" : "At least 2 characters long"
    }),
    ApiProperty({
      description: "User last name: required and must be at least 2 characters long.",
      required: true,
      type: String
    })
  ], CreateAdminDto.prototype, "lastName", 2);
  __decorateClass([
    (0, import_class_validator.IsEmail)(
      {},
      {
        message: isFrontend ? "errorCode.createAdmin.email.isEmail" : "must be a valid email"
      }
    ),
    ApiProperty({
      description: "Admin email: required and must be a valid email.",
      required: true,
      type: String
    })
  ], CreateAdminDto.prototype, "email", 2);
  __decorateClass([
    (0, import_class_validator.IsEnum)(import_types.ADMIN_ROLES, {
      message: isFrontend ? "errorCode.createAdmin.adminRole.isValid" : "A valid admin role is required"
    }),
    ApiProperty({
      enum: import_types.ADMIN_ROLES,
      description: "Admin Role.",
      required: true
    })
  ], CreateAdminDto.prototype, "adminRole", 2);
  return CreateAdminDto;
};

// src/dtos/backoffice/admins/update-admin.dto.ts
var import_types2 = __toESM(require_dist());
var import_class_validator2 = require("class-validator");
var getUpdateAdminDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class UpdateAdminDto {
  }
  __decorateClass([
    (0, import_class_validator2.IsOptional)(),
    (0, import_class_validator2.IsString)(),
    (0, import_class_validator2.MinLength)(2, {
      message: isFrontend ? "errorCode.createAdmin.firstName.minLength" : "At least 2 characters long"
    }),
    ApiProperty({
      description: "Admin first name: required and must be at least 2 characters long.",
      required: false,
      type: String
    })
  ], UpdateAdminDto.prototype, "firstName", 2);
  __decorateClass([
    (0, import_class_validator2.IsOptional)(),
    (0, import_class_validator2.IsString)(),
    (0, import_class_validator2.MinLength)(2, {
      message: isFrontend ? "errorCode.createAdmin.lastName.minLength" : "At least 2 characters long"
    }),
    ApiProperty({
      description: "Admin last name: required and must be at least 2 characters long.",
      required: false,
      type: String
    })
  ], UpdateAdminDto.prototype, "lastName", 2);
  __decorateClass([
    (0, import_class_validator2.IsOptional)(),
    (0, import_class_validator2.IsEnum)(import_types2.ADMIN_ROLES, {
      message: isFrontend ? "a valid admin role is required" : "errorCode.createAdmin.adminRole.isValid"
    }),
    ApiProperty({
      enum: import_types2.ADMIN_ROLES,
      description: "Admin Role.",
      required: false
    })
  ], UpdateAdminDto.prototype, "adminRole", 2);
  __decorateClass([
    (0, import_class_validator2.IsOptional)(),
    (0, import_class_validator2.IsEnum)(import_types2.USER_STATUSES, {
      message: isFrontend ? "errorCode.updateAdmin.status.isValid" : "a valid user status is required"
    }),
    ApiProperty({
      enum: import_types2.USER_STATUSES,
      description: "Admin status.",
      required: false
    })
  ], UpdateAdminDto.prototype, "status", 2);
  return UpdateAdminDto;
};

// src/dtos/backoffice/users/create-user.dto.ts
var import_class_validator3 = require("class-validator");
var getCreateUserDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class CreateUserDto {
  }
  __decorateClass([
    (0, import_class_validator3.IsString)(),
    (0, import_class_validator3.MinLength)(2, {
      message: isFrontend ? "errorCode.createAdmin.firstName.minLength" : "At least 2 characters long"
    }),
    ApiProperty({
      description: "User first name: required and must be at least 2 characters long.",
      type: String
    })
  ], CreateUserDto.prototype, "firstName", 2);
  __decorateClass([
    (0, import_class_validator3.IsString)(),
    (0, import_class_validator3.MinLength)(2, {
      message: isFrontend ? "errorCode.createAdmin.firstName.minLength" : "At least 2 characters long"
    }),
    ApiProperty({
      description: "User last name: required and must be at least 2 characters long.",
      type: String
    })
  ], CreateUserDto.prototype, "lastName", 2);
  __decorateClass([
    (0, import_class_validator3.IsEmail)(
      {},
      {
        message: isFrontend ? "errorCode.createAdmin.email.isEmail" : "Must be a valid email"
      }
    ),
    ApiProperty({
      description: "User email: required and must be a valid email.",
      type: String
    })
  ], CreateUserDto.prototype, "email", 2);
  __decorateClass([
    (0, import_class_validator3.IsString)(),
    (0, import_class_validator3.IsNotEmpty)({
      message: isFrontend ? "errorCode.createUser.fiscalId.notEmpty" : "User fiscal Id is required"
    }),
    ApiProperty({
      description: "User fiscal Id.",
      required: true,
      type: String
    })
  ], CreateUserDto.prototype, "fiscalId", 2);
  __decorateClass([
    (0, import_class_validator3.IsString)(),
    (0, import_class_validator3.IsNotEmpty)({
      message: isFrontend ? "errorCode.createAdmin.authUuid.required" : "User authUuid is required"
    }),
    ApiProperty({
      description: `User's Cognito UUID.`,
      required: true,
      type: String
    })
  ], CreateUserDto.prototype, "authUuid", 2);
  __decorateClass([
    (0, import_class_validator3.IsString)(),
    (0, import_class_validator3.IsNotEmpty)({
      message: isFrontend ? "errorCode.createUser.phoneNumber.isRequired" : "User phone number is required"
    }),
    ApiProperty({
      description: `User's phone number.`,
      required: true,
      type: String
    })
  ], CreateUserDto.prototype, "phoneNumber", 2);
  return CreateUserDto;
};

// src/dtos/backoffice/users/update-user.dto.ts
var import_types3 = __toESM(require_dist());
var import_class_validator4 = require("class-validator");
var getUpdateUserDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class UpdateUserDto {
  }
  __decorateClass([
    (0, import_class_validator4.IsOptional)(),
    (0, import_class_validator4.IsString)(),
    (0, import_class_validator4.MinLength)(2, {
      message: isFrontend ? "errorCode.createAdmin.firstName.minLength" : "At least 2 characters long"
    }),
    ApiProperty({
      description: "User first name: required and must be at least 2 characters long.",
      required: false,
      type: String
    })
  ], UpdateUserDto.prototype, "firstName", 2);
  __decorateClass([
    (0, import_class_validator4.IsString)(),
    (0, import_class_validator4.MinLength)(2, {
      message: isFrontend ? "errorCode.createAdmin.firstName.minLength" : "At least 2 characters long"
    }),
    ApiProperty({
      description: "User last name: required and must be at least 2 characters long.",
      required: false,
      type: String
    })
  ], UpdateUserDto.prototype, "lastName", 2);
  __decorateClass([
    (0, import_class_validator4.IsString)(),
    (0, import_class_validator4.IsNotEmpty)({
      message: isFrontend ? "errorCode.createUser.fiscalId.notEmpty" : "User fiscal Id is required"
    }),
    ApiProperty({
      description: "User fiscal Id.",
      required: false,
      type: String
    })
  ], UpdateUserDto.prototype, "fiscalId", 2);
  __decorateClass([
    (0, import_class_validator4.IsString)(),
    (0, import_class_validator4.IsNotEmpty)({
      message: isFrontend ? "errorCode.createUser.phoneNumber.isRequired" : "User phone number is required"
    }),
    ApiProperty({
      description: `User's phone number.`,
      required: false,
      type: String
    })
  ], UpdateUserDto.prototype, "phoneNumber", 2);
  __decorateClass([
    (0, import_class_validator4.IsOptional)(),
    (0, import_class_validator4.IsEnum)(import_types3.USER_STATUSES, {
      message: isFrontend ? "errorCode.createUser.status.isValid" : "A valid user status is required"
    }),
    ApiProperty({
      enum: import_types3.USER_ROLES,
      description: "User Role.",
      required: false
    })
  ], UpdateUserDto.prototype, "status", 2);
  __decorateClass([
    (0, import_class_validator4.IsOptional)(),
    (0, import_class_validator4.IsBoolean)(),
    ApiProperty({
      description: "User is validated by Backoffice?.",
      required: false,
      type: Boolean
    })
  ], UpdateUserDto.prototype, "validated", 2);
  __decorateClass([
    (0, import_class_validator4.IsOptional)(),
    (0, import_class_validator4.IsString)(),
    (0, import_class_validator4.Length)(1, 200, {
      message: isFrontend ? "errorCode.createCompany.invalidationMessage.length" : "Invalidation message should be between 1 and 200 characters."
    }),
    ApiProperty({
      description: `Backoffice invalidation message.`,
      required: false,
      type: String
    })
  ], UpdateUserDto.prototype, "invalidationMessage", 2);
  return UpdateUserDto;
};

// src/dtos/backoffice/companies/create-company.dto.ts
var import_types4 = __toESM(require_dist());
var import_class_validator5 = require("class-validator");
var getCreateCompanyDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class CreateCompanyDto {
  }
  __decorateClass([
    (0, import_class_validator5.IsString)(),
    (0, import_class_validator5.MinLength)(2, {
      message: isFrontend ? "errorCode.createCompany.name.minLength" : "At least 2 characters long"
    }),
    ApiProperty({
      description: "Company first name: required and must be at least 2 characters long.",
      required: true,
      type: String
    })
  ], CreateCompanyDto.prototype, "name", 2);
  __decorateClass([
    (0, import_class_validator5.IsString)(),
    (0, import_class_validator5.Length)(11, 11, {
      message: isFrontend ? "errorCode.createCompany.fiscalId.minLength" : "Must have 11 Characters"
    }),
    ApiProperty({
      description: "Company fiscal id: required and must be 11 characters long (only numbers).",
      required: true,
      type: String
    })
  ], CreateCompanyDto.prototype, "fiscalId", 2);
  __decorateClass([
    (0, import_class_validator5.IsOptional)(),
    (0, import_class_validator5.IsString)(),
    (0, import_class_validator5.Length)(1, 200, {
      message: isFrontend ? "errorCode.createCompany.ruca.minLength" : "1 to 200 Characters long, only numbers."
    }),
    ApiProperty({
      description: "Company RUCA id: not required and must between 1 to 200 characters long (only numbers).",
      required: false,
      type: String
    })
  ], CreateCompanyDto.prototype, "ruca", 2);
  __decorateClass([
    (0, import_class_validator5.IsOptional)(),
    (0, import_class_validator5.IsBoolean)(),
    ApiProperty({
      description: "Company is present in SISA?",
      required: false,
      type: Boolean
    })
  ], CreateCompanyDto.prototype, "sisa", 2);
  __decorateClass([
    (0, import_class_validator5.IsOptional)(),
    (0, import_class_validator5.IsString)(),
    (0, import_class_validator5.Length)(11, 11, {
      message: isFrontend ? "errorCode.createCompany.renspa.minLength" : "11 Characters long, only numbers."
    }),
    ApiProperty({
      description: "Company renspa id: not required and must be 11 characters long (only numbers).",
      required: true,
      type: String
    })
  ], CreateCompanyDto.prototype, "renspa", 2);
  __decorateClass([
    (0, import_class_validator5.IsOptional)(),
    (0, import_class_validator5.IsEnum)(import_types4.COMPANY_TYPES, {
      message: isFrontend ? "errorCode.createCompany.type.isValid" : "A valid company type is required"
    }),
    ApiProperty({
      enum: import_types4.COMPANY_TYPES,
      description: "Company Type.",
      required: false
    })
  ], CreateCompanyDto.prototype, "companyType", 2);
  __decorateClass([
    (0, import_class_validator5.IsOptional)(),
    (0, import_class_validator5.IsString)(),
    (0, import_class_validator5.Length)(1, 200, {
      message: isFrontend ? "errorCode.createCompany.mainActivity.length" : "1 to 200 Characters long."
    }),
    ApiProperty({
      description: `Company's Main Activity: not required and must between 1 to 200 characters long (only numbers).`,
      required: false,
      type: String
    })
  ], CreateCompanyDto.prototype, "mainActivity", 2);
  __decorateClass([
    (0, import_class_validator5.IsOptional)(),
    (0, import_class_validator5.IsNumber)(),
    (0, import_class_validator5.Length)(10, 10, {
      message: isFrontend ? "errorCode.createCompany.activityStartDate.isValid" : "Must be 10 numbers long."
    }),
    ApiProperty({
      description: `Company's Activity Start Date timestamp in seconds.`,
      required: false,
      type: Number
    })
  ], CreateCompanyDto.prototype, "activityStartDate", 2);
  __decorateClass([
    (0, import_class_validator5.IsOptional)(),
    (0, import_class_validator5.IsNumber)(),
    (0, import_class_validator5.Length)(10, 10, {
      message: isFrontend ? "errorCode.createCompany.activityStartDate.isValid" : "Must be 10 numbers long."
    }),
    ApiProperty({
      description: `Company's Activity End Date timestamp in seconds.`,
      required: false,
      type: Number
    })
  ], CreateCompanyDto.prototype, "activityEndDate", 2);
  return CreateCompanyDto;
};

// src/dtos/backoffice/companies/update-company.dto.ts
var import_types5 = __toESM(require_dist());
var import_class_validator6 = require("class-validator");
var getUpdateCompanyDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class UpdateCompanyDto {
  }
  __decorateClass([
    (0, import_class_validator6.IsOptional)(),
    (0, import_class_validator6.IsString)(),
    (0, import_class_validator6.MinLength)(2, {
      message: isFrontend ? "errorCode.createCompany.name.minLength" : "At least 2 characters long"
    }),
    ApiProperty({
      description: "Company first name: required and must be at least 2 characters long.",
      required: false,
      type: String
    })
  ], UpdateCompanyDto.prototype, "name", 2);
  __decorateClass([
    (0, import_class_validator6.IsOptional)(),
    (0, import_class_validator6.Length)(11, 11, {
      message: isFrontend ? "errorCode.createCompany.fiscalId.minLength" : "Must have 11 Characters"
    }),
    ApiProperty({
      description: "Company fiscal id: required and must be 11 characters long (only numbers).",
      required: false,
      type: String
    })
  ], UpdateCompanyDto.prototype, "fiscalId", 2);
  __decorateClass([
    (0, import_class_validator6.IsOptional)(),
    (0, import_class_validator6.IsString)(),
    (0, import_class_validator6.Length)(1, 200, {
      message: isFrontend ? "errorCode.createCompany.ruca.minLength" : "1 to 200 Characters long, only numbers."
    }),
    ApiProperty({
      description: "Company RUCA id: not required and must between 1 to 200 characters long (only numbers).",
      required: false,
      type: String
    })
  ], UpdateCompanyDto.prototype, "ruca", 2);
  __decorateClass([
    (0, import_class_validator6.IsOptional)(),
    (0, import_class_validator6.IsBoolean)(),
    ApiProperty({
      description: "Company is present in SISA?",
      required: false,
      type: Boolean
    })
  ], UpdateCompanyDto.prototype, "sisa", 2);
  __decorateClass([
    (0, import_class_validator6.IsOptional)(),
    (0, import_class_validator6.IsString)(),
    (0, import_class_validator6.Length)(11, 11, {
      message: isFrontend ? "errorCode.createCompany.renspa.minLength" : "11 Characters long, only numbers."
    }),
    ApiProperty({
      description: "Company renspa id: not required and must be 11 characters long (only numbers).",
      required: false,
      type: String
    })
  ], UpdateCompanyDto.prototype, "renspa", 2);
  __decorateClass([
    (0, import_class_validator6.IsOptional)(),
    (0, import_class_validator6.IsEnum)(import_types5.COMPANY_TYPES, {
      message: isFrontend ? "errorCode.createCompany.type.isValid" : "A valid company type is required"
    }),
    ApiProperty({
      enum: import_types5.COMPANY_TYPES,
      description: "Company Type.",
      required: false
    })
  ], UpdateCompanyDto.prototype, "companyType", 2);
  __decorateClass([
    (0, import_class_validator6.IsOptional)(),
    (0, import_class_validator6.IsEnum)(import_types5.COMPANY_STATUSES, {
      message: isFrontend ? "errorCode.updateCompany.status.validStatus" : "A valid company status is required"
    }),
    ApiProperty({
      enum: import_types5.COMPANY_STATUSES,
      description: "Company Status.",
      required: false
    })
  ], UpdateCompanyDto.prototype, "status", 2);
  __decorateClass([
    (0, import_class_validator6.IsOptional)(),
    (0, import_class_validator6.IsString)(),
    (0, import_class_validator6.Length)(1, 200, {
      message: isFrontend ? "errorCode.createCompany.mainActivity.length" : "1 to 200 Characters long."
    }),
    ApiProperty({
      description: `Company's Main Activity: not required and must between 1 to 200 characters long (only numbers).`,
      required: false,
      type: String
    })
  ], UpdateCompanyDto.prototype, "mainActivity", 2);
  __decorateClass([
    (0, import_class_validator6.IsOptional)(),
    (0, import_class_validator6.IsNumber)(),
    (0, import_class_validator6.Length)(10, 10, {
      message: isFrontend ? "errorCode.createCompany.activityStartDate.isValid" : "Must be 10 numbers long."
    }),
    ApiProperty({
      description: `Company's Activity Start Date timestamp in seconds.`,
      required: false,
      type: Number
    })
  ], UpdateCompanyDto.prototype, "activityStartDate", 2);
  __decorateClass([
    (0, import_class_validator6.IsOptional)(),
    (0, import_class_validator6.IsNumber)(),
    (0, import_class_validator6.Length)(10, 10, {
      message: isFrontend ? "errorCode.createCompany.activityStartDate.isValid" : "Must be 10 numbers long."
    }),
    ApiProperty({
      description: `Company's Activity End Date timestamp in seconds.`,
      required: false,
      type: Number
    })
  ], UpdateCompanyDto.prototype, "activityEndDate", 2);
  __decorateClass([
    (0, import_class_validator6.IsOptional)(),
    (0, import_class_validator6.IsBoolean)(),
    ApiProperty({
      description: "Company is validated by Backoffice?.",
      required: false,
      type: Boolean
    })
  ], UpdateCompanyDto.prototype, "validated", 2);
  __decorateClass([
    (0, import_class_validator6.IsOptional)(),
    (0, import_class_validator6.IsString)(),
    (0, import_class_validator6.Length)(1, 200, {
      message: isFrontend ? "errorCode.createCompany.invalidationMessage.length" : "Invalidation message should be between 1 and 200 characters."
    }),
    ApiProperty({
      description: `Backoffice invalidation message.`,
      required: false,
      type: String
    })
  ], UpdateCompanyDto.prototype, "invalidationMessage", 2);
  return UpdateCompanyDto;
};

// src/dtos/backoffice/companies/upsert-company-contact-information.dto.ts
var import_class_transformer = require("class-transformer");
var import_class_validator7 = require("class-validator");
var getUpsertBackofficeCompanyContactInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class UpsertBackofficeCompanyContactInformationDto {
  }
  __decorateClass([
    (0, import_class_validator7.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator7.IsString)(),
    ApiProperty({
      description: "Company Street Name.",
      required: true,
      type: String,
      example: "18th Av."
    })
  ], UpsertBackofficeCompanyContactInformationDto.prototype, "street", 2);
  __decorateClass([
    (0, import_class_validator7.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator7.IsNumberString)(
      void 0,
      isFrontend ? { message: "class-validator.isNumber.error" } : void 0
    ),
    ApiProperty({
      description: "Company Street Number.",
      required: true,
      type: String,
      example: "8558"
    })
  ], UpsertBackofficeCompanyContactInformationDto.prototype, "streetNumber", 2);
  __decorateClass([
    (0, import_class_validator7.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator7.IsUUID)(),
    ApiProperty({
      description: "Company Province uuid.",
      required: true,
      type: String,
      example: "456af476-147c-4522-8388-2b0e46f41911"
    })
  ], UpsertBackofficeCompanyContactInformationDto.prototype, "provinceUuid", 2);
  __decorateClass([
    (0, import_class_validator7.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator7.IsUUID)(),
    ApiProperty({
      description: "Company Locality uuid.",
      required: true,
      type: String,
      example: "79c62347-fba7-439f-9dda-26a7b98524c6"
    })
  ], UpsertBackofficeCompanyContactInformationDto.prototype, "localityUuid", 2);
  __decorateClass([
    (0, import_class_validator7.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator7.IsString)(),
    ApiProperty({
      description: "Company Postal Code.",
      required: true,
      type: String,
      example: "11150"
    })
  ], UpsertBackofficeCompanyContactInformationDto.prototype, "postalCode", 2);
  __decorateClass([
    (0, import_class_validator7.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator7.IsNumberString)(),
    ApiProperty({
      description: `User's phone number.`,
      required: true,
      type: String
    })
  ], UpsertBackofficeCompanyContactInformationDto.prototype, "phoneNumber", 2);
  __decorateClass([
    (0, import_class_validator7.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator7.IsEmail)(
      {},
      isFrontend ? { message: "class-validator.email.isEmail" } : void 0
    ),
    ApiProperty({
      description: "User email address.",
      required: true,
      type: String,
      example: "john.doe@mycompany.org"
    })
  ], UpsertBackofficeCompanyContactInformationDto.prototype, "email", 2);
  __decorateClass([
    (0, import_class_transformer.Transform)(({ value }) => Boolean(value) ? value : void 0),
    (0, import_class_validator7.IsUrl)(
      {
        protocols: ["http", "https"],
        require_protocol: false
      },
      {
        message: isFrontend ? "class-validator.url.isURL" : "A valid URL is required"
      }
    ),
    (0, import_class_validator7.IsOptional)(),
    ApiProperty({
      description: "User website.",
      required: false,
      type: String,
      example: "www.google.com"
    })
  ], UpsertBackofficeCompanyContactInformationDto.prototype, "website", 2);
  return UpsertBackofficeCompanyContactInformationDto;
};

// src/common/utils/validate-nested.ts
var import_class_validator8 = require("class-validator");
var import_class_transformer2 = require("class-transformer");

// src/common/utils/apply-decorators.ts
function applyDecorators(...decorators) {
  return (target, propertyKey, descriptor) => {
    decorators = decorators.filter((decorator) => !!decorator);
    for (const decorator of decorators) {
      if (target instanceof Function && !descriptor) {
        decorator(target);
        continue;
      }
      decorator(
        target,
        propertyKey,
        descriptor
      );
    }
  };
}

// src/common/utils/validate-nested.ts
function ValidateNested(Dto, options = {}) {
  const { required = true, isArray: isNestedArray = false } = options;
  const decorators = [];
  if (isNestedArray) {
    decorators.push(
      (0, import_class_validator8.ValidateNested)({ each: true }),
      (0, import_class_transformer2.Type)(() => Dto)
    );
  } else {
    decorators.push(
      (0, import_class_validator8.ValidateNested)(),
      (0, import_class_transformer2.Type)(() => Dto)
    );
  }
  if (required) {
    decorators.push((0, import_class_validator8.IsDefined)());
  }
  return applyDecorators(...decorators);
}

// src/dtos/backoffice/companies/upsert-company-equity-information.dto.ts
var import_class_validator32 = require("class-validator");

// src/dtos/common/documents/create-base64-document.dto.ts
var import_class_validator9 = require("class-validator");
var import_types6 = __toESM(require_dist());
var import_class_transformer3 = require("class-transformer");
var getCreateBase64DocumentDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class CreateBase64DocumentDto {
  }
  __decorateClass([
    (0, import_class_transformer3.Expose)(),
    (0, import_class_validator9.IsString)(),
    (0, import_class_validator9.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "This field is required"
    }),
    ApiProperty({
      description: `S3 Temp file key`,
      type: String,
      example: "temp/file.pdf"
    })
  ], CreateBase64DocumentDto.prototype, "s3TempKey", 2);
  __decorateClass([
    (0, import_class_transformer3.Expose)(),
    (0, import_class_validator9.MinLength)(4),
    (0, import_class_validator9.MaxLength)(200),
    (0, import_class_validator9.IsString)(),
    ApiProperty({
      description: `File name.`,
      type: String,
      example: "my_file.png"
    })
  ], CreateBase64DocumentDto.prototype, "name", 2);
  __decorateClass([
    (0, import_class_transformer3.Expose)(),
    (0, import_class_validator9.IsEnum)(import_types6.FILE_MIME_TYPES, {
      message: "a valid file MIME type is required for file"
    }),
    ApiProperty({
      enum: import_types6.FILE_MIME_TYPES,
      description: "File MIME Type.",
      example: import_types6.FILE_MIME_TYPES.PNG
    })
  ], CreateBase64DocumentDto.prototype, "mimeType", 2);
  return CreateBase64DocumentDto;
};

// src/dtos/common/documents/upsert-base64-document.dto.ts
var import_class_validator10 = require("class-validator");
var import_class_transformer4 = require("class-transformer");
var getUpsertBase64DocumentDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const _CreateBase64DocumentDto = getCreateBase64DocumentDto(ApiPropertySwagger);
  class CreateBase64DocumentDto extends _CreateBase64DocumentDto {
  }
  class UpsertBase64DocumentDto {
  }
  __decorateClass([
    (0, import_class_transformer4.Expose)(),
    (0, import_class_validator10.IsOptional)(),
    (0, import_class_validator10.IsUUID)(),
    ApiProperty({
      description: `Document UUID.`,
      type: String,
      example: "96c9e11d-74aa-4675-b37d-e218ac1ff2ac"
    })
  ], UpsertBase64DocumentDto.prototype, "uuid", 2);
  __decorateClass([
    (0, import_class_transformer4.Expose)(),
    (0, import_class_validator10.IsOptional)(),
    (0, import_class_validator10.IsBoolean)(),
    ApiProperty({
      description: `Boolean that enables to keep the original document, so we avoid uploading a new one.`,
      type: Boolean,
      example: false
    })
  ], UpsertBase64DocumentDto.prototype, "keepOriginal", 2);
  __decorateClass([
    (0, import_class_transformer4.Expose)(),
    ValidateNested(CreateBase64DocumentDto),
    (0, import_class_validator10.IsOptional)(),
    ApiProperty({
      description: "File",
      type: CreateBase64DocumentDto
    })
  ], UpsertBase64DocumentDto.prototype, "file", 2);
  __decorateClass([
    (0, import_class_transformer4.Expose)(),
    (0, import_class_validator10.IsOptional)(),
    (0, import_class_validator10.IsString)(),
    ApiProperty({
      description: `Original filename`,
      type: String,
      example: "FileName.pdf"
    })
  ], UpsertBase64DocumentDto.prototype, "originalName", 2);
  return UpsertBase64DocumentDto;
};

// src/dtos/common/documents/upsert-base64-extended-document.dto.ts
var import_class_validator14 = require("class-validator");
var import_class_transformer5 = require("class-transformer");

// src/dtos/utils/is-unix-timestamp.ts
var import_class_validator11 = require("class-validator");
var IsUnixTimestamp = (validationOptions) => (object, propertyName) => {
  (0, import_class_validator11.registerDecorator)({
    name: "isUnixTimestamp",
    target: object.constructor,
    propertyName,
    options: validationOptions,
    validator: {
      validate(value) {
        if (typeof value !== "number" || !Number.isInteger(value)) {
          return false;
        }
        const date = new Date(value * 1e3);
        return date instanceof Date && !isNaN(date.getTime());
      },
      defaultMessage(args) {
        return `${args.property} must be a valid Unix timestamp in seconds`;
      }
    }
  });
};

// src/dtos/utils/match.ts
var import_class_validator12 = require("class-validator");
function Match(property, validationOptions) {
  return (object, propertyName) => {
    (0, import_class_validator12.registerDecorator)({
      target: object.constructor,
      propertyName,
      options: validationOptions,
      constraints: [property],
      validator: MatchConstraint
    });
  };
}
var MatchConstraint = class {
  validate(value, args) {
    const [relatedPropertyName] = args.constraints;
    const relatedValue = args.object[relatedPropertyName];
    return value === relatedValue;
  }
  defaultMessage(args) {
    const [relatedPropertyName] = args.constraints;
    return `${relatedPropertyName} and ${args.property} don't match`;
  }
};
MatchConstraint = __decorateClass([
  (0, import_class_validator12.ValidatorConstraint)({ name: "Match" })
], MatchConstraint);

// src/dtos/utils/IsNotPastTimestamp.ts
var import_class_validator13 = require("class-validator");
function IsNotPastTimestamp(validationOptions) {
  return function(object, propertyName) {
    (0, import_class_validator13.registerDecorator)({
      name: "isNotPastTimestamp",
      target: object.constructor,
      propertyName,
      options: validationOptions,
      validator: {
        validate(value, args) {
          const currentTimestamp = Math.floor(Date.now() / 1e3);
          return typeof value === "number" && value >= currentTimestamp;
        },
        defaultMessage(args) {
          return `${args.property} must be a timestamp in the future`;
        }
      }
    });
  };
}

// src/dtos/common/documents/upsert-base64-extended-document.dto.ts
var getUpsertBase64ExtendedDocumentDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const _UpsertBase64DocumentDto = getUpsertBase64DocumentDto(ApiPropertySwagger);
  class UpsertBase64DocumentDto extends _UpsertBase64DocumentDto {
  }
  class UpsertBase64ExtendedDocumentDto extends UpsertBase64DocumentDto {
  }
  __decorateClass([
    (0, import_class_validator14.ValidateIf)(
      (document) => !!document.uuid || !!document?.file?.s3TempKey
    ),
    (0, import_class_validator14.IsString)(),
    (0, import_class_validator14.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    ApiProperty({
      description: `Document identifier`,
      type: String,
      required: true,
      example: "A000212412"
    })
  ], UpsertBase64ExtendedDocumentDto.prototype, "bcIdentifier", 2);
  __decorateClass([
    (0, import_class_validator14.ValidateIf)(
      (document) => !!document.uuid || !!document?.file?.s3TempKey
    ),
    (0, import_class_transformer5.Transform)(({ value }) => Number(value)),
    IsUnixTimestamp(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : {
        message: "Must be a valid date"
      }
    ),
    IsNotPastTimestamp(
      isFrontend ? { message: "common.expirationDate.error.dateFromPast" } : {
        message: "The timestamp must be in the future"
      }
    ),
    (0, import_class_validator14.IsNotEmpty)({
      message: isFrontend ? "errorCode.createUser.phoneNumber.isRequired" : "User phone number is required"
    }),
    ApiProperty({
      description: `Document's expiration timestamp in seconds.`,
      required: true,
      type: Number
    })
  ], UpsertBase64ExtendedDocumentDto.prototype, "expirationDate", 2);
  return UpsertBase64ExtendedDocumentDto;
};

// src/dtos/common/documents/optional-upsert-base64-extended-document.dto.ts
var import_class_transformer6 = require("class-transformer");
var import_class_validator15 = require("class-validator");
var getOptionalUpsertBase64ExtendedDocumentDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const _UpsertBase64DocumentDto = getUpsertBase64DocumentDto(ApiPropertySwagger);
  class UpsertBase64DocumentDto extends _UpsertBase64DocumentDto {
  }
  class OptionalUpsertBase64ExtendedDocumentDto extends UpsertBase64DocumentDto {
  }
  __decorateClass([
    (0, import_class_validator15.IsOptional)(),
    (0, import_class_validator15.IsString)(),
    ApiProperty({
      description: `Document identifier`,
      type: String,
      required: false,
      example: "A000212412"
    })
  ], OptionalUpsertBase64ExtendedDocumentDto.prototype, "bcIdentifier", 2);
  __decorateClass([
    (0, import_class_validator15.IsOptional)(),
    (0, import_class_transformer6.Transform)(({ value }) => value ? Number(value) : void 0),
    IsUnixTimestamp(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : {
        message: "Must be a valid date"
      }
    ),
    IsNotPastTimestamp(
      isFrontend ? { message: "common.expirationDate.error.dateFromPast" } : {
        message: "The timestamp must be in the future"
      }
    ),
    ApiProperty({
      description: `Document's expiration timestamp in seconds.`,
      required: false,
      type: Number
    })
  ], OptionalUpsertBase64ExtendedDocumentDto.prototype, "expirationDate", 2);
  return OptionalUpsertBase64ExtendedDocumentDto;
};

// src/dtos/common/productive-facilities/upsert-productive-facility.dto.ts
var import_class_validator16 = require("class-validator");
var import_types7 = __toESM(require_dist());
var import_class_transformer7 = require("class-transformer");

// src/dtos/utils/transformEmptyDocument2Undefined.ts
var import_common_utils = require("@bcba/common-utils");
var transformEmptyDocumentToUndefined = ({
  value
}) => {
  const isArrayOfDocuments = Array.isArray(value);
  if (isArrayOfDocuments) {
    const files = (0, import_common_utils.filterEmptyArrayOfDocumentField)(value);
    if (!files.length) {
      return void 0;
    }
    return files;
  }
  const isEmptySingleFile = (0, import_common_utils.isEmptyDocumentField)(value);
  if (isEmptySingleFile) {
    return void 0;
  }
  return value;
};

// src/dtos/common/productive-facilities/upsert-productive-facility.dto.ts
var getCommonUpsertProductiveFacilityDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const _UpsertBase64DocumentDto = getUpsertBase64DocumentDto(ApiPropertySwagger);
  class UpsertBase64DocumentDto extends _UpsertBase64DocumentDto {
  }
  class CommonUpsertProductiveFacilityDto {
  }
  __decorateClass([
    (0, import_class_validator16.ValidateIf)((o) => o.uuid),
    (0, import_class_validator16.IsUUID)("4"),
    ApiProperty({
      description: `Productive Facility UUID.`,
      type: Number,
      example: "5d681505-4e23-41b1-927a-3e5e4896e36c",
      required: false
    })
  ], CommonUpsertProductiveFacilityDto.prototype, "uuid", 2);
  __decorateClass([
    (0, import_class_validator16.Length)(1, 200, {
      message: isFrontend ? "class-validator.isNotEmpty.error" : "Name must be between 1 and 200 characters"
    }),
    (0, import_class_validator16.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "name is required"
    }),
    ApiProperty({
      description: `Productive Facility name.`,
      type: String,
      example: "Green Acres",
      required: true
    })
  ], CommonUpsertProductiveFacilityDto.prototype, "name", 2);
  __decorateClass([
    (0, import_class_validator16.IsUUID)("4"),
    (0, import_class_validator16.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "provinceUuid is required"
    }),
    ApiProperty({
      description: `Province UUID.`,
      type: Number,
      example: "8542e445-943b-45ce-8473-314afa7c9921",
      required: true
    })
  ], CommonUpsertProductiveFacilityDto.prototype, "provinceUuid", 2);
  __decorateClass([
    (0, import_class_validator16.IsUUID)("4"),
    (0, import_class_validator16.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "localityUuid is required"
    }),
    ApiProperty({
      description: `Locality UUID.`,
      type: Number,
      example: "bc84f6f0-4251-4317-af4e-508d5ab0d3c0",
      required: true
    })
  ], CommonUpsertProductiveFacilityDto.prototype, "localityUuid", 2);
  __decorateClass([
    (0, import_class_validator16.IsEnum)(import_types7.OWNERSHIP_TYPES, {
      message: isFrontend ? "errorCode.createProductiveFacility.ownershipType.isValid" : "A valid ownership type is required"
    }),
    (0, import_class_validator16.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "ownershipType is required"
    }),
    ApiProperty({
      enum: import_types7.OWNERSHIP_TYPES,
      description: "Ownership Type.",
      required: true,
      example: import_types7.OWNERSHIP_TYPES.OWN
    })
  ], CommonUpsertProductiveFacilityDto.prototype, "ownershipType", 2);
  __decorateClass([
    (0, import_class_validator16.IsOptional)(),
    (0, import_class_transformer7.Transform)(transformEmptyDocumentToUndefined),
    ValidateNested(UpsertBase64DocumentDto),
    ApiProperty({
      description: "Geolocation document file to process",
      type: UpsertBase64DocumentDto,
      required: false
    })
  ], CommonUpsertProductiveFacilityDto.prototype, "geolocationDocument", 2);
  return CommonUpsertProductiveFacilityDto;
};

// src/dtos/common/productive-affidavits/upsert-productive-affidavit.dto.ts
var import_class_validator19 = require("class-validator");

// src/common/utils/is-lower-than.ts
var import_class_validator17 = require("class-validator");
function IsLowerThan(property, validationOptions) {
  return function(object, propertyName) {
    (0, import_class_validator17.registerDecorator)({
      name: "isLowerThan",
      target: object.constructor,
      propertyName,
      constraints: [property],
      options: validationOptions,
      validator: {
        validate(value, args) {
          const [relatedPropertyName] = args.constraints;
          const relatedValue = args.object[relatedPropertyName];
          return typeof value === "number" && typeof relatedValue === "number" && value < relatedValue;
        },
        defaultMessage(args) {
          return `${args.property} must be lower than ${args.constraints[0]}`;
        }
      }
    });
  };
}

// src/common/utils/is-bigger-than.ts
var import_class_validator18 = require("class-validator");
function IsBiggerThan(property, validationOptions) {
  return function(object, propertyName) {
    (0, import_class_validator18.registerDecorator)({
      name: "isBiggerThan",
      target: object.constructor,
      propertyName,
      constraints: [property],
      options: validationOptions,
      validator: {
        validate(value, args) {
          const [relatedPropertyName] = args.constraints;
          const relatedValue = args.object[relatedPropertyName];
          return typeof value === "number" && typeof relatedValue === "number" && value > relatedValue;
        }
      }
    });
  };
}

// src/dtos/common/productive-affidavits/upsert-productive-affidavit.dto.ts
var import_types8 = __toESM(require_dist());
var getCommonUpsertProductiveAffidavitDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const startDateOlderThanEndDate = "backoffice.pages.generalInformation.activityStartDate.startDateMustBeOlderThanEndDate";
  const endDateNewerThanEndDate = "backoffice.pages.generalInformation.activityStartDate.startDateMustBeNewerThanEndDate";
  class CommonUpsertProductiveAffidavitDto {
  }
  __decorateClass([
    (0, import_class_validator19.ValidateIf)((o) => o.uuid),
    (0, import_class_validator19.IsUUID)("4"),
    (0, import_class_validator19.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "uuid is required"
    }),
    ApiProperty({
      description: `Productive Affidavit UUID.`,
      type: String,
      example: "5d681505-4e23-41b1-927a-3e5e4896e36c",
      required: false
    })
  ], CommonUpsertProductiveAffidavitDto.prototype, "uuid", 2);
  __decorateClass([
    (0, import_class_validator19.IsUUID)("4"),
    (0, import_class_validator19.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "facilityUuid is required"
    }),
    ApiProperty({
      description: `Productive Facility UUID.`,
      type: Number,
      example: "7h681505-4e23-41b1-927a-3e5e4896e36c",
      required: true
    })
  ], CommonUpsertProductiveAffidavitDto.prototype, "facilityUuid", 2);
  __decorateClass([
    (0, import_class_validator19.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "hectares is required"
    }),
    (0, import_class_validator19.IsNumber)(
      { maxDecimalPlaces: 2 },
      isFrontend ? { message: "common.error.valueMustBeANumber" } : void 0
    ),
    (0, import_class_validator19.Min)(
      0,
      isFrontend ? { message: "common.error.greaterOrEqualThanZero" } : void 0
    ),
    ApiProperty({
      description: `Number of hectares.`,
      type: Number,
      example: 12345.67,
      required: true
    })
  ], CommonUpsertProductiveAffidavitDto.prototype, "hectares", 2);
  __decorateClass([
    (0, import_class_validator19.IsEnum)(import_types8.EXPLOITATION_TYPES, {
      message: isFrontend ? "errorCode.exploitationType.isValid" : "Please select a valid exploitation type"
    }),
    (0, import_class_validator19.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "exploitationType is required"
    }),
    ApiProperty({
      description: `Exploitation Type`,
      type: "enum",
      required: true,
      enum: import_types8.EXPLOITATION_TYPES,
      example: import_types8.EXPLOITATION_TYPES.AGRICULTURAL
    })
  ], CommonUpsertProductiveAffidavitDto.prototype, "exploitationType", 2);
  __decorateClass([
    IsUnixTimestamp({
      message: "errorCode.createCompany.activityStartDate.isValid"
    }),
    IsLowerThan("endDate", {
      message: startDateOlderThanEndDate
    }),
    (0, import_class_validator19.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "startDate is required"
    }),
    ApiProperty({
      description: "Affidavit start date in unix timestamp in seconds",
      type: Number,
      required: true,
      example: 1713967700
    })
  ], CommonUpsertProductiveAffidavitDto.prototype, "startDate", 2);
  __decorateClass([
    IsUnixTimestamp({
      message: "errorCode.createCompany.activityStartDate.isValid"
    }),
    IsBiggerThan("startDate", {
      message: endDateNewerThanEndDate
    }),
    (0, import_class_validator19.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "endDate is required"
    }),
    ApiProperty({
      description: "Company activity end date in unix timestamp in seconds",
      type: Number,
      required: true,
      example: 1713967759
    })
  ], CommonUpsertProductiveAffidavitDto.prototype, "endDate", 2);
  __decorateClass([
    (0, import_class_validator19.Matches)(/^\d{2}\.\d{3}\.\d\.\d{5}\.\d{2}$/, {
      message: isFrontend ? `errorCode.renspa.invalidFormat` : "The RENSPA identifier must follow the format 00.000.0.00000.00"
    }),
    (0, import_class_validator19.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "renspa is required"
    }),
    ApiProperty({
      description: `Identificador RENSPA.`,
      type: String,
      example: "12.345.6.78901.23",
      required: true
    })
  ], CommonUpsertProductiveAffidavitDto.prototype, "renspa", 2);
  __decorateClass([
    (0, import_class_validator19.ValidateIf)((o) => o.renspaIsCurrent !== void 0),
    (0, import_class_validator19.IsBoolean)(),
    ApiProperty({
      description: `RENSPA is current.`,
      type: Boolean,
      example: true,
      required: false
    })
  ], CommonUpsertProductiveAffidavitDto.prototype, "renspaIsCurrent", 2);
  return CommonUpsertProductiveAffidavitDto;
};

// src/dtos/common/storage-facilities/upsert-storage-facility.dto.ts
var import_types9 = __toESM(require_dist());
var import_class_validator20 = require("class-validator");
var getCommonUpsertStorageFacilityDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class CommonUpsertStorageFacilityDto {
  }
  __decorateClass([
    (0, import_class_validator20.ValidateIf)((o) => o.uuid),
    (0, import_class_validator20.IsUUID)("4"),
    ApiProperty({
      description: `Storage Facility UUID.`,
      type: Number,
      example: "5d681505-4e23-41b1-927a-3e5e4896e36c",
      required: false
    })
  ], CommonUpsertStorageFacilityDto.prototype, "uuid", 2);
  __decorateClass([
    (0, import_class_validator20.Length)(1, 200, {
      message: isFrontend ? "errorCode.createCompany.mainActivity.length" : "Identifier must be between 1 and 200 characters"
    }),
    ApiProperty({
      description: `Storage Facility Identifier.`,
      type: String,
      example: "1847632BDD-322-XX0",
      required: true
    })
  ], CommonUpsertStorageFacilityDto.prototype, "identifier", 2);
  __decorateClass([
    (0, import_class_validator20.IsUUID)("4"),
    (0, import_class_validator20.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "provinceUuid is required"
    }),
    ApiProperty({
      description: `Province UUID.`,
      type: Number,
      example: "8542e445-943b-45ce-8473-314afa7c9921",
      required: true
    })
  ], CommonUpsertStorageFacilityDto.prototype, "provinceUuid", 2);
  __decorateClass([
    (0, import_class_validator20.IsUUID)("4"),
    (0, import_class_validator20.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "localityUuid is required"
    }),
    ApiProperty({
      description: `Locality UUID.`,
      type: Number,
      example: "bc84f6f0-4251-4317-af4e-508d5ab0d3c0",
      required: true
    })
  ], CommonUpsertStorageFacilityDto.prototype, "localityUuid", 2);
  __decorateClass([
    (0, import_class_validator20.IsEnum)(import_types9.OWNERSHIP_TYPES, {
      message: isFrontend ? "errorCode.createProductiveFacility.ownershipType.isValid" : "A valid ownership type is required"
    }),
    ApiProperty({
      enum: import_types9.OWNERSHIP_TYPES,
      description: "Ownership Type.",
      required: true,
      example: import_types9.OWNERSHIP_TYPES.OWN
    })
  ], CommonUpsertStorageFacilityDto.prototype, "ownershipType", 2);
  return CommonUpsertStorageFacilityDto;
};

// src/dtos/common/storage-affidavits/upsert-storage-affidavit.dto.ts
var import_class_transformer8 = require("class-transformer");
var import_class_validator21 = require("class-validator");
var import_types10 = __toESM(require_dist());
var getCommonUpsertStorageAffidavitDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const startDateOlderThanEndDate = "backoffice.pages.generalInformation.activityStartDate.startDateMustBeOlderThanEndDate";
  const endDateNewerThanEndDate = "backoffice.pages.generalInformation.activityStartDate.startDateMustBeNewerThanEndDate";
  class CommonUpsertStorageAffidavitDto {
  }
  __decorateClass([
    (0, import_class_validator21.ValidateIf)((o) => o.uuid),
    (0, import_class_validator21.IsUUID)("4"),
    ApiProperty({
      description: `Storage Affidavit UUID.`,
      type: String,
      example: "5d681505-4e23-41b1-927a-3e5e4896e36c",
      required: false
    })
  ], CommonUpsertStorageAffidavitDto.prototype, "uuid", 2);
  __decorateClass([
    (0, import_class_validator21.IsUUID)("4"),
    ApiProperty({
      description: `Storage Facility UUID.`,
      type: Number,
      example: "7h681505-4e23-41b1-927a-3e5e4896e36c",
      required: true
    })
  ], CommonUpsertStorageAffidavitDto.prototype, "facilityUuid", 2);
  __decorateClass([
    (0, import_class_transformer8.Transform)(({ value }) => Number(value)),
    (0, import_class_validator21.IsNumber)(
      { maxDecimalPlaces: 2 },
      isFrontend ? { message: "common.error.valueMustBeANumber" } : void 0
    ),
    (0, import_class_validator21.Min)(
      0,
      isFrontend ? { message: "common.error.greaterOrEqualThanZero" } : void 0
    ),
    ApiProperty({
      description: `Capacity in tons.`,
      type: Number,
      example: 12345.67,
      required: true
    })
  ], CommonUpsertStorageAffidavitDto.prototype, "capacity", 2);
  __decorateClass([
    (0, import_class_transformer8.Transform)(({ value }) => Number(value)),
    IsUnixTimestamp({
      message: "errorCode.createCompany.activityStartDate.isValid"
    }),
    IsLowerThan("endDate", {
      message: startDateOlderThanEndDate
    }),
    ApiProperty({
      description: "Affidavit start date in unix timestamp in seconds",
      type: Number,
      required: true,
      example: 1713967700
    })
  ], CommonUpsertStorageAffidavitDto.prototype, "startDate", 2);
  __decorateClass([
    (0, import_class_transformer8.Transform)(({ value }) => Number(value)),
    IsUnixTimestamp({
      message: "errorCode.createCompany.activityStartDate.isValid"
    }),
    IsBiggerThan("startDate", {
      message: endDateNewerThanEndDate
    }),
    ApiProperty({
      description: "Company activity end date in unix timestamp in seconds",
      type: Number,
      required: true,
      example: 1713967759
    })
  ], CommonUpsertStorageAffidavitDto.prototype, "endDate", 2);
  __decorateClass([
    (0, import_class_validator21.IsOptional)(),
    (0, import_class_validator21.ValidateIf)((o) => o.rucaStatus !== void 0),
    (0, import_class_validator21.IsEnum)(import_types10.RUCA_STATUSES, {
      message: isFrontend ? "errorCode.createCompany.ruca.isValid" : "Must be a valid RUCA Status"
    }),
    ApiProperty({
      enum: import_types10.RUCA_STATUSES,
      description: "RUCA Status.",
      required: false,
      example: import_types10.RUCA_STATUSES.CURRENT
    })
  ], CommonUpsertStorageAffidavitDto.prototype, "rucaStatus", 2);
  __decorateClass([
    (0, import_class_validator21.ValidateIf)((o) => o.observations !== void 0),
    (0, import_class_validator21.IsString)(),
    ApiProperty({
      description: `Observations.`,
      type: String,
      example: "My observations...",
      required: false
    })
  ], CommonUpsertStorageAffidavitDto.prototype, "observations", 2);
  return CommonUpsertStorageAffidavitDto;
};

// src/dtos/common/pagination/paginated-search.ts
var import_class_validator23 = require("class-validator");

// src/dtos/common/pagination/paginate.dto.ts
var import_class_transformer9 = require("class-transformer");
var import_class_validator22 = require("class-validator");
var getPaginateDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  class PaginateDto {
    constructor() {
      this.page = 1;
      this.pageSize = 10;
    }
  }
  __decorateClass([
    (0, import_class_transformer9.Transform)(({ value }) => Number(value)),
    (0, import_class_validator22.IsNumber)(),
    (0, import_class_validator22.IsOptional)(),
    ApiProperty({
      description: "Page number.",
      required: false,
      type: Number
    })
  ], PaginateDto.prototype, "page", 2);
  __decorateClass([
    (0, import_class_transformer9.Transform)(({ value }) => Number(value)),
    (0, import_class_validator22.IsNumber)(),
    (0, import_class_validator22.IsOptional)(),
    ApiProperty({
      description: "Items per page.",
      required: false,
      type: Number
    })
  ], PaginateDto.prototype, "pageSize", 2);
  return PaginateDto;
};

// src/dtos/common/pagination/paginated-search.ts
var getPaginatedSearchDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const _paginatedDto = getPaginateDto(ApiProperty);
  class PaginatedSearchDto extends _paginatedDto {
    constructor() {
      super(...arguments);
      this.search = "";
    }
  }
  __decorateClass([
    (0, import_class_validator23.IsString)(),
    (0, import_class_validator23.IsOptional)(),
    ApiProperty({
      description: "Search value.",
      required: false,
      type: String
    })
  ], PaginatedSearchDto.prototype, "search", 2);
  __decorateClass([
    (0, import_class_validator23.IsObject)(),
    (0, import_class_validator23.IsOptional)(),
    ApiProperty({
      description: "Filter value.",
      required: false,
      type: Object
    })
  ], PaginatedSearchDto.prototype, "filters", 2);
  return PaginatedSearchDto;
};

// src/dtos/common/crop-pledges/get-paginated-crop-pledges.dto.ts
var import_types11 = __toESM(require_dist());
var import_class_transformer10 = require("class-transformer");
var import_class_validator24 = require("class-validator");
var getPaginatedCropPledgesDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const _paginatedDto = getPaginateDto(ApiProperty);
  class GetCommonPaginatedCropPledgesDto extends _paginatedDto {
  }
  __decorateClass([
    (0, import_class_transformer10.Transform)(({ value }) => String(value)),
    (0, import_class_validator24.IsString)(),
    (0, import_class_validator24.IsOptional)(),
    ApiProperty({
      description: "Search by debtor/creditor company name or fiscal id",
      required: false,
      type: String
    })
  ], GetCommonPaginatedCropPledgesDto.prototype, "search", 2);
  __decorateClass([
    ApiProperty({
      type: [String],
      description: "Array of status strings",
      example: [
        import_types11.PLEDGE_STATUSES.PENDING_BOLSA_APPROVAL,
        import_types11.PLEDGE_STATUSES.PENDING_REGISTRATION
      ],
      required: false
    }),
    (0, import_class_validator24.IsOptional)(),
    (0, import_class_transformer10.Transform)(({ value }) => Array.isArray(value) ? value : Array(value)),
    (0, import_class_validator24.IsArray)(),
    (0, import_class_validator24.ArrayNotEmpty)({ message: "The status array should not be empty" }),
    (0, import_class_validator24.ArrayMinSize)(1, {
      message: "The status array should have at least one element"
    }),
    (0, import_class_validator24.ArrayUnique)({ message: "Status values must be unique" }),
    (0, import_class_validator24.IsEnum)(import_types11.PLEDGE_STATUSES, {
      each: true,
      message: "Each status must be a valid pledge status"
    })
  ], GetCommonPaginatedCropPledgesDto.prototype, "statuses", 2);
  return GetCommonPaginatedCropPledgesDto;
};

// src/dtos/common/crop-pledges/update-debtor-information.dto.ts
var import_common_utils2 = require("@bcba/common-utils");
var import_types12 = __toESM(require_dist());
var import_class_transformer11 = require("class-transformer");
var import_class_validator25 = require("class-validator");
var getCommonUpdateCropPledgeDebtorInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const todayUnix = (0, import_common_utils2.getUnixTimestamp)();
  class CommonUpdateCropPledgeDebtorInformationDto {
  }
  __decorateClass([
    (0, import_class_validator25.IsBoolean)({
      message: "true or false is required"
    }),
    (0, import_class_validator25.IsOptional)(),
    ApiProperty({
      type: Boolean,
      description: "Debtor company is PF type.",
      required: true,
      example: false
    })
  ], CommonUpdateCropPledgeDebtorInformationDto.prototype, "isPFCompanyType", 2);
  __decorateClass([
    (0, import_class_validator25.ValidateIf)((dto) => dto.isPFCompanyType),
    (0, import_class_validator25.IsEnum)(import_types12.MARITAL_STATUSES, {
      message: isFrontend ? "errorCode.cropPledge.maritalStatus" : "a valid marital statuses is required"
    }),
    (0, import_class_validator25.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "a valid marital statuses is required"
    }),
    ApiProperty({
      description: `Representant's marital status`,
      type: "enum",
      required: false,
      enum: import_types12.MARITAL_STATUSES,
      example: import_types12.MARITAL_STATUSES.MARRIED
    })
  ], CommonUpdateCropPledgeDebtorInformationDto.prototype, "representantMaritalStatus", 2);
  __decorateClass([
    (0, import_class_validator25.ValidateIf)((dto) => dto.isPFCompanyType),
    (0, import_class_transformer11.Transform)(({ value }) => value ? Number(value) : void 0),
    IsUnixTimestamp(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : { message: "Must be a valid date" }
    ),
    (0, import_class_validator25.Max)(todayUnix, {
      message: isFrontend ? "class-validator.isValidRepresentantBirthDate.error" : "representantBirthDate must be in the past"
    }),
    (0, import_class_validator25.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "representantBirthDate is required"
    }),
    ApiProperty({
      description: `Representant's birth date in unix timestamp in seconds`,
      type: Number,
      required: false,
      example: 1713967759
    })
  ], CommonUpdateCropPledgeDebtorInformationDto.prototype, "representantBirthDate", 2);
  __decorateClass([
    (0, import_class_validator25.ValidateIf)((dto) => dto.isPFCompanyType),
    (0, import_class_validator25.IsEnum)(import_types12.NATIONALITIES, {
      message: isFrontend ? "a valid nationality is required" : "errorCode.cropPledge.nationality"
    }),
    (0, import_class_validator25.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "representantNationality is required"
    }),
    ApiProperty({
      description: `Representant's nationality`,
      type: "enum",
      required: false,
      enum: import_types12.NATIONALITIES,
      example: import_types12.NATIONALITIES.ARGENTINE
    })
  ], CommonUpdateCropPledgeDebtorInformationDto.prototype, "representantNationality", 2);
  return CommonUpdateCropPledgeDebtorInformationDto;
};

// src/dtos/common/crop-pledges/update-creditor-information.dto.ts
var import_common_utils3 = require("@bcba/common-utils");
var import_types13 = __toESM(require_dist());
var import_class_transformer12 = require("class-transformer");
var import_class_validator26 = require("class-validator");
var getCommonUpdateCropPledgeCreditorInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const todayUnix = (0, import_common_utils3.getUnixTimestamp)();
  class CommonUpdateCropPledgeCreditorInformationDto {
  }
  __decorateClass([
    (0, import_class_validator26.IsBoolean)({
      message: "true or false is required"
    }),
    (0, import_class_validator26.IsOptional)(),
    ApiProperty({
      type: Boolean,
      description: "Creditor company is PF type.",
      required: true,
      example: false
    })
  ], CommonUpdateCropPledgeCreditorInformationDto.prototype, "isPFCompanyType", 2);
  __decorateClass([
    (0, import_class_validator26.ValidateIf)((dto) => dto.isPFCompanyType),
    (0, import_class_validator26.IsEnum)(import_types13.MARITAL_STATUSES, {
      message: isFrontend ? "a valid marital statuses is required" : "errorCode.cropPledge.maritalStatus"
    }),
    (0, import_class_validator26.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "representantMaritalStatus is required"
    }),
    ApiProperty({
      description: `Representant's marital status`,
      type: "enum",
      required: false,
      enum: import_types13.MARITAL_STATUSES,
      example: import_types13.MARITAL_STATUSES.MARRIED
    })
  ], CommonUpdateCropPledgeCreditorInformationDto.prototype, "representantMaritalStatus", 2);
  __decorateClass([
    (0, import_class_validator26.ValidateIf)((dto) => dto.isPFCompanyType),
    (0, import_class_transformer12.Transform)(({ value }) => value ? Number(value) : void 0),
    IsUnixTimestamp(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : { message: "Must be a valid date" }
    ),
    (0, import_class_validator26.Max)(todayUnix, {
      message: isFrontend ? "class-validator.isValidRepresentantBirthDate.error" : "representantBirthDate must be in the past"
    }),
    (0, import_class_validator26.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "representantBirthDate is required"
    }),
    ApiProperty({
      description: `Representant's birth date in unix timestamp in seconds`,
      type: Number,
      required: false,
      example: 1713967759
    })
  ], CommonUpdateCropPledgeCreditorInformationDto.prototype, "representantBirthDate", 2);
  __decorateClass([
    (0, import_class_validator26.ValidateIf)((dto) => dto.isPFCompanyType),
    (0, import_class_validator26.IsEnum)(import_types13.NATIONALITIES, {
      message: isFrontend ? "a valid nationality is required" : "errorCode.cropPledge.nationality"
    }),
    (0, import_class_validator26.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "representantNationality is required"
    }),
    ApiProperty({
      description: `Representant's nationality`,
      type: "enum",
      required: false,
      enum: import_types13.NATIONALITIES,
      example: import_types13.NATIONALITIES.ARGENTINE
    })
  ], CommonUpdateCropPledgeCreditorInformationDto.prototype, "representantNationality", 2);
  return CommonUpdateCropPledgeCreditorInformationDto;
};

// src/dtos/common/crop-pledges/set-crop-pledge-creditor.dto.ts
var import_class_validator27 = require("class-validator");
var getCommonSetCropPledgeCreditorDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class CommonSetCropPledgeCreditorDto {
  }
  __decorateClass([
    (0, import_class_validator27.IsString)(),
    (0, import_class_validator27.Length)(11, 11, {
      message: isFrontend ? "errorCode.createCompany.fiscalId.minLength" : "Must have 11 Characters"
    }),
    ApiProperty({
      description: "Company fiscal id: required and must be 11 characters long (only numbers).",
      required: true,
      type: String
    })
  ], CommonSetCropPledgeCreditorDto.prototype, "fiscalId", 2);
  return CommonSetCropPledgeCreditorDto;
};

// src/dtos/common/crop-pledges/upsert-crop-pledge-farm-information.dto.ts
var import_types14 = __toESM(require_dist());
var import_class_transformer13 = require("class-transformer");
var import_class_validator28 = require("class-validator");
var getCommonUpsertCropPledgeFarmInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const isNotEmptyMessage = isFrontend ? "class-validator.isNotEmpty.error" : "This field is required";
  const endDateNewerThanEndDate = "backoffice.pages.generalInformation.activityStartDate.startDateMustBeNewerThanEndDate";
  class CommonUpsertCropPledgeFarmInformationDto {
  }
  __decorateClass([
    (0, import_class_validator28.Length)(1, 200, {
      message: isFrontend ? "errorCode.createCompany.mainActivity.length" : "Identifier must be between 1 and 200 characters"
    }),
    (0, import_class_validator28.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: `Farm Identifier.`,
      type: String,
      example: "1847632BDD-322-XX0",
      required: true
    })
  ], CommonUpsertCropPledgeFarmInformationDto.prototype, "farmIdentifier", 2);
  __decorateClass([
    (0, import_class_validator28.Length)(1, 200, {
      message: isFrontend ? "errorCode.createCompany.mainActivity.length" : "Identifier must be between 1 and 200 characters"
    }),
    (0, import_class_validator28.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: `Cadastral nomenclature.`,
      type: String,
      example: "AA4737fd73",
      required: true
    })
  ], CommonUpsertCropPledgeFarmInformationDto.prototype, "cadastralNomenclature", 2);
  __decorateClass([
    (0, import_class_transformer13.Transform)(({ value }) => value ? parseFloat(value) : void 0),
    (0, import_class_validator28.Min)(
      0,
      isFrontend ? { message: "common.error.greaterOrEqualThanZero" } : void 0
    ),
    (0, import_class_validator28.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: `Total hectares.`,
      type: Number,
      example: 12345.67,
      required: true
    })
  ], CommonUpsertCropPledgeFarmInformationDto.prototype, "totalHectares", 2);
  __decorateClass([
    (0, import_class_validator28.IsUUID)("4"),
    (0, import_class_validator28.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: "Province uuid.",
      required: true,
      type: String,
      example: "79c62347-fba7-439f-9dda-26a7b98524c7"
    })
  ], CommonUpsertCropPledgeFarmInformationDto.prototype, "provinceUuid", 2);
  __decorateClass([
    (0, import_class_validator28.IsUUID)("4"),
    (0, import_class_validator28.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: "Locality uuid.",
      required: true,
      type: String,
      example: "79c62347-fba7-439f-9dda-26a7b98524c6"
    })
  ], CommonUpsertCropPledgeFarmInformationDto.prototype, "localityUuid", 2);
  __decorateClass([
    (0, import_class_validator28.Length)(1, 200, {
      message: isFrontend ? "errorCode.createCompany.mainActivity.length" : "Address must be between 1 and 200 characters"
    }),
    (0, import_class_validator28.IsString)(),
    (0, import_class_validator28.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: "Address.",
      required: true,
      type: String,
      example: "18th Av."
    })
  ], CommonUpsertCropPledgeFarmInformationDto.prototype, "address", 2);
  __decorateClass([
    (0, import_class_validator28.Length)(1, 200, {
      message: isFrontend ? "errorCode.createCompany.mainActivity.length" : "Postal Code must be between 1 and 200 characters"
    }),
    (0, import_class_validator28.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: "Postal Code.",
      required: true,
      type: String,
      example: "11150"
    })
  ], CommonUpsertCropPledgeFarmInformationDto.prototype, "postalCode", 2);
  __decorateClass([
    (0, import_class_validator28.IsEnum)(import_types14.OWNERSHIP_TYPES),
    (0, import_class_validator28.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      enum: import_types14.OWNERSHIP_TYPES,
      description: "Farm ownership type.",
      required: true,
      example: import_types14.OWNERSHIP_TYPES.OWN
    })
  ], CommonUpsertCropPledgeFarmInformationDto.prototype, "ownershipType", 2);
  __decorateClass([
    (0, import_class_validator28.ValidateIf)((o) => o.ownershipType === import_types14.OWNERSHIP_TYPES.THIRD_PARTY),
    (0, import_class_validator28.IsEnum)(import_types14.LEASE_CONTRACT_TYPES),
    (0, import_class_validator28.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      enum: import_types14.LEASE_CONTRACT_TYPES,
      description: "Farm lease contract type.",
      required: false,
      example: import_types14.LEASE_CONTRACT_TYPES.ASSOCIATIVE
    })
  ], CommonUpsertCropPledgeFarmInformationDto.prototype, "leaseContractType", 2);
  __decorateClass([
    (0, import_class_validator28.ValidateIf)((o) => o.ownershipType === import_types14.OWNERSHIP_TYPES.THIRD_PARTY),
    IsUnixTimestamp({
      message: "errorCode.createCompany.activityStartDate.isValid"
    }),
    (0, import_class_validator28.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: "Farm leased from date in unix timestamp in seconds",
      type: Number,
      required: false,
      example: 1713967700
    })
  ], CommonUpsertCropPledgeFarmInformationDto.prototype, "leasedFrom", 2);
  __decorateClass([
    (0, import_class_validator28.ValidateIf)((o) => o.ownershipType === import_types14.OWNERSHIP_TYPES.THIRD_PARTY),
    IsUnixTimestamp({
      message: "errorCode.createCompany.activityStartDate.isValid"
    }),
    IsBiggerThan("leasedFrom", {
      message: endDateNewerThanEndDate
    }),
    (0, import_class_validator28.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: "Farm leased until date in unix timestamp in seconds",
      type: Number,
      required: false,
      example: 1714e6
    })
  ], CommonUpsertCropPledgeFarmInformationDto.prototype, "leasedUntil", 2);
  __decorateClass([
    (0, import_class_validator28.ValidateIf)((o) => o.ownershipType === import_types14.OWNERSHIP_TYPES.THIRD_PARTY),
    (0, import_class_validator28.IsString)(),
    (0, import_class_validator28.Length)(11, 11, {
      message: isFrontend ? "errorCode.createCompany.fiscalId.minLength" : "Must have 11 Characters"
    }),
    (0, import_class_validator28.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: "Farm owner fiscal id: required and must be 11 characters long (only numbers).",
      required: false,
      type: String
    })
  ], CommonUpsertCropPledgeFarmInformationDto.prototype, "ownerFiscalId", 2);
  return CommonUpsertCropPledgeFarmInformationDto;
};

// src/dtos/common/crop-pledges/upsert-crop-pledge-lot-information.dto.ts
var import_class_validator29 = require("class-validator");
var getCommonUpsertCropPledgeLotInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const isNotEmptyMessage = isFrontend ? "class-validator.isNotEmpty.error" : "This field is required";
  class CommonUpsertCropPledgeLotInformationDto {
  }
  __decorateClass([
    (0, import_class_validator29.ValidateIf)((o) => o.uuid),
    (0, import_class_validator29.IsUUID)("4"),
    ApiProperty({
      description: `Lot Information UUID.`,
      type: String,
      example: "5d681505-4e23-41b1-927a-3e5e4896e36c",
      required: false
    })
  ], CommonUpsertCropPledgeLotInformationDto.prototype, "uuid", 2);
  __decorateClass([
    (0, import_class_validator29.Length)(1, 200, {
      message: isFrontend ? "errorCode.createCompany.mainActivity.length" : "Identifier must be between 1 and 200 characters"
    }),
    (0, import_class_validator29.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: `Lot Identifier.`,
      type: String,
      example: "1847632BDD-322-XX0",
      required: true
    })
  ], CommonUpsertCropPledgeLotInformationDto.prototype, "identifier", 2);
  return CommonUpsertCropPledgeLotInformationDto;
};

// src/dtos/common/crop-pledges/upsert-crop-pledge-lot-affidavit.dto.ts
var import_class_validator30 = require("class-validator");
var import_types15 = __toESM(require_dist());
var import_class_transformer14 = require("class-transformer");
var getCommonUpsertCropPledgeLotAffidavitDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const isNotEmptyMessage = isFrontend ? "class-validator.isNotEmpty.error" : "This field is required";
  const endDateNewerThanEndDate = "backoffice.pages.generalInformation.activityStartDate.startDateMustBeNewerThanEndDate";
  class CommonUpsertCropPledgeLotAffidavitDto {
  }
  __decorateClass([
    (0, import_class_validator30.ValidateIf)((o) => o.uuid),
    (0, import_class_validator30.IsUUID)("4"),
    ApiProperty({
      description: `Farm Information UUID.`,
      type: String,
      example: "5d681505-4e23-41b1-927a-3e5e4896e36c",
      required: false
    })
  ], CommonUpsertCropPledgeLotAffidavitDto.prototype, "uuid", 2);
  __decorateClass([
    IsUnixTimestamp({
      message: "errorCode.createCompany.activityStartDate.isValid"
    }),
    (0, import_class_validator30.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "startDate is required"
    }),
    ApiProperty({
      description: "Affidavit start date in unix timestamp in seconds",
      type: Number,
      required: true,
      example: 1713967700
    })
  ], CommonUpsertCropPledgeLotAffidavitDto.prototype, "startsAt", 2);
  __decorateClass([
    IsUnixTimestamp({
      message: "errorCode.createCompany.activityStartDate.isValid"
    }),
    IsBiggerThan("startsAt", {
      message: endDateNewerThanEndDate
    }),
    (0, import_class_validator30.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "startDate is required"
    }),
    ApiProperty({
      description: "Affidavit end date in unix timestamp in seconds",
      type: Number,
      required: true,
      example: 1714e6
    })
  ], CommonUpsertCropPledgeLotAffidavitDto.prototype, "endsAt", 2);
  __decorateClass([
    (0, import_class_validator30.IsEnum)(import_types15.PRODUCTS),
    (0, import_class_validator30.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      enum: import_types15.PRODUCTS,
      description: "Product type.",
      required: true,
      example: import_types15.PRODUCTS.CORN
    })
  ], CommonUpsertCropPledgeLotAffidavitDto.prototype, "productType", 2);
  __decorateClass([
    (0, import_class_validator30.ValidateIf)((dto) => dto.averageYieldPreviousSeason),
    (0, import_class_transformer14.Transform)(({ value }) => value ? parseFloat(value) : void 0),
    (0, import_class_validator30.Min)(0),
    ApiProperty({
      description: `Average yield of the previous season.`,
      type: Number,
      example: 19.4326,
      required: false
    })
  ], CommonUpsertCropPledgeLotAffidavitDto.prototype, "averageYieldPreviousSeason", 2);
  __decorateClass([
    (0, import_class_validator30.ValidateIf)((dto) => dto.averageYieldPreviousSeason1),
    (0, import_class_transformer14.Transform)(({ value }) => value ? parseFloat(value) : void 0),
    (0, import_class_validator30.Min)(0),
    ApiProperty({
      description: `Average yield of the previous season + 1.`,
      type: Number,
      example: 19.4326,
      required: false
    })
  ], CommonUpsertCropPledgeLotAffidavitDto.prototype, "averageYieldPreviousSeason1", 2);
  __decorateClass([
    (0, import_class_validator30.ValidateIf)((dto) => dto.averageYieldPreviousSeason2),
    (0, import_class_transformer14.Transform)(({ value }) => value ? parseFloat(value) : void 0),
    (0, import_class_validator30.Min)(0),
    ApiProperty({
      description: `Average yield of the previous season + 2.`,
      type: Number,
      example: 19.4326,
      required: false
    })
  ], CommonUpsertCropPledgeLotAffidavitDto.prototype, "averageYieldPreviousSeason2", 2);
  return CommonUpsertCropPledgeLotAffidavitDto;
};

// src/dtos/common/crop-pledges/upsert-crop-pledge-farm-documentation.dto.ts
var import_class_validator31 = require("class-validator");
var getCommonUpsertCropPledgeFarmDocumentationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  class CommonUpsertCropPledgeFarmDocumentationDto {
  }
  __decorateClass([
    (0, import_class_validator31.ValidateIf)((o) => o.uuid),
    (0, import_class_validator31.IsUUID)("4"),
    ApiProperty({
      description: `Farm Information UUID.`,
      type: String,
      example: "5d681505-4e23-41b1-927a-3e5e4896e36c",
      required: false
    })
  ], CommonUpsertCropPledgeFarmDocumentationDto.prototype, "uuid", 2);
  return CommonUpsertCropPledgeFarmDocumentationDto;
};

// src/dtos/backoffice/companies/upsert-company-equity-information.dto.ts
var import_class_transformer15 = require("class-transformer");
var getUpsertBackofficeCompanyEquityInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const _UpsertBase64ExtendedDocumentDto = getUpsertBase64ExtendedDocumentDto(ApiPropertySwagger);
  class UpsertBase64ExtendedDocumentDto extends _UpsertBase64ExtendedDocumentDto {
  }
  class UpsertCompanyEquityInformationDto {
  }
  __decorateClass([
    (0, import_class_validator32.IsOptional)(),
    (0, import_class_transformer15.Transform)(transformEmptyDocumentToUndefined),
    (0, import_class_validator32.ValidateIf)((o) => o?.balanceDocuments?.length > 0),
    ValidateNested(UpsertBase64ExtendedDocumentDto, { each: true }),
    ApiProperty({
      description: "Balance documents files to upload / update.",
      type: Array(UpsertBase64ExtendedDocumentDto),
      required: false
    })
  ], UpsertCompanyEquityInformationDto.prototype, "balanceDocuments", 2);
  __decorateClass([
    (0, import_class_validator32.IsOptional)(),
    (0, import_class_transformer15.Transform)(transformEmptyDocumentToUndefined),
    (0, import_class_validator32.ValidateIf)((o) => o?.additionalDocuments?.length > 0),
    ValidateNested(UpsertBase64ExtendedDocumentDto, { each: true }),
    ApiProperty({
      description: "Additional files to upload / update",
      type: [UpsertBase64ExtendedDocumentDto],
      required: false
    })
  ], UpsertCompanyEquityInformationDto.prototype, "additionalDocuments", 2);
  return UpsertCompanyEquityInformationDto;
};

// src/dtos/backoffice/crop-pledges/update-creditor-information.dto.ts
var import_class_validator33 = require("class-validator");
var getBackofficeUpdateCropPledgeCreditorInformationDto = (ApiPropertySwagger) => {
  const _CommonUpdateCropPledgeCreditorInformationDto = getCommonUpdateCropPledgeCreditorInformationDto(ApiPropertySwagger);
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class BackofficeUpdateCropPledgeCreditorInformationDto extends _CommonUpdateCropPledgeCreditorInformationDto {
  }
  __decorateClass([
    (0, import_class_validator33.IsOptional)(),
    (0, import_class_validator33.Length)(11, 11, {
      message: isFrontend ? "errorCode.createCompany.fiscalId.minLength" : "Must have 11 Characters"
    }),
    ApiProperty({
      description: "Company fiscal id: required and must be 11 characters long (only numbers).",
      required: false,
      type: String,
      example: "12345678901"
    })
  ], BackofficeUpdateCropPledgeCreditorInformationDto.prototype, "fiscalId", 2);
  return BackofficeUpdateCropPledgeCreditorInformationDto;
};

// src/dtos/backoffice/crop-pledges/upsert-farm-information/upsert-crop-pledge-lot-information.dto.ts
var import_class_transformer17 = require("class-transformer");
var import_class_validator35 = require("class-validator");

// src/dtos/backoffice/crop-pledges/upsert-farm-information/upsert-crop-pledge-lot-affidavit.dto.ts
var import_class_transformer16 = require("class-transformer");
var import_class_validator34 = require("class-validator");
var getBackofficeUpsertCropPledgeLotAffidavitDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const isNotEmptyMessage = isFrontend ? "class-validator.isNotEmpty.error" : "This field is required";
  const _CommonUpsertCropPledgeLotAffidavitDto = getCommonUpsertCropPledgeLotAffidavitDto(ApiPropertySwagger);
  class BackofficeUpsertCropPledgeLotAffidavitDto extends _CommonUpsertCropPledgeLotAffidavitDto {
  }
  __decorateClass([
    (0, import_class_transformer16.Transform)(({ value }) => value ? parseFloat(value) : void 0),
    (0, import_class_validator34.Min)(0),
    (0, import_class_validator34.Max)(999999999999e-2),
    (0, import_class_validator34.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: `Estimated production value.`,
      type: Number,
      example: 10000.5,
      required: false
    })
  ], BackofficeUpsertCropPledgeLotAffidavitDto.prototype, "estimatedProductionValue", 2);
  return BackofficeUpsertCropPledgeLotAffidavitDto;
};

// src/dtos/backoffice/crop-pledges/upsert-farm-information/upsert-crop-pledge-lot-information.dto.ts
var getBackofficeUpsertCropPledgeLotInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const isNotEmptyMessage = isFrontend ? "class-validator.isNotEmpty.error" : "This field is required";
  const _CommonUpsertCropPledgeLotInformationDto = getCommonUpsertCropPledgeLotInformationDto(ApiPropertySwagger);
  const _BackofficeUpsertCropPledgeLotAffidavitDto = getBackofficeUpsertCropPledgeLotAffidavitDto(ApiPropertySwagger);
  class BackofficeUpsertCropPledgeLotAffidavitDto extends _BackofficeUpsertCropPledgeLotAffidavitDto {
  }
  const _UpsertBase64DocumentDto = getUpsertBase64DocumentDto(ApiPropertySwagger);
  class UpsertBase64DocumentDto extends _UpsertBase64DocumentDto {
  }
  class BackofficeUpsertCropPledgeLotInformationDto extends _CommonUpsertCropPledgeLotInformationDto {
  }
  __decorateClass([
    ValidateNested(BackofficeUpsertCropPledgeLotAffidavitDto),
    ApiProperty({
      description: "Lot affidavit.",
      type: BackofficeUpsertCropPledgeLotAffidavitDto,
      required: true
    })
  ], BackofficeUpsertCropPledgeLotInformationDto.prototype, "affidavit", 2);
  __decorateClass([
    ValidateNested(UpsertBase64DocumentDto),
    ApiProperty({
      description: "Geolocation Document file.",
      type: UpsertBase64DocumentDto,
      required: true
    })
  ], BackofficeUpsertCropPledgeLotInformationDto.prototype, "geolocationDocument", 2);
  __decorateClass([
    (0, import_class_transformer17.Transform)(({ value }) => value ? parseFloat(value) : void 0),
    (0, import_class_validator35.IsLatitude)({
      message: isFrontend ? "class-validator.isLatitude" : "must be a valid latitude coordinate"
    }),
    (0, import_class_validator35.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: `Lot latitude coordinate.`,
      type: Number,
      example: 19.4326,
      required: true
    })
  ], BackofficeUpsertCropPledgeLotInformationDto.prototype, "latitude", 2);
  __decorateClass([
    (0, import_class_transformer17.Transform)(({ value }) => value ? parseFloat(value) : void 0),
    (0, import_class_validator35.IsLongitude)({
      message: isFrontend ? "class-validator.isLongitude" : "must be a valid longitude coordinate"
    }),
    (0, import_class_validator35.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: `Lot longitude coordinate.`,
      type: Number,
      example: -23.1142,
      required: true
    })
  ], BackofficeUpsertCropPledgeLotInformationDto.prototype, "longitude", 2);
  __decorateClass([
    (0, import_class_transformer17.Transform)(({ value }) => value ? parseInt(value, 10) : void 0),
    (0, import_class_validator35.IsInt)(),
    (0, import_class_validator35.Min)(1, {
      message: isFrontend ? "class-validator.min.1" : "areaPercentage must not be less than 1"
    }),
    (0, import_class_validator35.Max)(100, {
      message: isFrontend ? "class-validator.max.100" : "areaPercentage must not be greater than 100"
    }),
    (0, import_class_validator35.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: `Lot area percentage (integer).`,
      type: Number,
      example: 56,
      required: true
    })
  ], BackofficeUpsertCropPledgeLotInformationDto.prototype, "areaPercentage", 2);
  return BackofficeUpsertCropPledgeLotInformationDto;
};

// src/dtos/backoffice/crop-pledges/upsert-farm-information/upsert-crop-pledge-farm-information.dto.ts
var import_class_validator36 = require("class-validator");
var import_class_transformer18 = require("class-transformer");
var getBackofficeUpsertCropPledgeFarmInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const isNotEmptyMessage = isFrontend ? "class-validator.isNotEmpty.error" : "This field is required";
  const _CommonUpsertCropPledgeFarmInformationDto = getCommonUpsertCropPledgeFarmInformationDto(ApiPropertySwagger);
  const _UpsertBase64DocumentDto = getUpsertBase64DocumentDto(ApiPropertySwagger);
  class UpsertBase64DocumentDto extends _UpsertBase64DocumentDto {
  }
  const _BackofficeUpsertCropPledgeLotInformationDto = getBackofficeUpsertCropPledgeLotInformationDto(ApiPropertySwagger);
  class BackofficeUpsertCropPledgeLotInformationDto extends _BackofficeUpsertCropPledgeLotInformationDto {
  }
  const _UpsertBase64ExtendedDocumentDto = getUpsertBase64ExtendedDocumentDto(ApiPropertySwagger);
  class UpsertBase64ExtendedDocumentDto extends _UpsertBase64ExtendedDocumentDto {
  }
  class BackofficeUpsertCropPledgeFarmInformation extends _CommonUpsertCropPledgeFarmInformationDto {
  }
  __decorateClass([
    ValidateNested(UpsertBase64DocumentDto),
    ApiProperty({
      description: "Geolocation Document file.",
      type: UpsertBase64DocumentDto,
      required: true
    })
  ], BackofficeUpsertCropPledgeFarmInformation.prototype, "geolocationDocument", 2);
  __decorateClass([
    (0, import_class_validator36.IsOptional)(),
    (0, import_class_transformer18.Transform)(transformEmptyDocumentToUndefined),
    ValidateNested(UpsertBase64ExtendedDocumentDto, {
      each: true
    }),
    ApiProperty({
      description: "Farm documentation",
      type: Array(UpsertBase64ExtendedDocumentDto),
      required: false
    })
  ], BackofficeUpsertCropPledgeFarmInformation.prototype, "documentation", 2);
  __decorateClass([
    (0, import_class_transformer18.Transform)(({ value }) => value ? parseFloat(value) : void 0),
    (0, import_class_validator36.IsLatitude)({
      message: isFrontend ? "class-validator.isLatitude" : "must be a valid latitude coordinate"
    }),
    (0, import_class_validator36.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: `Farm latitude coordinate.`,
      type: Number,
      example: 19.4326,
      required: true
    })
  ], BackofficeUpsertCropPledgeFarmInformation.prototype, "latitude", 2);
  __decorateClass([
    (0, import_class_transformer18.Transform)(({ value }) => value ? parseFloat(value) : void 0),
    (0, import_class_validator36.IsLongitude)({
      message: isFrontend ? "class-validator.isLongitude" : "must be a valid longitude coordinate"
    }),
    (0, import_class_validator36.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: `Farm longitude coordinate.`,
      type: Number,
      example: -23.1142,
      required: true
    })
  ], BackofficeUpsertCropPledgeFarmInformation.prototype, "longitude", 2);
  __decorateClass([
    ValidateNested(BackofficeUpsertCropPledgeLotInformationDto, {
      each: true
    }),
    ApiProperty({
      description: "Farm lots",
      type: Array(BackofficeUpsertCropPledgeLotInformationDto),
      required: true
    })
  ], BackofficeUpsertCropPledgeFarmInformation.prototype, "lots", 2);
  return BackofficeUpsertCropPledgeFarmInformation;
};

// src/dtos/backoffice/crop-pledges/upsert-crop-pledge-documentation.dto.ts
var import_class_validator37 = require("class-validator");
var import_class_transformer19 = require("class-transformer");
var getBackofficeUpsertCropPledgeDocumentationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const _UpsertBase64ExtendedDocumentDto = getUpsertBase64ExtendedDocumentDto(ApiPropertySwagger);
  class UpsertBase64ExtendedDocumentDto extends _UpsertBase64ExtendedDocumentDto {
  }
  class BackofficeUpsertCropPledgeDocumentationDto {
  }
  __decorateClass([
    (0, import_class_transformer19.Expose)(),
    ValidateNested(UpsertBase64ExtendedDocumentDto),
    ApiProperty({
      description: "Loan contract file to upload / update.",
      type: UpsertBase64ExtendedDocumentDto,
      required: true
    })
  ], BackofficeUpsertCropPledgeDocumentationDto.prototype, "loanContractFile", 2);
  __decorateClass([
    (0, import_class_transformer19.Expose)(),
    (0, import_class_validator37.IsOptional)(),
    (0, import_class_transformer19.Transform)(transformEmptyDocumentToUndefined),
    ValidateNested(UpsertBase64ExtendedDocumentDto),
    ApiProperty({
      description: "Carbon analysis file to upload / update.",
      type: UpsertBase64ExtendedDocumentDto,
      required: false
    })
  ], BackofficeUpsertCropPledgeDocumentationDto.prototype, "carbonAnalysisFile", 2);
  __decorateClass([
    (0, import_class_transformer19.Expose)(),
    (0, import_class_validator37.IsOptional)(),
    (0, import_class_transformer19.Transform)(transformEmptyDocumentToUndefined),
    ValidateNested(UpsertBase64ExtendedDocumentDto),
    ApiProperty({
      description: "Domain report file to upload / update.",
      type: UpsertBase64ExtendedDocumentDto,
      required: false
    })
  ], BackofficeUpsertCropPledgeDocumentationDto.prototype, "domainReportFile", 2);
  __decorateClass([
    (0, import_class_transformer19.Expose)(),
    (0, import_class_validator37.IsOptional)(),
    (0, import_class_transformer19.Transform)(transformEmptyDocumentToUndefined),
    ValidateNested(UpsertBase64ExtendedDocumentDto),
    ApiProperty({
      description: "Modification form file to upload / update.",
      type: UpsertBase64ExtendedDocumentDto,
      required: false
    })
  ], BackofficeUpsertCropPledgeDocumentationDto.prototype, "modificationFormFile", 2);
  __decorateClass([
    (0, import_class_transformer19.Expose)(),
    (0, import_class_validator37.IsOptional)(),
    (0, import_class_transformer19.Transform)(transformEmptyDocumentToUndefined),
    ValidateNested(UpsertBase64ExtendedDocumentDto, { each: true }),
    ApiProperty({
      description: "Additional documents files to upload / update.",
      type: [UpsertBase64ExtendedDocumentDto],
      required: false
    })
  ], BackofficeUpsertCropPledgeDocumentationDto.prototype, "additionalDocumentFiles", 2);
  return BackofficeUpsertCropPledgeDocumentationDto;
};

// src/dtos/backoffice/crop-pledges/upsert-crop-pledge-information.dto.ts
var import_types16 = __toESM(require_dist());
var import_class_transformer20 = require("class-transformer");
var import_class_validator38 = require("class-validator");
var getBackofficeUpsertCropPledgeInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class BackofficeUpsertCropPledgeInformationDto {
  }
  __decorateClass([
    (0, import_class_validator38.IsUUID)("4"),
    (0, import_class_validator38.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "celebrationProvinceUuid is required"
    }),
    ApiProperty({
      description: "Celebration Province UUID.",
      type: Number,
      example: "8542e445-943b-45ce-8473-314afa7c9921",
      required: true
    })
  ], BackofficeUpsertCropPledgeInformationDto.prototype, "celebrationProvinceUuid", 2);
  __decorateClass([
    (0, import_class_transformer20.Transform)(({ value }) => value ? Number(value) : void 0),
    IsUnixTimestamp(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : { message: "Must be a valid date" }
    ),
    (0, import_class_validator38.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "celebratedAt is required"
    }),
    ApiProperty({
      description: "Celebration date in unix timestamp in seconds.",
      type: Number,
      required: true,
      example: 1713967759
    })
  ], BackofficeUpsertCropPledgeInformationDto.prototype, "celebratedAt", 2);
  __decorateClass([
    (0, import_class_validator38.IsEnum)(import_types16.PLEDGE_CROP_CLASSES, {
      message: isFrontend ? "errorCode.cropPledge.pledgeClass" : "a valid pledge class is required"
    }),
    (0, import_class_validator38.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "pledgeClass is required"
    }),
    ApiProperty({
      description: "Crop pledge class.",
      type: "enum",
      required: true,
      enum: import_types16.PLEDGE_CROP_CLASSES,
      example: import_types16.PLEDGE_CROP_CLASSES.FIXED
    })
  ], BackofficeUpsertCropPledgeInformationDto.prototype, "pledgeClass", 2);
  __decorateClass([
    (0, import_class_validator38.IsEnum)(import_types16.PLEDGE_CROP_DEGREES, {
      message: isFrontend ? "errorCode.cropPledge.degree" : "a valid pledge degree is required"
    }),
    (0, import_class_validator38.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "degree is required"
    }),
    ApiProperty({
      description: "Crop pledge degree.",
      type: "enum",
      required: true,
      enum: import_types16.PLEDGE_CROP_DEGREES,
      example: import_types16.PLEDGE_CROP_DEGREES.FIRST_DEGREE
    })
  ], BackofficeUpsertCropPledgeInformationDto.prototype, "degree", 2);
  __decorateClass([
    (0, import_class_validator38.IsEnum)(import_types16.CURRENCIES, {
      message: isFrontend ? "errorCode.cropPledge.currency" : "a valid currency is required"
    }),
    (0, import_class_validator38.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "currency is required"
    }),
    ApiProperty({
      description: "Currency",
      type: "enum",
      required: true,
      enum: import_types16.CURRENCIES,
      example: import_types16.CURRENCIES.USD
    })
  ], BackofficeUpsertCropPledgeInformationDto.prototype, "currency", 2);
  __decorateClass([
    (0, import_class_transformer20.Transform)(({ value }) => value ? parseFloat(value) : void 0),
    (0, import_class_validator38.Min)(
      0,
      isFrontend ? { message: "common.error.greaterOrEqualThanZero" } : void 0
    ),
    (0, import_class_validator38.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "contractAmount is required"
    }),
    ApiProperty({
      description: "Contract amount.",
      type: Number,
      example: 1e4,
      required: true
    })
  ], BackofficeUpsertCropPledgeInformationDto.prototype, "contractAmount", 2);
  __decorateClass([
    (0, import_class_validator38.Length)(1, 200, {
      message: isFrontend ? "errorCode.cropPledge.contractAmountInText.length" : "Contract amount in text must be between 1 and 200 characters"
    }),
    (0, import_class_validator38.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "contractAmountInText is required"
    }),
    ApiProperty({
      description: "Contract amount in text.",
      type: String,
      example: "Diez mil",
      required: true
    })
  ], BackofficeUpsertCropPledgeInformationDto.prototype, "contractAmountInText", 2);
  __decorateClass([
    (0, import_class_transformer20.Transform)(({ value }) => value ? parseFloat(value) : void 0),
    (0, import_class_validator38.Min)(
      0,
      isFrontend ? { message: "common.error.greaterOrEqualThanZero" } : void 0
    ),
    (0, import_class_validator38.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "exchangeRate is required"
    }),
    ApiProperty({
      description: "Exchange rate.",
      type: Number,
      example: 950,
      required: true
    })
  ], BackofficeUpsertCropPledgeInformationDto.prototype, "exchangeRate", 2);
  __decorateClass([
    (0, import_class_validator38.Length)(1, 200, {
      message: isFrontend ? "errorCode.cropPledge.obligationConcept.length" : "obligationConcept must be between 1 and 200 characters"
    }),
    (0, import_class_validator38.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "obligationConcept is required"
    }),
    ApiProperty({
      description: "Obligation concept.",
      type: String,
      example: 'CONTRATO DE PRENDA COMERCIAL ENTRE "DEUDOR" Y "ACREEDOR"',
      required: true
    })
  ], BackofficeUpsertCropPledgeInformationDto.prototype, "obligationConcept", 2);
  __decorateClass([
    (0, import_class_validator38.Length)(1, 200, {
      message: isFrontend ? "errorCode.cropPledge.documentation.length" : "documentation must be between 1 and 200 characters"
    }),
    (0, import_class_validator38.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "documentation is required"
    }),
    ApiProperty({
      description: "Documentation.",
      type: String,
      example: "Documentos...",
      required: true
    })
  ], BackofficeUpsertCropPledgeInformationDto.prototype, "documentation", 2);
  __decorateClass([
    (0, import_class_validator38.Length)(1, 200, {
      message: isFrontend ? "errorCode.cropPledge.paymentMethodsAndTerms.length" : "paymentMethodsAndTerms must be between 1 and 200 characters"
    }),
    (0, import_class_validator38.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "paymentMethodsAndTerms is required"
    }),
    ApiProperty({
      description: "Payment methods and terms.",
      type: String,
      example: "Pago en Especies por el cual X entrega a productor la cant de insumos...",
      required: true
    })
  ], BackofficeUpsertCropPledgeInformationDto.prototype, "paymentMethodsAndTerms", 2);
  __decorateClass([
    (0, import_class_transformer20.Transform)(({ value }) => value ? parseFloat(value) : void 0),
    (0, import_class_validator38.Min)(
      0,
      isFrontend ? { message: "common.error.greaterOrEqualThanZero" } : void 0
    ),
    (0, import_class_validator38.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "annualInterestRate is required"
    }),
    ApiProperty({
      description: "Annual interest rate.",
      type: Number,
      example: 18,
      required: true
    })
  ], BackofficeUpsertCropPledgeInformationDto.prototype, "annualInterestRate", 2);
  __decorateClass([
    (0, import_class_validator38.IsUUID)("4"),
    (0, import_class_validator38.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "paymentProvinceUuid is required"
    }),
    ApiProperty({
      description: "Payment Province UUID.",
      type: Number,
      example: "8542e445-943b-45ce-8473-314afa7c9921",
      required: true
    })
  ], BackofficeUpsertCropPledgeInformationDto.prototype, "paymentProvinceUuid", 2);
  __decorateClass([
    (0, import_class_validator38.IsEnum)(import_types16.CREDITOR_INSPECTION_RIGHTS, {
      message: isFrontend ? "errorCode.cropPledge.creditorInspectionRights" : "a valid creditorInspectionRight is required"
    }),
    (0, import_class_validator38.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "creditorInspectionRights is required"
    }),
    ApiProperty({
      description: "Creditor inspection rights.",
      type: "enum",
      required: true,
      enum: import_types16.CREDITOR_INSPECTION_RIGHTS,
      example: import_types16.CREDITOR_INSPECTION_RIGHTS.BROAD
    })
  ], BackofficeUpsertCropPledgeInformationDto.prototype, "creditorInspectionRights", 2);
  __decorateClass([
    (0, import_class_validator38.Length)(1, 200, {
      message: isFrontend ? "errorCode.cropPledge.liens.length" : "liens must be between 1 and 200 characters"
    }),
    (0, import_class_validator38.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "liens is required"
    }),
    ApiProperty({
      description: "Liens.",
      type: String,
      example: "Ninguno de ninguna naturaleza",
      required: true
    })
  ], BackofficeUpsertCropPledgeInformationDto.prototype, "liens", 2);
  return BackofficeUpsertCropPledgeInformationDto;
};

// src/dtos/backoffice/crop-pledges/upsert-crop-pledge-insurance-information.dto.ts
var import_types17 = __toESM(require_dist());
var import_class_transformer21 = require("class-transformer");
var import_class_validator39 = require("class-validator");
var getBackofficeUpsertCropPledgeInsuranceInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class BackofficeUpsertCropPledgeInsuranceInformationDto {
  }
  __decorateClass([
    (0, import_class_validator39.IsEnum)(import_types17.YES_NO_OPTIONS, {
      message: "YES or NO is required"
    }),
    (0, import_class_validator39.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "hasInsuranceInfo is required"
    }),
    ApiProperty({
      enum: import_types17.YES_NO_OPTIONS,
      description: "Crop pledge has or not insurance information.",
      required: true,
      example: import_types17.YES_NO_OPTIONS.NO
    })
  ], BackofficeUpsertCropPledgeInsuranceInformationDto.prototype, "hasInsuranceInfo", 2);
  __decorateClass([
    (0, import_class_validator39.ValidateIf)((dto) => dto.hasInsuranceInfo === import_types17.YES_NO_OPTIONS.YES),
    (0, import_class_validator39.MaxLength)(200),
    (0, import_class_validator39.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "insuranceType is required"
    }),
    ApiProperty({
      description: "Insurance Type.",
      type: String,
      example: "Granizo y Avigeato",
      required: false
    })
  ], BackofficeUpsertCropPledgeInsuranceInformationDto.prototype, "insuranceType", 2);
  __decorateClass([
    (0, import_class_validator39.ValidateIf)((dto) => dto.hasInsuranceInfo === import_types17.YES_NO_OPTIONS.YES),
    (0, import_class_validator39.IsEnum)(import_types17.CURRENCIES),
    (0, import_class_validator39.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "currency is required"
    }),
    ApiProperty({
      description: "Crop pledge has or not insurance information.",
      type: "enum",
      required: false,
      enum: import_types17.CURRENCIES,
      example: import_types17.CURRENCIES.ARS
    })
  ], BackofficeUpsertCropPledgeInsuranceInformationDto.prototype, "currency", 2);
  __decorateClass([
    (0, import_class_validator39.ValidateIf)((dto) => dto.hasInsuranceInfo === import_types17.YES_NO_OPTIONS.YES),
    (0, import_class_transformer21.Transform)(({ value }) => value ? Number(value) : void 0),
    (0, import_class_validator39.Min)(1),
    (0, import_class_validator39.Max)(9999999999999998e-2),
    (0, import_class_validator39.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "amount is required"
    }),
    ApiProperty({
      description: "Insurance covering amount.",
      type: Number,
      required: false,
      example: 100005054e-2
    })
  ], BackofficeUpsertCropPledgeInsuranceInformationDto.prototype, "amount", 2);
  __decorateClass([
    (0, import_class_validator39.ValidateIf)((dto) => dto.hasInsuranceInfo === import_types17.YES_NO_OPTIONS.YES),
    (0, import_class_validator39.MaxLength)(200),
    (0, import_class_validator39.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "insuranceCompany is required"
    }),
    ApiProperty({
      description: "Insurance company name.",
      type: String,
      required: false,
      example: "Mapfre"
    })
  ], BackofficeUpsertCropPledgeInsuranceInformationDto.prototype, "insuranceCompany", 2);
  __decorateClass([
    (0, import_class_validator39.ValidateIf)((dto) => dto.hasInsuranceInfo === import_types17.YES_NO_OPTIONS.YES),
    (0, import_class_validator39.MaxLength)(200),
    (0, import_class_validator39.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "streetName is required"
    }),
    ApiProperty({
      description: "Insurance street name.",
      type: String,
      required: false,
      example: "Av. del Libertador"
    })
  ], BackofficeUpsertCropPledgeInsuranceInformationDto.prototype, "streetName", 2);
  __decorateClass([
    (0, import_class_validator39.ValidateIf)((dto) => dto.hasInsuranceInfo === import_types17.YES_NO_OPTIONS.YES),
    (0, import_class_validator39.MaxLength)(200),
    (0, import_class_validator39.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "streetNumber is required"
    }),
    ApiProperty({
      description: "Insurance street number.",
      type: String,
      required: false,
      example: "12234 bis"
    })
  ], BackofficeUpsertCropPledgeInsuranceInformationDto.prototype, "streetNumber", 2);
  __decorateClass([
    (0, import_class_validator39.ValidateIf)((dto) => dto.hasInsuranceInfo === import_types17.YES_NO_OPTIONS.YES),
    (0, import_class_validator39.IsUUID)("4"),
    (0, import_class_validator39.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "provinceUuid is required"
    }),
    ApiProperty({
      description: "Province uuid.",
      required: true,
      type: String,
      example: "79c62347-fba7-439f-9dda-26a7b98524c7"
    })
  ], BackofficeUpsertCropPledgeInsuranceInformationDto.prototype, "provinceUuid", 2);
  __decorateClass([
    (0, import_class_validator39.ValidateIf)((dto) => dto.hasInsuranceInfo === import_types17.YES_NO_OPTIONS.YES),
    (0, import_class_validator39.IsUUID)("4"),
    (0, import_class_validator39.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "localityUuid is required"
    }),
    ApiProperty({
      description: "Insurance locality uuid.",
      type: String,
      required: false,
      example: "2502dcc8-44a1-4aab-8a8c-69611f8397fb"
    })
  ], BackofficeUpsertCropPledgeInsuranceInformationDto.prototype, "localityUuid", 2);
  __decorateClass([
    (0, import_class_validator39.ValidateIf)((dto) => dto.hasInsuranceInfo === import_types17.YES_NO_OPTIONS.YES),
    (0, import_class_validator39.MaxLength)(200),
    (0, import_class_validator39.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "postalCode is required"
    }),
    ApiProperty({
      description: "Insurance postal code.",
      type: String,
      required: false,
      example: "113443A"
    })
  ], BackofficeUpsertCropPledgeInsuranceInformationDto.prototype, "postalCode", 2);
  __decorateClass([
    (0, import_class_validator39.ValidateIf)((dto) => dto.hasInsuranceInfo === import_types17.YES_NO_OPTIONS.YES),
    (0, import_class_validator39.MaxLength)(200),
    (0, import_class_validator39.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "policyNumber is required"
    }),
    ApiProperty({
      description: "Insurance policy number.",
      type: String,
      required: false,
      example: "CB1234567890"
    })
  ], BackofficeUpsertCropPledgeInsuranceInformationDto.prototype, "policyNumber", 2);
  return BackofficeUpsertCropPledgeInsuranceInformationDto;
};

// src/dtos/backoffice/user-companies/create-user-company.dto.ts
var import_types18 = __toESM(require_dist());
var import_class_validator40 = require("class-validator");
var getCreateUserCompanyDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class CreateUserCompanyDto {
  }
  __decorateClass([
    (0, import_class_validator40.IsString)(),
    (0, import_class_validator40.Length)(36, 36, {
      message: isFrontend ? "errorCode.createUserCompany.companyUuid.length" : "Company UUID should be 36 Characters long"
    }),
    ApiProperty({
      description: `Company's UUID.`,
      required: true,
      type: String
    })
  ], CreateUserCompanyDto.prototype, "companyUuid", 2);
  __decorateClass([
    (0, import_class_validator40.IsString)(),
    (0, import_class_validator40.Length)(36, 36, {
      message: isFrontend ? "errorCode.createUserCompany.userUuid.length" : "User UUID should be 36 Characters long"
    }),
    ApiProperty({
      description: `User's UUID.`,
      required: true,
      type: String
    })
  ], CreateUserCompanyDto.prototype, "userUuid", 2);
  __decorateClass([
    (0, import_class_validator40.IsOptional)(),
    (0, import_class_validator40.IsEnum)(import_types18.USER_COMPANY_STATUSES, {
      message: isFrontend ? "errorCode.createUserCompany.status.isValid" : "A valid user-company status is required"
    }),
    ApiProperty({
      enum: import_types18.USER_COMPANY_STATUSES,
      description: "User Company Status.",
      required: false
    })
  ], CreateUserCompanyDto.prototype, "status", 2);
  __decorateClass([
    (0, import_class_validator40.IsEnum)(import_types18.USER_ROLES, {
      message: isFrontend ? "errorCode.createUserCompany.role.isValid" : "a valid user role is required"
    }),
    ApiProperty({
      enum: import_types18.USER_ROLES,
      description: "User Role on company.",
      required: true
    })
  ], CreateUserCompanyDto.prototype, "userRole", 2);
  return CreateUserCompanyDto;
};

// src/dtos/backoffice/documents/create-documents.dto.ts
var import_class_transformer22 = require("class-transformer");
var import_class_validator41 = require("class-validator");
var getCreateCompanyDocumentDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class CreateDocumentDto {
  }
  __decorateClass([
    (0, import_class_validator41.IsUUID)("4"),
    (0, import_class_validator41.IsNotEmpty)({
      message: isFrontend ? "errorCode.createCompanyDocument.companyUuid.isNotEmpty" : "Company Uuid is required"
    }),
    (0, import_class_validator41.MaxLength)(200, {
      message: isFrontend ? "errorCode.createCompanyDocument.identifier.length" : "Document original name length must be less than or equal to 200 characters"
    }),
    ApiProperty({
      description: "Original File name.",
      required: true,
      type: String
    })
  ], CreateDocumentDto.prototype, "originalFileName", 2);
  __decorateClass([
    (0, import_class_validator41.IsOptional)(),
    (0, import_class_validator41.MaxLength)(200, {
      message: isFrontend ? "errorCode.createCompanyDocument.identifier.length" : "Document identifier length must be less than or equal to 200 characters"
    }),
    ApiProperty({
      description: "Internal document identifier.",
      required: true,
      type: String
    })
  ], CreateDocumentDto.prototype, "identifier", 2);
  __decorateClass([
    (0, import_class_validator41.IsOptional)(),
    (0, import_class_transformer22.Transform)(({ value }) => Number(value)),
    IsUnixTimestamp(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : {
        message: "Must be a valid date"
      }
    ),
    ApiProperty({
      description: `Document's expiration timestamp in seconds.`,
      required: false,
      type: Number
    })
  ], CreateDocumentDto.prototype, "expirationDate", 2);
  return CreateDocumentDto;
};

// src/dtos/backoffice/documents/update.dto.ts
var import_class_validator42 = require("class-validator");
var getUpdateCompanyDocumentDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  class UpdateDocumentDto {
  }
  __decorateClass([
    (0, import_class_validator42.IsOptional)(),
    (0, import_class_validator42.IsBoolean)(),
    ApiProperty({
      description: "CompanyDocument is expired?",
      required: false,
      type: Boolean
    })
  ], UpdateDocumentDto.prototype, "expired", 2);
  return UpdateDocumentDto;
};

// src/dtos/backoffice/digital-dossiers/get-digital-dossiers.dto.ts
var import_class_validator43 = require("class-validator");
var import_class_transformer23 = require("class-transformer");
var import_types19 = __toESM(require_dist());
var getDigitalDossiersDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  class GetDigitalDossiersDto {
    constructor() {
      this.page = 1;
      this.pageSize = 10;
    }
  }
  __decorateClass([
    (0, import_class_transformer23.Transform)(({ value }) => String(value)),
    (0, import_class_validator43.IsString)(),
    (0, import_class_validator43.IsOptional)(),
    ApiProperty({
      description: "Search by company name and fiscalId",
      required: false,
      type: String
    })
  ], GetDigitalDossiersDto.prototype, "search", 2);
  __decorateClass([
    (0, import_class_validator43.IsOptional)(),
    (0, import_class_validator43.IsArray)(),
    ApiProperty({
      description: "Digital Dossier status filter.",
      required: false,
      type: Array,
      items: { enum: import_types19.DIGITAL_DOSSIER_STATUS }
    })
  ], GetDigitalDossiersDto.prototype, "dossierStatuses", 2);
  __decorateClass([
    (0, import_class_transformer23.Transform)(({ value }) => Number(value)),
    (0, import_class_validator43.IsNumber)(),
    (0, import_class_validator43.IsOptional)(),
    ApiProperty({
      description: "Page number.",
      required: false,
      type: Number
    })
  ], GetDigitalDossiersDto.prototype, "page", 2);
  __decorateClass([
    (0, import_class_transformer23.Transform)(({ value }) => Number(value)),
    (0, import_class_validator43.IsNumber)(),
    (0, import_class_validator43.IsOptional)(),
    ApiProperty({
      description: "Items per page.",
      required: false,
      type: Number
    })
  ], GetDigitalDossiersDto.prototype, "pageSize", 2);
  return GetDigitalDossiersDto;
};

// src/dtos/backoffice/digital-dossiers/update-digital-dossier-general-information.dto.ts
var import_types20 = __toESM(require_dist());
var import_class_transformer24 = require("class-transformer");
var import_class_validator44 = require("class-validator");
var getBackofficeUpdateDigitalDossierGeneralInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const startDateOlderThanEndDate = "backoffice.pages.generalInformation.activityStartDate.startDateMustBeOlderThanEndDate";
  const endDateNewerThanEndDate = "backoffice.pages.generalInformation.activityStartDate.startDateMustBeNewerThanEndDate";
  class BackofficeUpdateDigitalDossierGeneralInformationDto {
  }
  __decorateClass([
    (0, import_class_validator44.IsArray)(),
    (0, import_class_validator44.IsEnum)(import_types20.COMPANY_ACTIVITIES, {
      each: true,
      message: "errorCode.createCompany.activity.isValid"
    }),
    (0, import_class_validator44.ArrayNotEmpty)({
      message: "class-validator.isNotEmpty.error"
    }),
    ApiProperty({
      description: `Company activities`,
      type: "enum",
      required: true,
      enum: import_types20.COMPANY_ACTIVITIES,
      example: [
        import_types20.COMPANY_ACTIVITIES.PRODUCER,
        import_types20.COMPANY_ACTIVITIES.OPERATOR_WITH_PLANT
      ]
    })
  ], BackofficeUpdateDigitalDossierGeneralInformationDto.prototype, "mainActivities", 2);
  __decorateClass([
    (0, import_class_transformer24.Transform)(({ value }) => Number(value)),
    IsUnixTimestamp({
      message: "errorCode.createCompany.activityStartDate.isValid"
    }),
    IsLowerThan("activityEndDate", {
      message: startDateOlderThanEndDate
    }),
    ApiProperty({
      description: "Company activity start date in unix timestamp in seconds",
      type: Number,
      required: true,
      example: 1713967759
    })
  ], BackofficeUpdateDigitalDossierGeneralInformationDto.prototype, "activityStartDate", 2);
  __decorateClass([
    (0, import_class_transformer24.Transform)(({ value }) => Number(value)),
    IsUnixTimestamp({
      message: "errorCode.createCompany.activityStartDate.isValid"
    }),
    IsBiggerThan("activityStartDate", {
      message: endDateNewerThanEndDate
    }),
    ApiProperty({
      description: "Company activity end date in unix timestamp in seconds",
      type: Number,
      required: true,
      example: 1713967759
    })
  ], BackofficeUpdateDigitalDossierGeneralInformationDto.prototype, "activityEndDate", 2);
  __decorateClass([
    (0, import_class_validator44.IsEnum)(import_types20.RUCA_STATUSES, {
      message: isFrontend ? "errorCode.createCompany.ruca.isValid" : "Must be a valid RUCA Status"
    }),
    ApiProperty({
      enum: import_types20.RUCA_STATUSES,
      description: "RUCA Status.",
      required: true,
      example: import_types20.RUCA_STATUSES.CURRENT
    })
  ], BackofficeUpdateDigitalDossierGeneralInformationDto.prototype, "rucaStatus", 2);
  __decorateClass([
    (0, import_class_validator44.Length)(1, 200, {
      message: isFrontend ? "errorCode.createCompanyDocument.identifier.length" : "Must be between 1 and 200 characters"
    }),
    ApiProperty({
      description: `Company IGJ identifier`,
      required: true,
      type: String,
      example: "RL-20023-MFR7776"
    })
  ], BackofficeUpdateDigitalDossierGeneralInformationDto.prototype, "igjIdentifier", 2);
  __decorateClass([
    (0, import_class_validator44.IsEnum)(import_types20.SISA_ACTIVITIES, {
      each: true,
      message: isFrontend ? "errorCode.updateCompanyGeneralInformation.sisaActivities.isValid" : "Must be a valid SISA activity"
    }),
    ApiProperty({
      description: `Company SISA activities`,
      type: "enum",
      enum: import_types20.SISA_ACTIVITIES,
      required: true,
      example: [import_types20.SISA_ACTIVITIES.PRODUCER, import_types20.SISA_ACTIVITIES.BROKER]
    })
  ], BackofficeUpdateDigitalDossierGeneralInformationDto.prototype, "sisaActivities", 2);
  __decorateClass([
    (0, import_class_validator44.IsEnum)(import_types20.SISA_SCORINGS, {
      message: isFrontend ? "errorCode.updateCompanyGeneralInformation.sisaScoring.isValid" : "Must be a valid SISA Scoring"
    }),
    ApiProperty({
      description: `Company SISA scoring`,
      type: "enum",
      enum: import_types20.SISA_SCORINGS,
      required: true,
      example: import_types20.SISA_SCORINGS.SITUATION_2
    })
  ], BackofficeUpdateDigitalDossierGeneralInformationDto.prototype, "sisaScoring", 2);
  __decorateClass([
    (0, import_class_validator44.Length)(1, 200, {
      message: isFrontend ? "errorCode.createCompanyDocument.identifier.length" : "Must be between 1 and 200 characters"
    }),
    ApiProperty({
      description: `Company signature schema`,
      required: true,
      type: String,
      example: "B-0000-0004"
    })
  ], BackofficeUpdateDigitalDossierGeneralInformationDto.prototype, "signatureSchema", 2);
  return BackofficeUpdateDigitalDossierGeneralInformationDto;
};

// src/dtos/backoffice/digital-dossiers/request-changes-digital-dossier.dto.ts
var import_class_validator45 = require("class-validator");
var getBackofficeRequestChangesDigitalDossierDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const maxLengthMessage = "backoffice.pages.generalInformation.validationMessage.maxLength";
  const minLengthMessage = "backoffice.pages.generalInformation.validationMessage.minLength";
  class BackofficeRequestChangesDigitalDossierDto {
  }
  __decorateClass([
    (0, import_class_validator45.ValidateIf)((o) => typeof o.validationMessage === "string"),
    (0, import_class_validator45.IsOptional)(),
    (0, import_class_validator45.IsString)(),
    (0, import_class_validator45.MaxLength)(
      500,
      isFrontend ? {
        message: maxLengthMessage
      } : void 0
    ),
    (0, import_class_validator45.MinLength)(
      3,
      isFrontend ? {
        message: minLengthMessage
      } : void 0
    ),
    ApiProperty({
      description: "Validation message required to request changes",
      example: "The info is invalid, please change X...",
      type: String,
      required: false
    })
  ], BackofficeRequestChangesDigitalDossierDto.prototype, "validationMessage", 2);
  return BackofficeRequestChangesDigitalDossierDto;
};

// src/dtos/backoffice/digital-dossiers/update-digital-dossier-banking-information.dto.ts
var import_class_validator47 = require("class-validator");

// src/dtos/backoffice/digital-dossiers/update-digital-dossier-bank-account.dto.ts
var import_class_validator46 = require("class-validator");
var getBackofficeUpdateDigitalDossierBankAccountDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const _UpsertBase64ExtendedDocumentDto = getUpsertBase64ExtendedDocumentDto(ApiPropertySwagger);
  class UpsertBase64ExtendedDocumentDto extends _UpsertBase64ExtendedDocumentDto {
  }
  class UpdateDigitalDossierBankAccountDto {
  }
  __decorateClass([
    (0, import_class_validator46.IsOptional)(),
    (0, import_class_validator46.IsUUID)(),
    ApiProperty({
      description: `Bank account UUID.`,
      type: String,
      example: "96c9e11d-74aa-4675-b37d-e218ac1ff2ac"
    })
  ], UpdateDigitalDossierBankAccountDto.prototype, "uuid", 2);
  __decorateClass([
    (0, import_class_validator46.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator46.Length)(22, 22, {
      message: isFrontend ? "errorCode.digitalDossier.updateBankingInfo.cbu.length" : "Must be 22 characters"
    }),
    (0, import_class_validator46.IsString)(),
    ApiProperty({
      description: `Account's CBU.`,
      type: String,
      example: "6540940411100063886749",
      required: true
    })
  ], UpdateDigitalDossierBankAccountDto.prototype, "cbu", 2);
  __decorateClass([
    (0, import_class_validator46.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator46.IsString)(),
    ApiProperty({
      description: `Account's Bank entity.`,
      type: String,
      example: "Santander",
      required: true
    })
  ], UpdateDigitalDossierBankAccountDto.prototype, "bankEntity", 2);
  __decorateClass([
    (0, import_class_validator46.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    ValidateNested(UpsertBase64ExtendedDocumentDto),
    (0, import_class_validator46.IsOptional)(),
    ApiProperty({
      description: "ID Document file to update",
      type: UpsertBase64ExtendedDocumentDto
    })
  ], UpdateDigitalDossierBankAccountDto.prototype, "cbuDocument", 2);
  return UpdateDigitalDossierBankAccountDto;
};

// src/dtos/backoffice/digital-dossiers/update-digital-dossier-banking-information.dto.ts
var import_types21 = __toESM(require_dist());
var getBackofficeUpdateDigitalDossierBankingInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const _UpdateDigitalDossierBankAccountDto = getBackofficeUpdateDigitalDossierBankAccountDto(ApiPropertySwagger);
  class UpdateDigitalDossierBankAccountDto extends _UpdateDigitalDossierBankAccountDto {
  }
  function WithUpdateBackofficeDigitalDossierBankingInformationDto(Base) {
    class UpdateDigitalDossierBankingInformationDto extends Base {
    }
    __decorateClass([
      (0, import_class_validator47.IsNotEmpty)(),
      (0, import_class_validator47.IsEnum)(import_types21.YES_NO_OPTIONS, {
        message: "YES or NO is required"
      }),
      ApiProperty({
        enum: import_types21.YES_NO_OPTIONS,
        description: "Indicates if user has banking info.",
        required: true
      })
    ], UpdateDigitalDossierBankingInformationDto.prototype, "hasBankingInfo", 2);
    __decorateClass([
      (0, import_class_validator47.ValidateIf)((o) => o.hasBankingInfo === import_types21.YES_NO_OPTIONS.YES),
      ValidateNested(UpdateDigitalDossierBankAccountDto, { each: true }),
      (0, import_class_validator47.ArrayMinSize)(1, {
        message: "Debe haber al menos una cuenta bancaria."
      }),
      ApiProperty({
        description: "List of bank accounts",
        type: [UpdateDigitalDossierBankAccountDto],
        required: true
      })
    ], UpdateDigitalDossierBankingInformationDto.prototype, "accounts", 2);
    return UpdateDigitalDossierBankingInformationDto;
  }
  return {
    UpdateBackofficeDigitalDossierBankingInformationDto: WithUpdateBackofficeDigitalDossierBankingInformationDto(class {
    })
  };
};

// src/dtos/backoffice/digital-dossiers/update-digital-dossier-tax-information.dto.ts
var import_class_validator48 = require("class-validator");
var import_types22 = __toESM(require_dist());
var import_class_transformer25 = require("class-transformer");
var getBackofficeUpdateDigitalDossierTaxInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const _UpsertBase64ExtendedDocumentDto = getUpsertBase64ExtendedDocumentDto(ApiPropertySwagger);
  class UpsertBase64ExtendedDocumentDto extends _UpsertBase64ExtendedDocumentDto {
  }
  const _OptionalUpsertBase64ExtendedDocumentDto = getOptionalUpsertBase64ExtendedDocumentDto(ApiPropertySwagger);
  class OptionalUpsertBase64ExtendedDocumentDto extends _OptionalUpsertBase64ExtendedDocumentDto {
  }
  class UpdateDigitalDossierTaxInformationDto {
  }
  __decorateClass([
    (0, import_class_validator48.IsOptional)(),
    (0, import_class_transformer25.Transform)(transformEmptyDocumentToUndefined),
    ValidateNested(UpsertBase64ExtendedDocumentDto),
    ApiProperty({
      description: "CUIT proof file to update",
      type: UpsertBase64ExtendedDocumentDto,
      required: false
    })
  ], UpdateDigitalDossierTaxInformationDto.prototype, "cuitDocument", 2);
  __decorateClass([
    (0, import_class_validator48.IsOptional)(),
    (0, import_class_validator48.IsEnum)(import_types22.IVA_CONDITION),
    ApiProperty({
      enum: import_types22.IVA_CONDITION,
      description: "IVA Condition.",
      required: false,
      example: import_types22.IVA_CONDITION.IVA_REGISTERED_RESPONSIBLE
    })
  ], UpdateDigitalDossierTaxInformationDto.prototype, "ivaCondition", 2);
  __decorateClass([
    (0, import_class_validator48.IsOptional)(),
    (0, import_class_validator48.IsEnum)(import_types22.BRUTE_INCOME_TYPES),
    ApiProperty({
      enum: import_types22.BRUTE_INCOME_TYPES,
      description: "Brute income.",
      required: false,
      example: import_types22.BRUTE_INCOME_TYPES.LOCAL_JURISDICTION
    })
  ], UpdateDigitalDossierTaxInformationDto.prototype, "bruteIncome", 2);
  __decorateClass([
    (0, import_class_validator48.IsOptional)(),
    (0, import_class_validator48.IsArray)(),
    (0, import_class_validator48.IsEnum)(import_types22.PROVINCES, {
      each: true,
      message: "Debe ser una jurisdicci\xF3n v\xE1lida"
    }),
    ApiProperty({
      description: `Jurisdictions`,
      type: "enum",
      required: false,
      enum: import_types22.PROVINCES,
      example: [import_types22.PROVINCES.CHACO, import_types22.PROVINCES.NEUQUEN]
    })
  ], UpdateDigitalDossierTaxInformationDto.prototype, "jurisdictions", 2);
  __decorateClass([
    (0, import_class_validator48.IsOptional)(),
    (0, import_class_transformer25.Transform)(transformEmptyDocumentToUndefined),
    ValidateNested(UpsertBase64ExtendedDocumentDto),
    ApiProperty({
      description: "IIBB file to update",
      type: UpsertBase64ExtendedDocumentDto,
      required: false
    })
  ], UpdateDigitalDossierTaxInformationDto.prototype, "iibbDocument", 2);
  __decorateClass([
    (0, import_class_validator48.IsOptional)(),
    (0, import_class_validator48.IsEnum)(
      import_types22.PROFIT_TYPES,
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    ApiProperty({
      enum: import_types22.PROFIT_TYPES,
      description: "Profits tax",
      required: false,
      example: import_types22.PROFIT_TYPES.REGISTERED
    })
  ], UpdateDigitalDossierTaxInformationDto.prototype, "profits", 2);
  __decorateClass([
    (0, import_class_validator48.IsOptional)(),
    (0, import_class_transformer25.Transform)(transformEmptyDocumentToUndefined),
    ValidateNested(UpsertBase64ExtendedDocumentDto),
    ApiProperty({
      description: "Profits file to update",
      type: UpsertBase64ExtendedDocumentDto,
      required: false
    })
  ], UpdateDigitalDossierTaxInformationDto.prototype, "profitsDocument", 2);
  __decorateClass([
    (0, import_class_validator48.IsOptional)(),
    (0, import_class_transformer25.Transform)(transformEmptyDocumentToUndefined),
    ValidateNested(UpsertBase64ExtendedDocumentDto),
    ApiProperty({
      description: "CM05 file to update",
      type: UpsertBase64ExtendedDocumentDto,
      required: false
    })
  ], UpdateDigitalDossierTaxInformationDto.prototype, "cm05Document", 2);
  __decorateClass([
    (0, import_class_validator48.IsOptional)(),
    (0, import_class_transformer25.Transform)(transformEmptyDocumentToUndefined),
    ValidateNested(UpsertBase64ExtendedDocumentDto),
    ApiProperty({
      description: "Exemptions file to update",
      type: UpsertBase64ExtendedDocumentDto,
      required: false
    })
  ], UpdateDigitalDossierTaxInformationDto.prototype, "exemptionsDocument", 2);
  __decorateClass([
    (0, import_class_validator48.IsOptional)(),
    (0, import_class_transformer25.Transform)(transformEmptyDocumentToUndefined),
    ValidateNested(UpsertBase64ExtendedDocumentDto, { each: true }),
    ApiProperty({
      description: "Additional files to update",
      type: [UpsertBase64ExtendedDocumentDto],
      required: false
    })
  ], UpdateDigitalDossierTaxInformationDto.prototype, "additionalDocuments", 2);
  return UpdateDigitalDossierTaxInformationDto;
};

// src/dtos/backoffice/digital-dossiers/upsert-digital-dossier-legal-representant-information.dto.ts
var import_class_validator52 = require("class-validator");

// src/dtos/backoffice/digital-dossiers/upsert-digital-dossier-legal-representant.dto.ts
var import_class_validator51 = require("class-validator");
var import_types25 = __toESM(require_dist());

// src/dtos/backoffice/digital-dossiers/upsert-digital-dossier-legal-representant-product-cap.dto.ts
var import_class_validator49 = require("class-validator");
var import_types23 = __toESM(require_dist());
var getBackofficeUpsertDigitalDossierRepresentantProductCapDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class UpsertDigitalDossierRepresentantProductCapDto {
  }
  __decorateClass([
    (0, import_class_validator49.IsUUID)(),
    (0, import_class_validator49.IsOptional)(),
    ApiProperty({
      description: `Product cap UUID.`,
      type: String,
      example: "96c9e11d-74aa-4675-b37d-e218ac1ff2ac"
    })
  ], UpsertDigitalDossierRepresentantProductCapDto.prototype, "uuid", 2);
  __decorateClass([
    (0, import_class_validator49.IsEnum)(import_types23.PRODUCTS, {
      each: true,
      message: "TODO"
    }),
    (0, import_class_validator49.IsNotEmpty)({
      message: "class-validator.isNotEmpty.error"
    }),
    ApiProperty({
      description: "Product",
      type: "enum",
      required: true,
      enum: import_types23.PRODUCTS,
      example: import_types23.PRODUCTS.CORN
    })
  ], UpsertDigitalDossierRepresentantProductCapDto.prototype, "product", 2);
  __decorateClass([
    (0, import_class_validator49.Min)(
      0,
      isFrontend ? { message: "common.error.greaterOrEqualThanZero" } : void 0
    ),
    (0, import_class_validator49.IsNotEmpty)({
      message: "class-validator.isNotEmpty.error"
    }),
    ApiProperty({
      description: "Product cap in tons",
      type: Number,
      required: true,
      example: 100
    })
  ], UpsertDigitalDossierRepresentantProductCapDto.prototype, "cap", 2);
  return UpsertDigitalDossierRepresentantProductCapDto;
};

// src/dtos/backoffice/digital-dossiers/upsert-digital-dossier-legal-representant-currency-cap.dto.ts
var import_class_validator50 = require("class-validator");
var import_types24 = __toESM(require_dist());
var getBackofficeUpsertDigitalDossierRepresentantCurrencyCapDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class UpsertDigitalDossierRepresentantCurrencyCapDto {
  }
  __decorateClass([
    (0, import_class_validator50.IsUUID)(),
    (0, import_class_validator50.IsOptional)(),
    ApiProperty({
      description: `Currency cap UUID.`,
      type: String,
      example: "96c9e11d-74aa-4675-b37d-e218ac1ff2ac"
    })
  ], UpsertDigitalDossierRepresentantCurrencyCapDto.prototype, "uuid", 2);
  __decorateClass([
    (0, import_class_validator50.IsEnum)(import_types24.CURRENCIES, {
      each: true,
      message: "TODO"
    }),
    (0, import_class_validator50.IsNotEmpty)({
      message: "class-validator.isNotEmpty.error"
    }),
    ApiProperty({
      description: "Currency",
      type: "enum",
      required: true,
      enum: import_types24.CURRENCIES,
      example: import_types24.CURRENCIES.USD
    })
  ], UpsertDigitalDossierRepresentantCurrencyCapDto.prototype, "currency", 2);
  __decorateClass([
    (0, import_class_validator50.IsNumber)(),
    (0, import_class_validator50.IsNotEmpty)({
      message: "class-validator.isNotEmpty.error"
    }),
    ApiProperty({
      description: "Currency cap",
      type: Number,
      required: true,
      example: 1e3
    })
  ], UpsertDigitalDossierRepresentantCurrencyCapDto.prototype, "cap", 2);
  return UpsertDigitalDossierRepresentantCurrencyCapDto;
};

// src/dtos/backoffice/digital-dossiers/upsert-digital-dossier-legal-representant.dto.ts
var getBackofficeUpsertDigitalDossierLegalRepresentantDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const isNotEmptyMessage = isFrontend ? "class-validator.isNotEmpty.error" : "This field is required";
  const startOfTermMustBeNewerThanEndOfTerm = "digitalDossier.legalRepresentatives.error.startOfTermMustBeNewerThanEndOfTerm";
  const endOfTermOlderMustBeThanStartOfTerm = "digitalDossier.legalRepresentatives.error.endOfTermMustBeOlderThanStartOfTerm";
  const _UpsertBase64ExtendedDocumentDto = getUpsertBase64ExtendedDocumentDto(ApiPropertySwagger);
  class UpsertBase64ExtendedDocumentDto extends _UpsertBase64ExtendedDocumentDto {
  }
  const _UpsertProductCapDto = getBackofficeUpsertDigitalDossierRepresentantProductCapDto(
    ApiPropertySwagger
  );
  class UpsertProductCapDto extends _UpsertProductCapDto {
  }
  const _UpsertCurrencyCapDto = getBackofficeUpsertDigitalDossierRepresentantCurrencyCapDto(
    ApiPropertySwagger
  );
  class UpsertCurrencyCapDto extends _UpsertCurrencyCapDto {
  }
  class UpsertDigitalDossierLegalRepresentantDto {
  }
  __decorateClass([
    (0, import_class_validator51.IsUUID)(),
    (0, import_class_validator51.IsOptional)(),
    ApiProperty({
      description: `Legal Representant UUID.`,
      type: String,
      example: "e28f0636-5ff1-43e1-b3c9-88fb1be6c53e"
    })
  ], UpsertDigitalDossierLegalRepresentantDto.prototype, "uuid", 2);
  __decorateClass([
    (0, import_class_validator51.IsString)(),
    (0, import_class_validator51.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: `Representant's first name.`,
      type: String,
      example: "John"
    })
  ], UpsertDigitalDossierLegalRepresentantDto.prototype, "firstName", 2);
  __decorateClass([
    (0, import_class_validator51.IsString)(),
    (0, import_class_validator51.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: `Representant's last name.`,
      type: String,
      example: "Doe"
    })
  ], UpsertDigitalDossierLegalRepresentantDto.prototype, "lastName", 2);
  __decorateClass([
    (0, import_class_validator51.IsEnum)(import_types25.IDENTITY_DOCUMENT_TYPES),
    (0, import_class_validator51.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      enum: import_types25.IDENTITY_DOCUMENT_TYPES,
      description: `Representant's Identity document type.`,
      required: true,
      example: import_types25.IDENTITY_DOCUMENT_TYPES.DNI
    })
  ], UpsertDigitalDossierLegalRepresentantDto.prototype, "identityDocumentType", 2);
  __decorateClass([
    (0, import_class_validator51.IsString)(),
    (0, import_class_validator51.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: `Representant's Identity document id.`,
      type: String,
      example: "AA123456"
    })
  ], UpsertDigitalDossierLegalRepresentantDto.prototype, "identityDocumentId", 2);
  __decorateClass([
    (0, import_class_validator51.IsEmail)(
      {},
      isFrontend ? { message: "class-validator.email.isEmail" } : void 0
    ),
    (0, import_class_validator51.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      type: String,
      description: `Representant's email.`,
      required: false,
      example: `john.doe@mycompany.org`
    })
  ], UpsertDigitalDossierLegalRepresentantDto.prototype, "email", 2);
  __decorateClass([
    (0, import_class_validator51.IsEnum)(import_types25.REPRESENTATIVE_POSITIONS),
    (0, import_class_validator51.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      enum: import_types25.REPRESENTATIVE_POSITIONS,
      description: `Representant's position within the company.`,
      required: true,
      example: import_types25.REPRESENTATIVE_POSITIONS.PRESIDENT
    })
  ], UpsertDigitalDossierLegalRepresentantDto.prototype, "position", 2);
  __decorateClass([
    IsLowerThan("endOfTerm", { message: startOfTermMustBeNewerThanEndOfTerm }),
    IsUnixTimestamp(),
    (0, import_class_validator51.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      type: String,
      description: `Representant's activity start date.`,
      required: true,
      example: "1715190536"
    })
  ], UpsertDigitalDossierLegalRepresentantDto.prototype, "startOfTerm", 2);
  __decorateClass([
    IsBiggerThan("startOfTerm", {
      message: endOfTermOlderMustBeThanStartOfTerm
    }),
    IsUnixTimestamp(),
    (0, import_class_validator51.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      type: String,
      description: `Representant's activity end date.`,
      required: true,
      example: "1715190536"
    })
  ], UpsertDigitalDossierLegalRepresentantDto.prototype, "endOfTerm", 2);
  __decorateClass([
    ValidateNested(UpsertBase64ExtendedDocumentDto),
    (0, import_class_validator51.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: "ID Document file to upload / update.",
      type: UpsertBase64ExtendedDocumentDto
    })
  ], UpsertDigitalDossierLegalRepresentantDto.prototype, "idDocument", 2);
  __decorateClass([
    (0, import_class_validator51.IsEnum)(import_types25.SIGNATURE_LEVELS),
    (0, import_class_validator51.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      enum: import_types25.SIGNATURE_LEVELS,
      description: `Representant's signature level.`,
      required: true,
      example: import_types25.SIGNATURE_LEVELS.ONE
    })
  ], UpsertDigitalDossierLegalRepresentantDto.prototype, "signatureLevel", 2);
  __decorateClass([
    (0, import_class_validator51.IsString)(),
    (0, import_class_validator51.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      description: `BC Document authorized legal representation identification`,
      type: String,
      example: "XXXXXX"
    })
  ], UpsertDigitalDossierLegalRepresentantDto.prototype, "bcAuthorizedDocumentIdentifier", 2);
  __decorateClass([
    (0, import_class_validator51.IsEnum)(import_types25.YES_NO_OPTIONS, {
      message: "YES or NO is required"
    }),
    (0, import_class_validator51.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      enum: import_types25.YES_NO_OPTIONS,
      description: "Indicates if user has power of attorney exchanges.",
      required: true
    })
  ], UpsertDigitalDossierLegalRepresentantDto.prototype, "hasPowerOfAttorneyExchanges", 2);
  __decorateClass([
    (0, import_class_validator51.ValidateIf)((o) => o.hasPowerOfAttorneyExchanges === import_types25.YES_NO_OPTIONS.YES),
    (0, import_class_validator51.IsArray)(),
    (0, import_class_validator51.ArrayMinSize)(1, {
      message: "Debe haber al menos un Poder por Bolsa."
    }),
    (0, import_class_validator51.IsEnum)(import_types25.POWER_OF_ATTORNEY_EXCHANGES, {
      each: true,
      message: "errorCode.createCompany.activity.isValid"
    }),
    ApiProperty({
      description: `Power of attorney exchanges`,
      type: Array,
      required: true,
      example: [
        import_types25.POWER_OF_ATTORNEY_EXCHANGES.GRAIN_EXCHANGE_BUENOS_AIRES,
        import_types25.POWER_OF_ATTORNEY_EXCHANGES.STOCK_EXCHANGE_ROSARIO
      ]
    })
  ], UpsertDigitalDossierLegalRepresentantDto.prototype, "powerOfAttorneyExchanges", 2);
  __decorateClass([
    (0, import_class_validator51.IsEnum)(import_types25.YES_NO_OPTIONS, {
      message: "YES or NO is required"
    }),
    (0, import_class_validator51.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      enum: import_types25.YES_NO_OPTIONS,
      description: "Indicates if user has product caps.",
      required: true
    })
  ], UpsertDigitalDossierLegalRepresentantDto.prototype, "hasProductCaps", 2);
  __decorateClass([
    (0, import_class_validator51.ValidateIf)((o) => o.hasProductCaps === import_types25.YES_NO_OPTIONS.YES),
    ValidateNested(UpsertProductCapDto, { each: true }),
    (0, import_class_validator51.ArrayMinSize)(1, {
      message: "Debe haber al menos un Tope por producto."
    })
  ], UpsertDigitalDossierLegalRepresentantDto.prototype, "productCaps", 2);
  __decorateClass([
    (0, import_class_validator51.IsEnum)(import_types25.YES_NO_OPTIONS, {
      message: "YES or NO is required"
    }),
    (0, import_class_validator51.IsNotEmpty)({ message: isNotEmptyMessage }),
    ApiProperty({
      enum: import_types25.YES_NO_OPTIONS,
      description: "Indicates if user has currency caps.",
      required: true
    })
  ], UpsertDigitalDossierLegalRepresentantDto.prototype, "hasCurrencyCaps", 2);
  __decorateClass([
    (0, import_class_validator51.ValidateIf)((o) => o.hasCurrencyCaps === import_types25.YES_NO_OPTIONS.YES),
    ValidateNested(UpsertCurrencyCapDto, { each: true }),
    (0, import_class_validator51.ArrayMinSize)(1, {
      message: "Debe haber al menos un tope por monto."
    })
  ], UpsertDigitalDossierLegalRepresentantDto.prototype, "currencyCaps", 2);
  return UpsertDigitalDossierLegalRepresentantDto;
};

// src/dtos/backoffice/digital-dossiers/upsert-digital-dossier-legal-representant-information.dto.ts
var getBackofficeUpsertDigitalDossierLegalRepresentantInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const _UpsertBackofficeDigitalDossierLegalRepresentantDto = getBackofficeUpsertDigitalDossierLegalRepresentantDto(ApiPropertySwagger);
  class UpsertBackofficeDigitalDossierLegalRepresentantDto extends _UpsertBackofficeDigitalDossierLegalRepresentantDto {
  }
  function WithUpsertBackofficeDigitalDossierLegalRepresentantInformationDto(Base) {
    class UpsertBackofficeDigitalDossierLegalRepresentantInformationDto extends Base {
    }
    __decorateClass([
      ValidateNested(UpsertBackofficeDigitalDossierLegalRepresentantDto, {
        each: true
      }),
      (0, import_class_validator52.ArrayMinSize)(1, {
        message: "Debe haber al menos un representante legal."
      }),
      ApiProperty({
        description: "List of legal representants",
        type: [UpsertBackofficeDigitalDossierLegalRepresentantDto],
        required: true
      })
    ], UpsertBackofficeDigitalDossierLegalRepresentantInformationDto.prototype, "legalRepresentants", 2);
    return UpsertBackofficeDigitalDossierLegalRepresentantInformationDto;
  }
  return {
    UpsertBackofficeDigitalDossierLegalRepresentantInformationDto: WithUpsertBackofficeDigitalDossierLegalRepresentantInformationDto(
      class {
      }
    )
  };
};

// src/dtos/backoffice/digital-dossiers/upsert-digital-dossier-forms-and-docs-information.dto.ts
var import_class_validator53 = require("class-validator");
var import_class_transformer26 = require("class-transformer");
var getBackofficeUpsertDigitalDossierFormsAndDocsInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const _UpsertBase64ExtendedDocumentDto = getUpsertBase64ExtendedDocumentDto(ApiPropertySwagger);
  class UpsertBase64ExtendedDocumentDto extends _UpsertBase64ExtendedDocumentDto {
  }
  function WithUpsertDigitalDossierFormsAndDocsInformationDto(Base) {
    class BackofficeUpsertDigitalDossierFormsAndDocsInformationDto extends Base {
    }
    __decorateClass([
      (0, import_class_validator53.IsOptional)(),
      (0, import_class_validator53.IsUUID)(),
      ApiProperty({
        description: `Forms and Docs Information UUID.`,
        type: String,
        example: "e28f0636-5ff1-43e1-b3c9-88fb1be6c53e",
        required: false
      })
    ], BackofficeUpsertDigitalDossierFormsAndDocsInformationDto.prototype, "uuid", 2);
    __decorateClass([
      (0, import_class_validator53.IsNotEmpty)({ message: "class-validator.isNotEmpty.error" }),
      ValidateNested(UpsertBase64ExtendedDocumentDto),
      ApiProperty({
        description: "SISA Document file to upload / update.",
        type: UpsertBase64ExtendedDocumentDto,
        required: true
      })
    ], BackofficeUpsertDigitalDossierFormsAndDocsInformationDto.prototype, "sisaFile", 2);
    __decorateClass([
      (0, import_class_validator53.IsOptional)(),
      (0, import_class_transformer26.Transform)(transformEmptyDocumentToUndefined),
      ValidateNested(UpsertBase64ExtendedDocumentDto),
      ApiProperty({
        description: "STATUTE Document file to upload / update.",
        type: UpsertBase64ExtendedDocumentDto,
        required: true
      })
    ], BackofficeUpsertDigitalDossierFormsAndDocsInformationDto.prototype, "statuteFile", 2);
    __decorateClass([
      (0, import_class_validator53.IsOptional)(),
      (0, import_class_transformer26.Transform)(transformEmptyDocumentToUndefined),
      ValidateNested(UpsertBase64ExtendedDocumentDto, { each: true }),
      ApiProperty({
        description: "STATUTE Change Documents files to upload / update.",
        type: Array(UpsertBase64ExtendedDocumentDto),
        required: false
      })
    ], BackofficeUpsertDigitalDossierFormsAndDocsInformationDto.prototype, "statuteChangeFiles", 2);
    __decorateClass([
      (0, import_class_validator53.IsOptional)(),
      (0, import_class_transformer26.Transform)(transformEmptyDocumentToUndefined),
      ValidateNested(UpsertBase64ExtendedDocumentDto, { each: true }),
      ApiProperty({
        description: "ASSEMBLY Board Documents files to upload / update.",
        type: Array(UpsertBase64ExtendedDocumentDto),
        required: false
      })
    ], BackofficeUpsertDigitalDossierFormsAndDocsInformationDto.prototype, "assemblyBoardMinutesFiles", 2);
    __decorateClass([
      (0, import_class_validator53.IsOptional)(),
      (0, import_class_transformer26.Transform)(transformEmptyDocumentToUndefined),
      ValidateNested(UpsertBase64ExtendedDocumentDto, { each: true }),
      ApiProperty({
        description: "POWER OF ATTORNEY Documents files to upload / update.",
        type: Array(UpsertBase64ExtendedDocumentDto),
        required: false
      })
    ], BackofficeUpsertDigitalDossierFormsAndDocsInformationDto.prototype, "powerOfAttorneyFiles", 2);
    __decorateClass([
      (0, import_class_validator53.MinLength)(1, {
        message: "N\xFAmero de caja archivo obligatorio: m\xEDnimo 1 car\xE1cter."
      }),
      ApiProperty({
        description: "N\xFAmero de caja archivo.",
        type: String,
        required: true,
        example: "A14534472"
      })
    ], BackofficeUpsertDigitalDossierFormsAndDocsInformationDto.prototype, "fileBoxNumber", 2);
    __decorateClass([
      (0, import_class_validator53.IsOptional)(),
      (0, import_class_transformer26.Transform)(transformEmptyDocumentToUndefined),
      ValidateNested(UpsertBase64ExtendedDocumentDto, { each: true }),
      ApiProperty({
        description: "ADDITIONAL DOCUMENTS files to upload / update.",
        type: Array(UpsertBase64ExtendedDocumentDto),
        required: false
      })
    ], BackofficeUpsertDigitalDossierFormsAndDocsInformationDto.prototype, "additionalDocumentFiles", 2);
    return BackofficeUpsertDigitalDossierFormsAndDocsInformationDto;
  }
  return {
    BackofficeUpsertDigitalDossierFormsAndDocsInformationDto: WithUpsertDigitalDossierFormsAndDocsInformationDto(class {
    })
  };
};

// src/dtos/backoffice/signup-requests/get-signup-requests.dto.ts
var import_class_validator54 = require("class-validator");
var import_class_transformer27 = require("class-transformer");
var import_types26 = __toESM(require_dist());
var getSignupRequestsDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  class GetSignupRequestsDto {
    constructor() {
      this.page = 1;
      this.pageSize = 10;
    }
  }
  __decorateClass([
    (0, import_class_transformer27.Transform)(({ value }) => String(value)),
    (0, import_class_validator54.IsString)(),
    (0, import_class_validator54.IsOptional)(),
    ApiProperty({
      description: "Search by company name and fiscalId",
      required: false,
      type: String
    })
  ], GetSignupRequestsDto.prototype, "search", 2);
  __decorateClass([
    (0, import_class_validator54.IsOptional)(),
    (0, import_class_validator54.IsArray)(),
    ApiProperty({
      description: "Signup Request status filter.",
      required: false,
      type: Array,
      items: { enum: import_types26.VALIDATION_STATUSES }
    })
  ], GetSignupRequestsDto.prototype, "statuses", 2);
  __decorateClass([
    (0, import_class_transformer27.Transform)(({ value }) => Number(value)),
    (0, import_class_validator54.IsNumber)(),
    (0, import_class_validator54.IsOptional)(),
    ApiProperty({
      description: "Page number.",
      required: false,
      type: Number
    })
  ], GetSignupRequestsDto.prototype, "page", 2);
  __decorateClass([
    (0, import_class_transformer27.Transform)(({ value }) => Number(value)),
    (0, import_class_validator54.IsNumber)(),
    (0, import_class_validator54.IsOptional)(),
    ApiProperty({
      description: "Items per page.",
      required: false,
      type: Number
    })
  ], GetSignupRequestsDto.prototype, "pageSize", 2);
  return GetSignupRequestsDto;
};

// src/dtos/backoffice/signup-requests/backoffice.reject-signup-request.dto.ts
var import_class_validator55 = require("class-validator");
var getRejectSignupRequestDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class RejectSignupRequestDto {
  }
  __decorateClass([
    (0, import_class_validator55.IsNotEmpty)({
      message: isFrontend ? "errorCode.signupRequest.rejectionReason.required" : "Rejection reason is required."
    }),
    (0, import_class_validator55.MaxLength)(200, {
      message: isFrontend ? "errorCode.signupRequest.rejectionReason.maxLength" : "Rejection reason max length is 200 characters."
    }),
    ApiProperty({
      description: "Rejection message.",
      required: true,
      type: String,
      example: "These are the rejection reasons..."
    })
  ], RejectSignupRequestDto.prototype, "rejectionMessage", 2);
  return RejectSignupRequestDto;
};

// src/dtos/backoffice/signup-requests/backoffice.change-request-signup.dto.ts
var import_class_validator58 = require("class-validator");

// src/dtos/backoffice/signup-requests/backoffice.change-request-update-legal-rep.dto.ts
var import_class_validator57 = require("class-validator");

// src/dtos/backoffice/signup-requests/backoffice.change-request-update-legal-rep-document.dto.ts
var import_types27 = __toESM(require_dist());
var import_class_validator56 = require("class-validator");
var getChangeRequestUpdateLegalRepDocumentDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class ChangeRequestUpdateLegalRepDocumentDto {
  }
  __decorateClass([
    (0, import_class_validator56.IsNotEmpty)(),
    (0, import_class_validator56.IsUUID)(),
    ApiProperty({
      description: `Representative UUID.`,
      required: true,
      type: String,
      example: "John7146c00c-cac0-49aa-b313-b716a897ba97"
    })
  ], ChangeRequestUpdateLegalRepDocumentDto.prototype, "uuid", 2);
  __decorateClass([
    (0, import_class_validator56.IsNotEmpty)(),
    (0, import_class_validator56.IsEnum)(import_types27.YES_NO_OPTIONS, {
      message: "YES or NO is required"
    }),
    ApiProperty({
      enum: import_types27.YES_NO_OPTIONS,
      description: "Indicates if changes where requested for this document.",
      required: true
    })
  ], ChangeRequestUpdateLegalRepDocumentDto.prototype, "requestChanges", 2);
  __decorateClass([
    (0, import_class_validator56.ValidateIf)((o) => o.requestChanges === import_types27.YES_NO_OPTIONS.YES),
    (0, import_class_validator56.IsNotEmpty)({
      message: isFrontend ? "errorCode.signupRequest.rejectionReason.required" : "Rejection reason is required."
    }),
    (0, import_class_validator56.MaxLength)(200, {
      message: isFrontend ? "errorCode.signupRequest.rejectionReason.maxLength" : "Rejection reason max length is 200 characters."
    }),
    ApiProperty({
      description: "Rejection message.",
      required: true,
      type: String,
      example: "These are the rejection reasons..."
    })
  ], ChangeRequestUpdateLegalRepDocumentDto.prototype, "rejectionMessage", 2);
  return ChangeRequestUpdateLegalRepDocumentDto;
};

// src/dtos/backoffice/signup-requests/backoffice.change-request-update-legal-rep.dto.ts
var getChangeRequestUpdateLegalRepDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const _ChangeRequestUpdateLegalRepDocumentDto = getChangeRequestUpdateLegalRepDocumentDto(ApiPropertySwagger);
  class ChangeRequestUpdateLegalRepDocumentDto extends _ChangeRequestUpdateLegalRepDocumentDto {
  }
  const _BackofficeRequestChangesDigitalDossierDto = getBackofficeRequestChangesDigitalDossierDto(ApiPropertySwagger);
  class BackofficeRequestChangesDigitalDossierDto extends _BackofficeRequestChangesDigitalDossierDto {
  }
  class ChangeRequestUpdateLegalRepDto extends BackofficeRequestChangesDigitalDossierDto {
  }
  __decorateClass([
    (0, import_class_validator57.IsNotEmpty)(),
    (0, import_class_validator57.IsUUID)(),
    ApiProperty({
      description: `Representative UUID.`,
      required: true,
      type: String,
      example: "John7146c00c-cac0-49aa-b313-b716a897ba97"
    })
  ], ChangeRequestUpdateLegalRepDto.prototype, "uuid", 2);
  __decorateClass([
    (0, import_class_validator57.ArrayMinSize)(1, {
      message: isFrontend ? "Debe haber al menos un documento a solicitar nuevamente." : "Must have at least one document to request again."
    }),
    (0, import_class_validator57.ArrayMaxSize)(2, {
      message: isFrontend ? "Debe haber como m\xE1ximo dos documentos a solicitar nuevamente." : "Must have up to two documents to request again."
    }),
    ValidateNested(ChangeRequestUpdateLegalRepDocumentDto, {
      each: true
    }),
    ApiProperty({
      description: "List of documents to request back, with their rejection message",
      type: [ChangeRequestUpdateLegalRepDocumentDto],
      required: true
    })
  ], ChangeRequestUpdateLegalRepDto.prototype, "documents", 2);
  return ChangeRequestUpdateLegalRepDto;
};

// src/dtos/backoffice/signup-requests/backoffice.change-request-signup.dto.ts
var getChangeRequestSignupDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const _ChangeRequestUpdateLegalRepDto = getChangeRequestUpdateLegalRepDto(ApiPropertySwagger);
  class ChangeRequestUpdateLegalRepDto extends _ChangeRequestUpdateLegalRepDto {
  }
  const isFrontend = typeof window !== "undefined";
  class ChangeRequestSignupDto {
  }
  __decorateClass([
    (0, import_class_validator58.ArrayMinSize)(1, {
      message: isFrontend ? "Debe haber al menos un representante legal." : "Must have at least one legal representative."
    }),
    (0, import_class_validator58.ArrayMaxSize)(2, {
      message: isFrontend ? "Debe haber como m\xE1ximo dos representantes legales." : "Must have up to two legal representatives."
    }),
    ValidateNested(ChangeRequestUpdateLegalRepDto, {
      each: true
    }),
    ApiProperty({
      description: "List of legal representatives to request back their documentation",
      type: [ChangeRequestUpdateLegalRepDto],
      required: true
    })
  ], ChangeRequestSignupDto.prototype, "legalRepresentatives", 2);
  return ChangeRequestSignupDto;
};

// src/dtos/backoffice/signup-requests/backoffice.update-signup-request.dto.ts
var import_types28 = __toESM(require_dist());
var import_class_validator60 = require("class-validator");

// src/dtos/common/property-decorators/fiscal-id.decorator.ts
var import_class_validator59 = require("class-validator");
var import_common_utils4 = require("@bcba/common-utils");
function FiscalId({ required }) {
  const isFrontend = typeof window !== "undefined";
  const decoratorsToApply = [];
  if (required) {
    decoratorsToApply.push(
      (0, import_class_validator59.IsNotEmpty)(
        isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
      )
    );
  }
  decoratorsToApply.push(
    (0, import_class_validator59.IsNumberString)(
      {},
      isFrontend ? { message: "class-validator.isNumber.error" } : void 0
    ),
    (0, import_class_validator59.Length)(11, 11, {
      message: isFrontend ? "errorCode.createCompany.fiscalId.minLength" : "Must have 11 Characters"
    }),
    (0, import_class_validator59.Matches)(import_common_utils4.REGEX_FORMAT_CUIT_CUIL, {
      message: "errorCode.fiscalIdInvalidFormat"
    })
  );
  return applyDecorators(...decoratorsToApply);
}

// src/dtos/common/property-decorators/company-fiscal-id.decorator.ts
function CompanyFiscalId({
  required,
  ApiPropertySwagger
}) {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  return applyDecorators(
    FiscalId({ required }),
    ApiProperty({
      description: "Company Fiscal Id",
      required,
      type: String,
      example: "AA1234411221"
    })
  );
}

// src/dtos/backoffice/signup-requests/backoffice.update-signup-request.dto.ts
var getUpdateSignupRequestDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const _UpdateSignupUserDto = getUpdateSignupUserDto(ApiPropertySwagger);
  class UpdateSignupUserDto extends _UpdateSignupUserDto {
  }
  const _UpdateSignupLegalRepresentativeDto = getUpdateSignupLegalRepresentativeDto(ApiPropertySwagger);
  class UpdateSignupLegalRepresentativeDto extends _UpdateSignupLegalRepresentativeDto {
  }
  class UpdateSignupRequestDto {
  }
  __decorateClass([
    CompanyFiscalId({ required: true, ApiPropertySwagger })
  ], UpdateSignupRequestDto.prototype, "companyFiscalId", 2);
  __decorateClass([
    (0, import_class_validator60.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator60.IsString)(),
    ApiProperty({
      description: "Company Name.",
      required: true,
      type: String,
      example: "My Company LLC"
    })
  ], UpdateSignupRequestDto.prototype, "companyName", 2);
  __decorateClass([
    (0, import_class_validator60.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator60.IsString)(),
    ApiProperty({
      description: "Company Street Name.",
      required: true,
      type: String,
      example: "18th Av."
    })
  ], UpdateSignupRequestDto.prototype, "companyStreetName", 2);
  __decorateClass([
    (0, import_class_validator60.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator60.IsNumberString)(
      {},
      isFrontend ? { message: "class-validator.isNumber.error" } : void 0
    ),
    ApiProperty({
      description: "Company Street Number.",
      required: true,
      type: String,
      example: "8558"
    })
  ], UpdateSignupRequestDto.prototype, "companyStreetNumber", 2);
  __decorateClass([
    (0, import_class_validator60.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator60.IsUUID)(),
    ApiProperty({
      description: "Company Province uuid.",
      required: true,
      type: String,
      example: "456af476-147c-4522-8388-2b0e46f41911"
    })
  ], UpdateSignupRequestDto.prototype, "companyProvinceUuid", 2);
  __decorateClass([
    (0, import_class_validator60.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator60.IsUUID)(),
    ApiProperty({
      description: "Company Locality uuid.",
      required: true,
      type: String,
      example: "79c62347-fba7-439f-9dda-26a7b98524c6"
    })
  ], UpdateSignupRequestDto.prototype, "companyLocalityUuid", 2);
  __decorateClass([
    (0, import_class_validator60.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator60.IsNumberString)(
      {},
      isFrontend ? { message: "class-validator.isNumber.error" } : void 0
    ),
    ApiProperty({
      description: "Company Postal Code.",
      required: true,
      type: String,
      example: "11150"
    })
  ], UpdateSignupRequestDto.prototype, "companyPostalCode", 2);
  __decorateClass([
    (0, import_class_validator60.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator60.IsEnum)(import_types28.EXCHANGES, {
      message: "errorCode.createSignUp.companyExchange.isValid"
    }),
    ApiProperty({
      enum: import_types28.EXCHANGES,
      description: "Company Exchange.",
      required: true,
      example: import_types28.EXCHANGES.BCBA
    })
  ], UpdateSignupRequestDto.prototype, "exchange", 2);
  __decorateClass([
    (0, import_class_validator60.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator60.IsEnum)(import_types28.COMPANY_TYPES),
    ApiProperty({
      enum: import_types28.COMPANY_TYPES,
      description: "Company Type.",
      required: true,
      example: import_types28.COMPANY_TYPES.SA
    })
  ], UpdateSignupRequestDto.prototype, "companyType", 2);
  __decorateClass([
    (0, import_class_validator60.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    ValidateNested(UpdateSignupUserDto, {
      each: true
    }),
    ApiProperty({
      description: "Administrator data",
      type: UpdateSignupUserDto,
      required: true
    })
  ], UpdateSignupRequestDto.prototype, "user", 2);
  __decorateClass([
    (0, import_class_validator60.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator60.ArrayMinSize)(1, {
      message: isFrontend ? "errorCode.createSignUp.representantMinLength" : "Must have at least one legal representative."
    }),
    (0, import_class_validator60.ArrayMaxSize)(2, {
      message: isFrontend ? "errorCode.createSignUp.representantMaxLength" : "Must have up to two legal representatives."
    }),
    ValidateNested(UpdateSignupLegalRepresentativeDto, {
      each: true
    }),
    ApiProperty({
      description: "List of legal representatives",
      type: [UpdateSignupLegalRepresentativeDto],
      required: true
    })
  ], UpdateSignupRequestDto.prototype, "representatives", 2);
  return UpdateSignupRequestDto;
};
var getUpdateSignupUserDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class UpdateSignupUserDto {
  }
  __decorateClass([
    (0, import_class_validator60.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator60.IsNumberString)(
      {},
      isFrontend ? { message: "class-validator.isNumber.error" } : void 0
    ),
    ApiProperty({
      description: `User's phone number.`,
      required: true,
      type: String,
      example: "999848488"
    })
  ], UpdateSignupUserDto.prototype, "phoneNumber", 2);
  return UpdateSignupUserDto;
};
var getUpdateSignupLegalRepresentativeDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class UpdateSignupLegalRepresentativeDto {
  }
  __decorateClass([
    (0, import_class_validator60.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator60.IsUUID)(),
    ApiProperty({
      description: `Representative UUID.`,
      required: true,
      type: String,
      example: "John7146c00c-cac0-49aa-b313-b716a897ba97"
    })
  ], UpdateSignupLegalRepresentativeDto.prototype, "uuid", 2);
  __decorateClass([
    (0, import_class_validator60.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator60.IsString)(),
    (0, import_class_validator60.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    ApiProperty({
      description: `Legal representative's first name.`,
      required: true,
      type: String,
      example: "John"
    })
  ], UpdateSignupLegalRepresentativeDto.prototype, "firstName", 2);
  __decorateClass([
    (0, import_class_validator60.IsString)(),
    (0, import_class_validator60.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    ApiProperty({
      description: `Legal representative's first name.`,
      required: true,
      type: String,
      example: "Doe"
    })
  ], UpdateSignupLegalRepresentativeDto.prototype, "lastName", 2);
  __decorateClass([
    (0, import_class_validator60.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator60.IsNumberString)(
      {},
      isFrontend ? { message: "class-validator.isNumber.error" } : void 0
    ),
    ApiProperty({
      description: `Legal representative's id document number.`,
      required: true,
      type: String,
      example: "123123123"
    })
  ], UpdateSignupLegalRepresentativeDto.prototype, "idDocumentNumber", 2);
  __decorateClass([
    (0, import_class_validator60.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator60.IsEnum)(import_types28.IDENTITY_DOCUMENT_TYPES, {
      message: "a valid identity document type is required"
    }),
    ApiProperty({
      enum: import_types28.IDENTITY_DOCUMENT_TYPES,
      description: "Representative ID Document Type.",
      required: true,
      example: import_types28.IDENTITY_DOCUMENT_TYPES.DNI
    })
  ], UpdateSignupLegalRepresentativeDto.prototype, "idDocumentType", 2);
  __decorateClass([
    (0, import_class_validator60.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator60.IsEnum)(import_types28.REPRESENTATIVE_POSITIONS, {
      message: "a valid representative position is required"
    }),
    ApiProperty({
      enum: import_types28.REPRESENTATIVE_POSITIONS,
      description: "Representative Position.",
      required: true,
      example: import_types28.REPRESENTATIVE_POSITIONS.PRESIDENT
    })
  ], UpdateSignupLegalRepresentativeDto.prototype, "position", 2);
  __decorateClass([
    (0, import_class_validator60.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator60.IsEmail)(
      {},
      isFrontend ? { message: "class-validator.email.isEmail" } : void 0
    ),
    ApiProperty({
      description: `Legal representative's email.`,
      required: true,
      type: String,
      example: "johndoe@example.com"
    })
  ], UpdateSignupLegalRepresentativeDto.prototype, "email", 2);
  return UpdateSignupLegalRepresentativeDto;
};

// src/dtos/backoffice/productive-facilities/backoffice.upsert-productive-faciltity.dto.ts
var import_class_validator61 = require("class-validator");
var getBackofficeUpsertProductiveFacilityDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const CommonUpsertProductiveFacilityDto = getCommonUpsertProductiveFacilityDto(ApiPropertySwagger);
  class BackofficeUpsertProductiveFacilityDto extends CommonUpsertProductiveFacilityDto {
  }
  __decorateClass([
    (0, import_class_validator61.IsUUID)("4"),
    ApiProperty({
      description: `Company UUID.`,
      type: Number,
      example: "6t581505-4e23-41b1-927a-3e5e4896e36c",
      required: true
    })
  ], BackofficeUpsertProductiveFacilityDto.prototype, "companyUuid", 2);
  return BackofficeUpsertProductiveFacilityDto;
};

// src/dtos/backoffice/storage-facilities/backoffice.upsert-storage-facility.dto.ts
var import_class_validator62 = require("class-validator");
var getBackofficeUpsertStorageFacilityDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const CommonUpsertStorageFacilityDto = getCommonUpsertStorageFacilityDto(ApiPropertySwagger);
  class BackofficeUpsertStorageFacilityDto extends CommonUpsertStorageFacilityDto {
  }
  __decorateClass([
    (0, import_class_validator62.IsUUID)("4"),
    ApiProperty({
      description: `Company UUID.`,
      type: Number,
      example: "6t581505-4e23-41b1-927a-3e5e4896e36c",
      required: true
    })
  ], BackofficeUpsertStorageFacilityDto.prototype, "companyUuid", 2);
  return BackofficeUpsertStorageFacilityDto;
};

// src/dtos/backoffice/company-queries-load-history/backoffice.create-company-queries-load-history-payload.dto.ts
var import_class_validator63 = require("class-validator");
var import_class_transformer28 = require("class-transformer");
var getCreateCompanyQueriesLoadHistoryDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const _CreateBase64DocumentDto = getCreateBase64DocumentDto(ApiPropertySwagger);
  class CreateBase64DocumentDto extends _CreateBase64DocumentDto {
  }
  class CreateCompanyQueriesLoadHistoryDto {
  }
  __decorateClass([
    (0, import_class_validator63.Min)(
      1,
      isFrontend ? { message: "common.error.greaterOrEqualThanOne" } : void 0
    ),
    (0, import_class_validator63.IsNumber)(
      void 0,
      isFrontend ? { message: "common.error.greaterOrEqualThanOne" } : void 0
    ),
    ApiProperty({
      description: "Amount to be added.",
      required: true,
      type: Number
    })
  ], CreateCompanyQueriesLoadHistoryDto.prototype, "amount", 2);
  __decorateClass([
    (0, import_class_transformer28.Expose)(),
    (0, import_class_validator63.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    ValidateNested(CreateBase64DocumentDto),
    ApiProperty({
      description: "File",
      required: true,
      type: CreateBase64DocumentDto
    })
  ], CreateCompanyQueriesLoadHistoryDto.prototype, "file", 2);
  __decorateClass([
    (0, import_class_transformer28.Expose)(),
    (0, import_class_validator63.IsNumber)(),
    (0, import_class_validator63.IsNotEmpty)(),
    ApiProperty({
      description: "companyId ",
      type: Number
    })
  ], CreateCompanyQueriesLoadHistoryDto.prototype, "companyId", 2);
  return CreateCompanyQueriesLoadHistoryDto;
};

// src/dtos/explorer/access-requests/get-sent-access-requests.dto.ts
var import_class_transformer29 = require("class-transformer");
var import_class_validator64 = require("class-validator");
var getSentAccessRequestsDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  class GetSentAccessRequestsDto {
    constructor() {
      this.page = 1;
      this.pageSize = 10;
    }
  }
  __decorateClass([
    (0, import_class_transformer29.Transform)(({ value }) => Number(value)),
    (0, import_class_validator64.IsNumber)(),
    (0, import_class_validator64.IsOptional)(),
    ApiProperty({
      description: "Page number.",
      required: false,
      type: Number
    })
  ], GetSentAccessRequestsDto.prototype, "page", 2);
  __decorateClass([
    (0, import_class_transformer29.Transform)(({ value }) => Number(value)),
    (0, import_class_validator64.IsNumber)(),
    (0, import_class_validator64.IsOptional)(),
    ApiProperty({
      description: "Items per page.",
      required: false,
      type: Number
    })
  ], GetSentAccessRequestsDto.prototype, "pageSize", 2);
  return GetSentAccessRequestsDto;
};

// src/dtos/explorer/access-requests/get-received-access-requests.dto.ts
var import_class_transformer30 = require("class-transformer");
var import_class_validator65 = require("class-validator");
var import_types29 = __toESM(require_dist());
var getReceivedAccessRequestsDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const _PaginateDto = getPaginateDto(ApiPropertySwagger);
  class PaginateDto extends _PaginateDto {
  }
  class GetReceivedAccessRequestsDto extends PaginateDto {
  }
  __decorateClass([
    (0, import_class_transformer30.Transform)(({ value }) => String(value)),
    (0, import_class_validator65.IsString)(),
    (0, import_class_validator65.IsOptional)(),
    ApiProperty({
      description: "Search by requesting company name and fiscalId",
      required: false,
      type: String
    })
  ], GetReceivedAccessRequestsDto.prototype, "search", 2);
  __decorateClass([
    (0, import_class_validator65.IsOptional)(),
    (0, import_class_validator65.IsArray)(),
    ApiProperty({
      description: "Signup Request status filter.",
      required: false,
      type: Array,
      items: { enum: import_types29.VALIDATION_STATUSES }
    })
  ], GetReceivedAccessRequestsDto.prototype, "statuses", 2);
  return GetReceivedAccessRequestsDto;
};

// src/dtos/explorer/access-requests/update-access-request-dto.ts
var import_types30 = __toESM(require_dist());
var import_class_validator66 = require("class-validator");
var getExplorerUpdateAccessRequestDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class GetExplorerUpdateAccessRequestDto {
  }
  __decorateClass([
    (0, import_class_validator66.IsOptional)(),
    (0, import_class_validator66.IsEnum)(import_types30.DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS, {
      message: isFrontend ? "errorCode.accessRequest.update.status.isValid" : "Must be a valid Access Request status"
    }),
    ApiProperty({
      description: `Access Request Status`,
      type: "enum",
      enum: import_types30.DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS,
      required: true,
      example: import_types30.DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS.APPROVED
    })
  ], GetExplorerUpdateAccessRequestDto.prototype, "status", 2);
  __decorateClass([
    (0, import_class_validator66.IsOptional)(),
    (0, import_class_validator66.IsArray)(),
    (0, import_class_validator66.IsEnum)(import_types30.DIGITAL_DOSSIER_SECTIONS, {
      each: true,
      message: isFrontend ? "errorCode.accessRequest.update.accessibleSection.isValid" : "Must be a valid Accessible Section"
    }),
    ApiProperty({
      description: `Digital dossier sections accessible to the viewer company.`,
      type: "enum",
      enum: import_types30.DIGITAL_DOSSIER_SECTIONS,
      required: false,
      example: [import_types30.DIGITAL_DOSSIER_SECTIONS.CONTACT_INFORMATION]
    })
  ], GetExplorerUpdateAccessRequestDto.prototype, "accessibleSections", 2);
  return GetExplorerUpdateAccessRequestDto;
};

// src/dtos/explorer/access-requests/search-dossiers.dto.ts
var import_class_transformer31 = require("class-transformer");
var import_class_validator67 = require("class-validator");
var getExplorerSearchDossierDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const minLength2Message = "errorCode.minLength.2";
  class ExplorerSearchDossierDto {
    constructor() {
      this.page = 1;
      this.pageSize = 3;
    }
  }
  __decorateClass([
    (0, import_class_transformer31.Transform)(({ value }) => String(value)),
    (0, import_class_validator67.IsString)(),
    (0, import_class_validator67.MinLength)(2, {
      message: isFrontend ? minLength2Message : "Must be at least 2 characters"
    }),
    ApiProperty({
      description: "Search by company name or fiscal Id (partial)",
      required: true,
      type: String,
      example: "My Company "
    })
  ], ExplorerSearchDossierDto.prototype, "search", 2);
  __decorateClass([
    (0, import_class_transformer31.Transform)(({ value }) => Number(value)),
    (0, import_class_validator67.IsNumber)(),
    (0, import_class_validator67.IsOptional)(),
    ApiProperty({
      description: "Page number.",
      required: false,
      type: Number,
      example: 1
    })
  ], ExplorerSearchDossierDto.prototype, "page", 2);
  __decorateClass([
    (0, import_class_transformer31.Transform)(({ value }) => Number(value)),
    (0, import_class_validator67.IsNumber)(),
    (0, import_class_validator67.IsOptional)(),
    ApiProperty({
      description: "Items per page.",
      required: false,
      type: Number,
      example: 3
    })
  ], ExplorerSearchDossierDto.prototype, "pageSize", 2);
  return ExplorerSearchDossierDto;
};

// src/dtos/explorer/access-requests/create-access-request.dto.ts
var import_class_validator68 = require("class-validator");
var getExplorerCreateAccessRequestDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  class getExplorerCreateAccessRequestDto2 {
  }
  __decorateClass([
    (0, import_class_validator68.IsUUID)("4"),
    ApiProperty({
      description: `Requested to Company UUID.`,
      type: String,
      required: true,
      example: "96c9e11d-74aa-4675-b37d-e218ac1ff2ac"
    })
  ], getExplorerCreateAccessRequestDto2.prototype, "uuid", 2);
  return getExplorerCreateAccessRequestDto2;
};

// src/dtos/explorer/companies/upsert-company-contact-information.dto.ts
var import_class_transformer32 = require("class-transformer");
var import_class_validator69 = require("class-validator");
var getUpsertCompanyContactInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class UpsertCompanyContactInformationDto {
  }
  __decorateClass([
    (0, import_class_validator69.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator69.IsString)(),
    ApiProperty({
      description: "Company Street Name.",
      required: true,
      type: String,
      example: "18th Av."
    })
  ], UpsertCompanyContactInformationDto.prototype, "street", 2);
  __decorateClass([
    (0, import_class_validator69.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator69.IsNumberString)(
      void 0,
      isFrontend ? { message: "class-validator.isNumber.error" } : void 0
    ),
    ApiProperty({
      description: "Company Street Number.",
      required: true,
      type: String,
      example: "8558"
    })
  ], UpsertCompanyContactInformationDto.prototype, "streetNumber", 2);
  __decorateClass([
    (0, import_class_validator69.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator69.IsUUID)(),
    ApiProperty({
      description: "Company Province uuid.",
      required: true,
      type: String,
      example: "456af476-147c-4522-8388-2b0e46f41911"
    })
  ], UpsertCompanyContactInformationDto.prototype, "provinceUuid", 2);
  __decorateClass([
    (0, import_class_validator69.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator69.IsUUID)(),
    ApiProperty({
      description: "Company Locality uuid.",
      required: true,
      type: String,
      example: "79c62347-fba7-439f-9dda-26a7b98524c6"
    })
  ], UpsertCompanyContactInformationDto.prototype, "localityUuid", 2);
  __decorateClass([
    (0, import_class_validator69.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator69.IsString)(),
    ApiProperty({
      description: "Company Postal Code.",
      required: true,
      type: String,
      example: "11150"
    })
  ], UpsertCompanyContactInformationDto.prototype, "postalCode", 2);
  __decorateClass([
    (0, import_class_validator69.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "User phone number is required"
    }),
    (0, import_class_validator69.IsNumberString)(
      void 0,
      isFrontend ? { message: "class-validator.isNumber.error" } : void 0
    ),
    ApiProperty({
      description: `User's phone number.`,
      required: true,
      type: String
    })
  ], UpsertCompanyContactInformationDto.prototype, "phoneNumber", 2);
  __decorateClass([
    (0, import_class_validator69.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "Email address is required"
    }),
    (0, import_class_validator69.IsEmail)(
      {},
      {
        message: isFrontend ? "class-validator.email.isEmail" : "A valid email address is required"
      }
    ),
    ApiProperty({
      description: "User email address.",
      required: true,
      type: String,
      example: "john.doe@mycompany.org"
    })
  ], UpsertCompanyContactInformationDto.prototype, "email", 2);
  __decorateClass([
    (0, import_class_transformer32.Transform)(({ value }) => Boolean(value) ? value : void 0),
    (0, import_class_validator69.IsUrl)(
      {
        protocols: ["http", "https"],
        require_protocol: false
      },
      {
        message: isFrontend ? "class-validator.url.isURL" : "A valid URL is required"
      }
    ),
    (0, import_class_validator69.IsOptional)(),
    ApiProperty({
      description: "User website.",
      required: false,
      type: String,
      example: "www.google.com"
    })
  ], UpsertCompanyContactInformationDto.prototype, "website", 2);
  return UpsertCompanyContactInformationDto;
};

// src/dtos/explorer/companies/upsert-company-equity-information.dto.ts
var import_class_validator70 = require("class-validator");
var import_class_transformer33 = require("class-transformer");
var getUpsertCompanyEquityInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const _UpsertBase64DocumentDto = getUpsertBase64DocumentDto(ApiPropertySwagger);
  class UpsertBase64DocumentDto extends _UpsertBase64DocumentDto {
  }
  class ExplorerUpsertCompanyEquityInformationDto {
  }
  __decorateClass([
    (0, import_class_validator70.IsOptional)(),
    (0, import_class_transformer33.Transform)(transformEmptyDocumentToUndefined),
    (0, import_class_validator70.ValidateIf)((o) => o?.balanceDocuments?.length > 0),
    ValidateNested(UpsertBase64DocumentDto, { each: true }),
    ApiProperty({
      description: "Balance documents files to upload / update.",
      type: Array(UpsertBase64DocumentDto),
      required: false
    })
  ], ExplorerUpsertCompanyEquityInformationDto.prototype, "balanceDocuments", 2);
  __decorateClass([
    (0, import_class_validator70.IsOptional)(),
    (0, import_class_transformer33.Transform)(transformEmptyDocumentToUndefined),
    (0, import_class_validator70.ValidateIf)((o) => o?.additionalDocuments?.length > 0),
    ValidateNested(UpsertBase64DocumentDto, { each: true }),
    ApiProperty({
      description: "Additional files to upload / update",
      type: [UpsertBase64DocumentDto],
      required: false
    })
  ], ExplorerUpsertCompanyEquityInformationDto.prototype, "additionalDocuments", 2);
  return ExplorerUpsertCompanyEquityInformationDto;
};

// src/dtos/explorer/digital-dossiers/explorer.upsert-digital-dossier-banking-information.dto.ts
var import_class_validator72 = require("class-validator");

// src/dtos/explorer/digital-dossiers/explorer.upsert-digital-dossier-bank-account.dto.ts
var import_class_validator71 = require("class-validator");
var getExplorerUpsertDigitalDossierBankAccountDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const _UpsertBase64DocumentDto = getUpsertBase64DocumentDto(ApiPropertySwagger);
  class UpsertBase64DocumentDto extends _UpsertBase64DocumentDto {
  }
  class UpsertDigitalDossierBankAccountDto {
  }
  __decorateClass([
    (0, import_class_validator71.IsOptional)(),
    (0, import_class_validator71.IsUUID)(),
    ApiProperty({
      description: `Bank account UUID.`,
      type: String,
      example: "96c9e11d-74aa-4675-b37d-e218ac1ff2ac"
    })
  ], UpsertDigitalDossierBankAccountDto.prototype, "uuid", 2);
  __decorateClass([
    (0, import_class_validator71.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator71.Length)(22, 22, {
      message: isFrontend ? "errorCode.digitalDossier.updateBankingInfo.cbu.length" : "Must be 22 characters"
    }),
    (0, import_class_validator71.IsString)(),
    ApiProperty({
      description: `Account's CBU.`,
      type: String,
      example: "6540940411100063886749",
      required: true
    })
  ], UpsertDigitalDossierBankAccountDto.prototype, "cbu", 2);
  __decorateClass([
    (0, import_class_validator71.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator71.IsString)(),
    ApiProperty({
      description: `Account's Bank entity.`,
      type: String,
      example: "Santander",
      required: true
    })
  ], UpsertDigitalDossierBankAccountDto.prototype, "bankEntity", 2);
  __decorateClass([
    (0, import_class_validator71.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    ValidateNested(UpsertBase64DocumentDto),
    ApiProperty({
      description: "ID Document file to update",
      type: UpsertBase64DocumentDto,
      required: true
    })
  ], UpsertDigitalDossierBankAccountDto.prototype, "cbuDocument", 2);
  return UpsertDigitalDossierBankAccountDto;
};

// src/dtos/explorer/digital-dossiers/explorer.upsert-digital-dossier-banking-information.dto.ts
var import_types31 = __toESM(require_dist());
var getExplorerUpsertDigitalDossierBankingInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const _UpsertDigitalDossierBankAccountDto = getExplorerUpsertDigitalDossierBankAccountDto(ApiPropertySwagger);
  class UpsertDigitalDossierBankAccountDto extends _UpsertDigitalDossierBankAccountDto {
  }
  function WithUpsertDigitalDossierBankingInformationDto(Base) {
    class UpsertDigitalDossierBankingInformationDto extends Base {
    }
    __decorateClass([
      (0, import_class_validator72.IsNotEmpty)(),
      (0, import_class_validator72.IsEnum)(import_types31.YES_NO_OPTIONS, {
        message: "YES or NO is required"
      }),
      ApiProperty({
        enum: import_types31.YES_NO_OPTIONS,
        description: "Indicates if user has banking info.",
        required: true
      })
    ], UpsertDigitalDossierBankingInformationDto.prototype, "hasBankingInfo", 2);
    __decorateClass([
      (0, import_class_validator72.ValidateIf)((o) => o.hasBankingInfo === import_types31.YES_NO_OPTIONS.YES),
      ValidateNested(UpsertDigitalDossierBankAccountDto, { each: true }),
      (0, import_class_validator72.ArrayMinSize)(1, {
        message: "Debe haber al menos una cuenta bancaria."
      }),
      (0, import_class_validator72.IsNotEmpty)(),
      ApiProperty({
        description: "List of bank accounts",
        type: [UpsertDigitalDossierBankAccountDto],
        required: true
      })
    ], UpsertDigitalDossierBankingInformationDto.prototype, "accounts", 2);
    return UpsertDigitalDossierBankingInformationDto;
  }
  return {
    UpsertDigitalDossierBankingInformationDto: WithUpsertDigitalDossierBankingInformationDto(class {
    })
  };
};

// src/dtos/explorer/digital-dossiers/explorer.update-digital-dossier-tax-information.dto.ts
var import_class_validator73 = require("class-validator");
var import_types32 = __toESM(require_dist());
var import_class_transformer34 = require("class-transformer");
var getExplorerUpdateDigitalDossierTaxInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== void 0;
  const _UpsertBase64DocumentDto = getUpsertBase64DocumentDto(ApiPropertySwagger);
  class UpsertBase64DocumentDto extends _UpsertBase64DocumentDto {
  }
  class UpdateDigitalDossierTaxInformationDto {
  }
  __decorateClass([
    ValidateNested(UpsertBase64DocumentDto),
    ApiProperty({
      description: "CUIT proof file to update",
      type: UpsertBase64DocumentDto,
      required: true
    })
  ], UpdateDigitalDossierTaxInformationDto.prototype, "cuitDocument", 2);
  __decorateClass([
    (0, import_class_validator73.IsEnum)(
      import_types32.IVA_CONDITION,
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    ApiProperty({
      enum: import_types32.IVA_CONDITION,
      description: "IVA Condition.",
      required: true,
      example: import_types32.IVA_CONDITION.IVA_REGISTERED_RESPONSIBLE
    })
  ], UpdateDigitalDossierTaxInformationDto.prototype, "ivaCondition", 2);
  __decorateClass([
    (0, import_class_validator73.IsEnum)(
      import_types32.BRUTE_INCOME_TYPES,
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    ApiProperty({
      enum: import_types32.BRUTE_INCOME_TYPES,
      description: "Brute income.",
      required: true,
      example: import_types32.BRUTE_INCOME_TYPES.LOCAL_JURISDICTION
    })
  ], UpdateDigitalDossierTaxInformationDto.prototype, "bruteIncome", 2);
  __decorateClass([
    (0, import_class_validator73.IsOptional)(),
    (0, import_class_validator73.IsArray)(),
    (0, import_class_validator73.IsEnum)(import_types32.PROVINCES, {
      each: true,
      message: "Debe ser una jurisdicci\xF3n v\xE1lida"
    }),
    ApiProperty({
      description: `Jurisdictions`,
      type: "enum",
      required: false,
      enum: import_types32.PROVINCES,
      example: [import_types32.PROVINCES.CHACO, import_types32.PROVINCES.NEUQUEN]
    })
  ], UpdateDigitalDossierTaxInformationDto.prototype, "jurisdictions", 2);
  __decorateClass([
    ValidateNested(UpsertBase64DocumentDto),
    ApiProperty({
      description: "IIBB file to update",
      type: UpsertBase64DocumentDto,
      required: true
    })
  ], UpdateDigitalDossierTaxInformationDto.prototype, "iibbDocument", 2);
  __decorateClass([
    (0, import_class_validator73.IsEnum)(
      import_types32.PROFIT_TYPES,
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    ApiProperty({
      enum: import_types32.PROFIT_TYPES,
      description: "Profits tax",
      required: true,
      example: import_types32.PROFIT_TYPES.REGISTERED
    })
  ], UpdateDigitalDossierTaxInformationDto.prototype, "profits", 2);
  __decorateClass([
    ValidateNested(UpsertBase64DocumentDto),
    ApiProperty({
      description: "Profits file to update",
      type: UpsertBase64DocumentDto,
      required: true
    })
  ], UpdateDigitalDossierTaxInformationDto.prototype, "profitsDocument", 2);
  __decorateClass([
    (0, import_class_validator73.IsOptional)(),
    (0, import_class_transformer34.Transform)(transformEmptyDocumentToUndefined),
    ValidateNested(UpsertBase64DocumentDto),
    ApiProperty({
      description: "CM05 file to update",
      type: UpsertBase64DocumentDto,
      required: false
    })
  ], UpdateDigitalDossierTaxInformationDto.prototype, "cm05Document", 2);
  __decorateClass([
    (0, import_class_validator73.IsOptional)(),
    (0, import_class_transformer34.Transform)(transformEmptyDocumentToUndefined),
    ValidateNested(UpsertBase64DocumentDto),
    ApiProperty({
      description: "Exemptions file to update",
      type: UpsertBase64DocumentDto,
      required: false
    })
  ], UpdateDigitalDossierTaxInformationDto.prototype, "exemptionsDocument", 2);
  __decorateClass([
    (0, import_class_validator73.IsOptional)(),
    (0, import_class_transformer34.Transform)(transformEmptyDocumentToUndefined),
    ValidateNested(UpsertBase64DocumentDto, { each: true }),
    ApiProperty({
      description: "Additional files to update",
      type: [UpsertBase64DocumentDto],
      required: false
    })
  ], UpdateDigitalDossierTaxInformationDto.prototype, "additionalDocuments", 2);
  return UpdateDigitalDossierTaxInformationDto;
};

// src/dtos/explorer/digital-dossiers/explorer.update-digital-dossier-general-information.dto.ts
var import_types33 = __toESM(require_dist());
var import_class_validator74 = require("class-validator");
var getExplorerUpdateDigitalDossierGeneralInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class UpdateDigitalDossierGeneralInformationDto {
  }
  __decorateClass([
    (0, import_class_validator74.IsArray)(),
    (0, import_class_validator74.IsEnum)(import_types33.COMPANY_ACTIVITIES, {
      each: true,
      message: "errorCode.createCompany.activity.isValid"
    }),
    (0, import_class_validator74.ArrayNotEmpty)({
      message: "class-validator.isNotEmpty.error"
    }),
    (0, import_class_validator74.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "This field is required"
    }),
    ApiProperty({
      description: `Company main activities`,
      type: "enum",
      enum: import_types33.COMPANY_ACTIVITIES,
      required: true,
      example: [
        import_types33.COMPANY_ACTIVITIES.PRODUCER,
        import_types33.COMPANY_ACTIVITIES.OPERATOR_WITH_PLANT
      ]
    })
  ], UpdateDigitalDossierGeneralInformationDto.prototype, "mainActivities", 2);
  return UpdateDigitalDossierGeneralInformationDto;
};

// src/dtos/explorer/digital-dossiers/explorer.update-digital-dossier-legal-representative-information.dto.ts
var getExplorerUpdateDigitalDossierLegalRepresentativeInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  class UpdateDigitalDossierLegalRepresentativeInformationDto {
  }
  return UpdateDigitalDossierLegalRepresentativeInformationDto;
};

// src/dtos/explorer/digital-dossiers/explorer.update-digital-dossier-forms-docs.dto.ts
var getExplorerUpdateDigitalDossierFormDocsDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  class UpdateDigitalDossierFormDocsDto {
  }
  return UpdateDigitalDossierFormDocsDto;
};

// src/dtos/explorer/digital-dossiers/explorer.upsert-digital-dossier-legal-representant.dto.ts
var import_class_validator75 = require("class-validator");
var getExplorerUpsertDigitalDossierLegalRepresentantDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class UpsertDigitalDossierLegalRepresentantDto {
  }
  __decorateClass([
    (0, import_class_validator75.IsUUID)(),
    ApiProperty({
      description: `Legal Representant UUID.`,
      type: String,
      example: "e28f0636-5ff1-43e1-b3c9-88fb1be6c53e"
    })
  ], UpsertDigitalDossierLegalRepresentantDto.prototype, "uuid", 2);
  __decorateClass([
    (0, import_class_validator75.IsEmail)(
      {},
      isFrontend ? { message: "class-validator.email.isEmail" } : void 0
    ),
    (0, import_class_validator75.IsNotEmpty)({
      message: isFrontend ? "class-validator.isNotEmpty.error" : "This field is required"
    }),
    ApiProperty({
      type: String,
      description: `Representant's email.`,
      required: false,
      example: `john.doe@mycompany.org`
    })
  ], UpsertDigitalDossierLegalRepresentantDto.prototype, "email", 2);
  return UpsertDigitalDossierLegalRepresentantDto;
};

// src/dtos/explorer/digital-dossiers/explorer.upsert-digital-dossier-legal-representant-information.dto.ts
var import_class_validator76 = require("class-validator");
var getExplorerUpsertDigitalDossierLegalRepresentantInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const _UpsertExplorerDigitalDossierLegalRepresentantDto = getExplorerUpsertDigitalDossierLegalRepresentantDto(ApiPropertySwagger);
  class UpsertExplorerDigitalDossierLegalRepresentantDto extends _UpsertExplorerDigitalDossierLegalRepresentantDto {
  }
  function WithUpsertExplorerDigitalDossierLegalRepresentantInformationDto(Base) {
    class UpsertExplorerDigitalDossierLegalRepresentantInformationDto extends Base {
    }
    __decorateClass([
      ValidateNested(UpsertExplorerDigitalDossierLegalRepresentantDto, {
        each: true
      }),
      (0, import_class_validator76.ArrayMinSize)(1, {
        message: "Debe haber al menos un representante legal."
      }),
      (0, import_class_validator76.ArrayMaxSize)(2, {
        message: "Debe haber como m\xE1ximo 2 representantes legales."
      }),
      ApiProperty({
        description: "List of legal representants",
        type: [UpsertExplorerDigitalDossierLegalRepresentantDto],
        required: true
      })
    ], UpsertExplorerDigitalDossierLegalRepresentantInformationDto.prototype, "legalRepresentants", 2);
    return UpsertExplorerDigitalDossierLegalRepresentantInformationDto;
  }
  return {
    UpsertExplorerDigitalDossierLegalRepresentantInformationDto: WithUpsertExplorerDigitalDossierLegalRepresentantInformationDto(class {
    })
  };
};

// src/dtos/explorer/digital-dossiers/explorer.upsert-digital-dossier-forms-and-docs-information.dto.ts
var import_class_validator77 = require("class-validator");
var import_class_transformer35 = require("class-transformer");
var getExplorerUpsertDigitalDossierFormsAndDocsInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const _UpsertBase64DocumentDto = getUpsertBase64DocumentDto(ApiPropertySwagger);
  class UpsertBase64DocumentDto extends _UpsertBase64DocumentDto {
  }
  function WithUpsertDigitalDossierFormsAndDocsInformationDto(Base) {
    class ExplorerUpsertDigitalDossierFormsAndDocsInformationDto extends Base {
    }
    __decorateClass([
      (0, import_class_transformer35.Expose)(),
      (0, import_class_validator77.IsOptional)(),
      (0, import_class_validator77.IsUUID)(),
      ApiProperty({
        description: `Forms and Docs Information UUID.`,
        type: String,
        example: "e28f0636-5ff1-43e1-b3c9-88fb1be6c53e",
        required: false
      })
    ], ExplorerUpsertDigitalDossierFormsAndDocsInformationDto.prototype, "uuid", 2);
    __decorateClass([
      (0, import_class_transformer35.Expose)(),
      ValidateNested(UpsertBase64DocumentDto),
      ApiProperty({
        description: "SISA Document file to upload / update.",
        type: UpsertBase64DocumentDto,
        required: true
      })
    ], ExplorerUpsertDigitalDossierFormsAndDocsInformationDto.prototype, "sisaFile", 2);
    __decorateClass([
      (0, import_class_transformer35.Expose)(),
      (0, import_class_validator77.IsOptional)(),
      (0, import_class_transformer35.Transform)(transformEmptyDocumentToUndefined),
      ValidateNested(UpsertBase64DocumentDto),
      ApiProperty({
        description: "STATUTE Document file to upload / update.",
        type: UpsertBase64DocumentDto,
        required: true
      })
    ], ExplorerUpsertDigitalDossierFormsAndDocsInformationDto.prototype, "statuteFile", 2);
    __decorateClass([
      (0, import_class_transformer35.Expose)(),
      (0, import_class_validator77.IsOptional)(),
      (0, import_class_transformer35.Transform)(transformEmptyDocumentToUndefined),
      ValidateNested(UpsertBase64DocumentDto, { each: true }),
      ApiProperty({
        description: "STATUTE Change Documents files to upload / update.",
        type: Array(UpsertBase64DocumentDto),
        required: false
      })
    ], ExplorerUpsertDigitalDossierFormsAndDocsInformationDto.prototype, "statuteChangeFiles", 2);
    __decorateClass([
      (0, import_class_transformer35.Expose)(),
      (0, import_class_validator77.ArrayMinSize)(1, {
        message: "Debe haber al menos 1 archivo de actas de asamblea y directorio."
      }),
      (0, import_class_validator77.IsOptional)(),
      (0, import_class_transformer35.Transform)(transformEmptyDocumentToUndefined),
      ValidateNested(UpsertBase64DocumentDto, { each: true }),
      ApiProperty({
        description: "ASSEMBLY Board Documents files to upload / update.",
        type: Array(UpsertBase64DocumentDto),
        required: true
      })
    ], ExplorerUpsertDigitalDossierFormsAndDocsInformationDto.prototype, "assemblyBoardMinutesFiles", 2);
    __decorateClass([
      (0, import_class_transformer35.Expose)(),
      (0, import_class_validator77.IsOptional)(),
      (0, import_class_transformer35.Transform)(transformEmptyDocumentToUndefined),
      ValidateNested(UpsertBase64DocumentDto, { each: true }),
      ApiProperty({
        description: "POWER OF ATTORNEY Documents files to upload / update.",
        type: Array(UpsertBase64DocumentDto),
        required: false
      })
    ], ExplorerUpsertDigitalDossierFormsAndDocsInformationDto.prototype, "powerOfAttorneyFiles", 2);
    __decorateClass([
      (0, import_class_transformer35.Expose)(),
      (0, import_class_validator77.IsOptional)(),
      (0, import_class_transformer35.Transform)(transformEmptyDocumentToUndefined),
      ValidateNested(UpsertBase64DocumentDto, { each: true }),
      ApiProperty({
        description: "ADDITIONAL DOCUMENTS files to upload / update.",
        type: Array(UpsertBase64DocumentDto),
        required: false
      })
    ], ExplorerUpsertDigitalDossierFormsAndDocsInformationDto.prototype, "additionalDocumentFiles", 2);
    return ExplorerUpsertDigitalDossierFormsAndDocsInformationDto;
  }
  return {
    ExplorerUpsertDigitalDossierFormsAndDocsInformationDto: WithUpsertDigitalDossierFormsAndDocsInformationDto(class {
    })
  };
};

// src/dtos/explorer/signup-requests/explorer.update-sign-up.dto.ts
var import_class_validator79 = require("class-validator");

// src/dtos/explorer/signup-requests/explorer.update-legal-representative.dto.ts
var import_class_validator78 = require("class-validator");
var getExplorerUpdateLegalRepresentativeDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const _UpsertBase64DocumentDto = getUpsertBase64DocumentDto(ApiPropertySwagger);
  class UpsertBase64DocumentDto extends _UpsertBase64DocumentDto {
  }
  class UpdateLegalRepresentativeDto {
  }
  __decorateClass([
    (0, import_class_validator78.IsUUID)(),
    (0, import_class_validator78.Length)(36, 36, {
      message: "Sign up Representative UUID should be 36 Characters long"
    }),
    ApiProperty({
      description: `Sign up Representative UUID.`,
      required: true,
      type: String,
      example: "96c9e11d-74aa-4675-b37d-e218ac1ff2ac"
    })
  ], UpdateLegalRepresentativeDto.prototype, "uuid", 2);
  __decorateClass([
    ValidateNested(UpsertBase64DocumentDto),
    (0, import_class_validator78.IsOptional)(),
    ApiProperty({
      description: "ID Document file to update",
      type: UpsertBase64DocumentDto
    })
  ], UpdateLegalRepresentativeDto.prototype, "idDocument", 2);
  __decorateClass([
    ValidateNested(UpsertBase64DocumentDto),
    (0, import_class_validator78.IsOptional)(),
    ApiProperty({
      description: "Permission file file to update",
      type: UpsertBase64DocumentDto,
      isRequired: false
    })
  ], UpdateLegalRepresentativeDto.prototype, "signupPermissionDocument", 2);
  return UpdateLegalRepresentativeDto;
};

// src/dtos/explorer/signup-requests/explorer.update-sign-up.dto.ts
var getExplorerUpdateSignupDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const _UpdateLegalRepresentativeDto = getExplorerUpdateLegalRepresentativeDto(ApiPropertySwagger);
  class UpdateLegalRepresentativeDto extends _UpdateLegalRepresentativeDto {
  }
  function WithUpdateSignupDto(Base) {
    class UpdateSignupDto extends Base {
    }
    __decorateClass([
      ValidateNested(UpdateLegalRepresentativeDto, { each: true }),
      (0, import_class_validator79.ArrayMinSize)(1, {
        message: "Debe haber al menos un representante legal."
      }),
      (0, import_class_validator79.ArrayMaxSize)(2, {
        message: "Debe haber un m\xE1ximo de dos representantes legales."
      }),
      ApiProperty({
        description: "List of legal representatives",
        type: [UpdateLegalRepresentativeDto],
        required: true
      })
    ], UpdateSignupDto.prototype, "legalRepresentatives", 2);
    return UpdateSignupDto;
  }
  return {
    UpdateSignupDto: WithUpdateSignupDto(class {
    })
  };
};

// src/dtos/explorer/users/update-profile-user.dto.ts
var import_class_validator80 = require("class-validator");
var getUpdateUserProfileDto = (ApiPropertySwagger) => {
  const isFrontend = typeof window !== "undefined";
  const ApiProperty = ApiPropertySwagger || function() {
  };
  class UpdateUserProfileDto {
  }
  __decorateClass([
    (0, import_class_validator80.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator80.IsNumberString)(
      {},
      isFrontend ? { message: "class-validator.isNumber.error" } : void 0
    ),
    ApiProperty({
      description: `User's phone number.`,
      required: false,
      type: String
    })
  ], UpdateUserProfileDto.prototype, "phoneNumber", 2);
  return UpdateUserProfileDto;
};

// src/dtos/explorer/crop-pledges/reject-crop-pledge.dto.ts
var import_class_validator81 = require("class-validator");
var getExplorerRejectCropPledgeDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const maxLengthMessage = "backoffice.pages.generalInformation.validationMessage.maxLength";
  const minLengthMessage = "backoffice.pages.generalInformation.validationMessage.minLength";
  class ExplorerRejectCropPledgeDto {
  }
  __decorateClass([
    (0, import_class_validator81.ValidateIf)((o) => typeof o.validationMessage === "string"),
    (0, import_class_validator81.IsOptional)(),
    (0, import_class_validator81.IsString)(),
    (0, import_class_validator81.MaxLength)(
      500,
      isFrontend ? {
        message: maxLengthMessage
      } : void 0
    ),
    (0, import_class_validator81.MinLength)(
      3,
      isFrontend ? {
        message: minLengthMessage
      } : void 0
    ),
    ApiProperty({
      description: "Validation message required to request changes",
      example: "The info is invalid, please change X...",
      type: String,
      required: false
    })
  ], ExplorerRejectCropPledgeDto.prototype, "validationMessage", 2);
  return ExplorerRejectCropPledgeDto;
};

// src/dtos/explorer/crop-pledges/upsert-crop-pledge-lot-information.dto.ts
var getExplorerUpsertCropPledgeLotInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const _CommonUpsertCropPledgeLotInformationDto = getCommonUpsertCropPledgeLotInformationDto(ApiPropertySwagger);
  const _CommonUpsertCropPledgeLotAffidavitDto = getCommonUpsertCropPledgeLotAffidavitDto(ApiPropertySwagger);
  class CommonUpsertCropPledgeLotAffidavitDto extends _CommonUpsertCropPledgeLotAffidavitDto {
  }
  const _UpsertBase64DocumentDto = getUpsertBase64DocumentDto(ApiPropertySwagger);
  class UpsertBase64DocumentDto extends _UpsertBase64DocumentDto {
  }
  class ExplorerUpsertCropPledgeLotInformationDto extends _CommonUpsertCropPledgeLotInformationDto {
  }
  __decorateClass([
    ValidateNested(CommonUpsertCropPledgeLotAffidavitDto),
    ApiProperty({
      description: "Lot affidavit.",
      type: CommonUpsertCropPledgeLotAffidavitDto,
      required: true
    })
  ], ExplorerUpsertCropPledgeLotInformationDto.prototype, "affidavit", 2);
  __decorateClass([
    ValidateNested(UpsertBase64DocumentDto),
    ApiProperty({
      description: "Geolocation Document file.",
      type: UpsertBase64DocumentDto,
      required: true
    })
  ], ExplorerUpsertCropPledgeLotInformationDto.prototype, "geolocationDocument", 2);
  return ExplorerUpsertCropPledgeLotInformationDto;
};

// src/dtos/explorer/crop-pledges/upsert-crop-pledge-farm-information.dto.ts
var import_class_validator82 = require("class-validator");
var import_class_transformer36 = require("class-transformer");
var getExplorerUpsertCropPledgeLFarmInformationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const _CommonUpsertCropPledgeFarmInformationDto = getCommonUpsertCropPledgeFarmInformationDto(ApiPropertySwagger);
  const _ExplorerUpsertCropPledgeLotInformationDto = getExplorerUpsertCropPledgeLotInformationDto(ApiPropertySwagger);
  class ExplorerUpsertCropPledgeLotInformationDto extends _ExplorerUpsertCropPledgeLotInformationDto {
  }
  const _UpsertBase64DocumentDto = getUpsertBase64DocumentDto(ApiPropertySwagger);
  class UpsertBase64DocumentDto extends _UpsertBase64DocumentDto {
  }
  const _OptionalUpsertBase64ExtendedDocumentDto = getOptionalUpsertBase64ExtendedDocumentDto(ApiPropertySwagger);
  class OptionalUpsertBase64ExtendedDocumentDto extends _OptionalUpsertBase64ExtendedDocumentDto {
  }
  class ExplorerUpsertCropPledgeFarmInformation extends _CommonUpsertCropPledgeFarmInformationDto {
  }
  __decorateClass([
    ValidateNested(UpsertBase64DocumentDto),
    ApiProperty({
      description: "Geolocation Document file.",
      type: UpsertBase64DocumentDto,
      required: true
    })
  ], ExplorerUpsertCropPledgeFarmInformation.prototype, "geolocationDocument", 2);
  __decorateClass([
    (0, import_class_validator82.IsOptional)(),
    (0, import_class_transformer36.Transform)(transformEmptyDocumentToUndefined),
    ValidateNested(OptionalUpsertBase64ExtendedDocumentDto, {
      each: true
    }),
    ApiProperty({
      description: "Farm documentation",
      type: [OptionalUpsertBase64ExtendedDocumentDto],
      required: false
    })
  ], ExplorerUpsertCropPledgeFarmInformation.prototype, "documentation", 2);
  __decorateClass([
    ValidateNested(ExplorerUpsertCropPledgeLotInformationDto, { each: true }),
    ApiProperty({
      description: "Farm lots",
      type: Array(ExplorerUpsertCropPledgeLotInformationDto),
      required: true
    })
  ], ExplorerUpsertCropPledgeFarmInformation.prototype, "lots", 2);
  return ExplorerUpsertCropPledgeFarmInformation;
};

// src/dtos/explorer/crop-pledges/upsert-crop-pledge-farm-documentation.dto.ts
var import_class_transformer37 = require("class-transformer");
var import_class_validator83 = require("class-validator");
var getExplorerUpsertCropPledgeFarmDocumentationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const _CommonUpsertCropPledgeFarmDocumentationDto = getCommonUpsertCropPledgeFarmDocumentationDto(ApiPropertySwagger);
  const _UpsertBase64DocumentDto = getUpsertBase64DocumentDto(ApiPropertySwagger);
  class UpsertBase64DocumentDto extends _UpsertBase64DocumentDto {
  }
  class ExplorerUpsertCropPledgeFarmDocumentationDto extends _CommonUpsertCropPledgeFarmDocumentationDto {
  }
  __decorateClass([
    (0, import_class_validator83.IsOptional)(),
    (0, import_class_transformer37.Transform)(transformEmptyDocumentToUndefined),
    ValidateNested(UpsertBase64DocumentDto),
    ApiProperty({
      description: "Document",
      type: UpsertBase64DocumentDto,
      required: true
    })
  ], ExplorerUpsertCropPledgeFarmDocumentationDto.prototype, "document", 2);
  return ExplorerUpsertCropPledgeFarmDocumentationDto;
};

// src/dtos/explorer/crop-pledges/upsert-crop-pledge-lot-affidavit.dto.ts
var getExplorerUpsertCropPledgeLotAffidavitDto = (ApiPropertySwagger) => {
  const _CommonUpsertCropPledgeLotAffidavitDto = getCommonUpsertCropPledgeLotAffidavitDto(ApiPropertySwagger);
  class ExplorerUpsertCropPledgeLotAffidavitDto extends _CommonUpsertCropPledgeLotAffidavitDto {
  }
  return ExplorerUpsertCropPledgeLotAffidavitDto;
};

// src/dtos/explorer/crop-pledges/upsert-crop-pledge-documentation.dto.ts
var import_class_validator84 = require("class-validator");
var import_class_transformer38 = require("class-transformer");
var getExplorerUpsertCropPledgeDocumentationDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const _UpsertBase64DocumentDto = getUpsertBase64DocumentDto(ApiPropertySwagger);
  class UpsertBase64DocumentDto extends _UpsertBase64DocumentDto {
  }
  class ExplorerUpsertCropPledgeDocumentationDto {
  }
  __decorateClass([
    (0, import_class_transformer38.Expose)(),
    ValidateNested(UpsertBase64DocumentDto),
    ApiProperty({
      description: "Loan contract file to upload / update.",
      type: UpsertBase64DocumentDto,
      required: true
    })
  ], ExplorerUpsertCropPledgeDocumentationDto.prototype, "loanContractFile", 2);
  __decorateClass([
    (0, import_class_transformer38.Expose)(),
    (0, import_class_validator84.IsOptional)(),
    (0, import_class_transformer38.Transform)(transformEmptyDocumentToUndefined),
    ValidateNested(UpsertBase64DocumentDto, { each: true }),
    ApiProperty({
      description: "Additional documents files to upload / update.",
      type: [UpsertBase64DocumentDto],
      required: false
    })
  ], ExplorerUpsertCropPledgeDocumentationDto.prototype, "additionalDocumentFiles", 2);
  return ExplorerUpsertCropPledgeDocumentationDto;
};

// src/dtos/public/sign-up/explorer.create-legal-representative.dto.ts
var import_types34 = __toESM(require_dist());
var import_class_transformer39 = require("class-transformer");
var import_class_validator85 = require("class-validator");

// src/dtos/utils/sanitize.ts
var import_sanitize_html = __toESM(require("sanitize-html"));
var sanitizeValue = ({ value }) => {
  return (0, import_sanitize_html.default)(value, { allowedTags: [], allowedAttributes: {} });
};

// src/dtos/public/sign-up/explorer.create-legal-representative.dto.ts
var getCreateLegalRepresentativeDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const _CreateBase64DocumentDto = getCreateBase64DocumentDto(ApiPropertySwagger);
  class CreateBase64DocumentDto extends _CreateBase64DocumentDto {
  }
  class CreateLegalRepresentativeDto {
  }
  __decorateClass([
    (0, import_class_validator85.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator85.IsString)(),
    ApiProperty({
      description: `Representative First Name.`,
      required: true,
      type: String,
      example: "John"
    }),
    (0, import_class_transformer39.Transform)(sanitizeValue)
  ], CreateLegalRepresentativeDto.prototype, "firstName", 2);
  __decorateClass([
    (0, import_class_validator85.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator85.IsString)(),
    ApiProperty({
      description: `Representative Last Name.`,
      required: true,
      type: String,
      example: "Doe"
    }),
    (0, import_class_transformer39.Transform)(sanitizeValue)
  ], CreateLegalRepresentativeDto.prototype, "lastName", 2);
  __decorateClass([
    (0, import_class_validator85.IsEnum)(import_types34.IDENTITY_DOCUMENT_TYPES, {
      message: "a valid identity document type is required"
    }),
    ApiProperty({
      enum: import_types34.IDENTITY_DOCUMENT_TYPES,
      description: "Representative ID Document Type.",
      required: true,
      example: import_types34.IDENTITY_DOCUMENT_TYPES.DNI
    })
  ], CreateLegalRepresentativeDto.prototype, "idDocumentType", 2);
  __decorateClass([
    (0, import_class_validator85.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator85.IsNumberString)(
      void 0,
      isFrontend ? { message: "class-validator.isNumber.error" } : void 0
    ),
    ApiProperty({
      description: `Representative ID Document number.`,
      required: true,
      type: String,
      example: "12345678AA"
    })
  ], CreateLegalRepresentativeDto.prototype, "idDocumentNumber", 2);
  __decorateClass([
    (0, import_class_validator85.IsEnum)(import_types34.REPRESENTATIVE_POSITIONS, {
      message: isFrontend ? "errorCode.createRepresentative.position.isValid" : "a valid representative position is required"
    }),
    ApiProperty({
      enum: import_types34.REPRESENTATIVE_POSITIONS,
      description: "Representative Position.",
      required: true,
      example: import_types34.REPRESENTATIVE_POSITIONS.PRESIDENT
    })
  ], CreateLegalRepresentativeDto.prototype, "position", 2);
  __decorateClass([
    (0, import_class_validator85.IsEmail)(
      {},
      isFrontend ? { message: "errorCode.createUser.email.isEmail" } : void 0
    ),
    ApiProperty({
      description: "Representative Email.",
      required: true,
      type: String,
      example: "jonnhyboy@company.org"
    })
  ], CreateLegalRepresentativeDto.prototype, "email", 2);
  __decorateClass([
    (0, import_class_validator85.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    ValidateNested(CreateBase64DocumentDto),
    ApiProperty({
      description: "Sign up ID document file to process",
      type: CreateBase64DocumentDto,
      required: true
    })
  ], CreateLegalRepresentativeDto.prototype, "idDocument", 2);
  __decorateClass([
    (0, import_class_validator85.IsOptional)(),
    (0, import_class_transformer39.Transform)(transformEmptyDocumentToUndefined),
    ValidateNested(CreateBase64DocumentDto),
    ApiProperty({
      description: "Sign up Permission document file to process",
      type: CreateBase64DocumentDto,
      required: false
    })
  ], CreateLegalRepresentativeDto.prototype, "signupPermissionDocument", 2);
  return CreateLegalRepresentativeDto;
};

// src/dtos/public/sign-up/explorer.create-sign-up.dto.ts
var import_types35 = __toESM(require_dist());
var import_class_transformer40 = require("class-transformer");
var import_class_validator86 = require("class-validator");

// src/dtos/common/property-decorators/user-fiscal-id.decorator.ts
function UserFiscalId({
  required,
  ApiPropertySwagger
}) {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  return applyDecorators(
    FiscalId({ required }),
    ApiProperty({
      description: "User personal Fiscal Id",
      required,
      type: String,
      example: "30246348681"
    })
  );
}

// src/dtos/public/sign-up/explorer.create-sign-up.dto.ts
var getCreateSignupDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  const _CreateLegalRepresentativeDto = getCreateLegalRepresentativeDto(ApiPropertySwagger);
  class CreateLegalRepresentativeDto extends _CreateLegalRepresentativeDto {
  }
  const _CreateBase64DocumentDto = getCreateBase64DocumentDto(ApiPropertySwagger);
  class CreateBase64DocumentDto extends _CreateBase64DocumentDto {
  }
  function WithCompanyDataDto(Base) {
    class CompanyDataDto extends Base {
    }
    __decorateClass([
      CompanyFiscalId({ required: true, ApiPropertySwagger })
    ], CompanyDataDto.prototype, "companyFiscalId", 2);
    __decorateClass([
      (0, import_class_validator86.IsString)(),
      (0, import_class_validator86.IsNotEmpty)(
        isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
      ),
      ApiProperty({
        description: "Company Name.",
        required: true,
        type: String,
        example: "My Company LLC"
      }),
      (0, import_class_transformer40.Transform)(sanitizeValue)
    ], CompanyDataDto.prototype, "companyName", 2);
    __decorateClass([
      (0, import_class_validator86.IsNotEmpty)(
        isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
      ),
      (0, import_class_validator86.IsString)(),
      ApiProperty({
        description: "Company Street Name.",
        required: true,
        type: String,
        example: "18th Av."
      }),
      (0, import_class_transformer40.Transform)(sanitizeValue)
    ], CompanyDataDto.prototype, "companyStreetName", 2);
    __decorateClass([
      (0, import_class_validator86.IsNotEmpty)(
        isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
      ),
      (0, import_class_validator86.IsNumberString)(
        void 0,
        isFrontend ? { message: "class-validator.isNumber.error" } : void 0
      ),
      ApiProperty({
        description: "Company Street Number.",
        required: true,
        type: String,
        example: "8558"
      })
    ], CompanyDataDto.prototype, "companyStreetNumber", 2);
    __decorateClass([
      (0, import_class_validator86.IsNotEmpty)(
        isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
      ),
      (0, import_class_validator86.IsNumber)(
        void 0,
        isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
      ),
      ApiProperty({
        description: "Company Province ID.",
        required: true,
        type: Number,
        example: 18
      }),
      (0, import_class_transformer40.Transform)(({ value }) => parseInt(value, 10))
    ], CompanyDataDto.prototype, "companyProvinceId", 2);
    __decorateClass([
      (0, import_class_validator86.IsNotEmpty)(
        isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
      ),
      (0, import_class_validator86.IsNumber)(
        void 0,
        isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
      ),
      ApiProperty({
        description: "Company Locality ID.",
        required: true,
        type: Number,
        example: "1540"
      }),
      (0, import_class_transformer40.Transform)(({ value }) => parseInt(value, 10))
    ], CompanyDataDto.prototype, "companyLocalityId", 2);
    __decorateClass([
      (0, import_class_validator86.IsNotEmpty)(
        isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
      ),
      (0, import_class_validator86.IsNumberString)(
        {},
        isFrontend ? { message: "class-validator.isNumber.error" } : void 0
      ),
      (0, import_class_validator86.MaxLength)(
        10,
        isFrontend ? { message: "class-validator.maxLength10.error" } : void 0
      ),
      ApiProperty({
        description: "Company Postal Code.",
        required: true,
        type: String,
        example: "11150"
      })
    ], CompanyDataDto.prototype, "companyPostalCode", 2);
    __decorateClass([
      (0, import_class_validator86.IsEnum)(import_types35.EXCHANGES, {
        message: "errorCode.createSignUp.companyExchange.isValid"
      }),
      (0, import_class_validator86.IsNotEmpty)(
        isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
      ),
      ApiProperty({
        enum: import_types35.EXCHANGES,
        description: "Company Exchange.",
        required: true,
        example: import_types35.EXCHANGES.BCBA
      })
    ], CompanyDataDto.prototype, "companyExchange", 2);
    __decorateClass([
      (0, import_class_validator86.IsEnum)(import_types35.COMPANY_TYPES),
      (0, import_class_validator86.IsNotEmpty)(
        isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
      ),
      ApiProperty({
        enum: import_types35.COMPANY_TYPES,
        description: "Company Type.",
        required: true,
        example: import_types35.COMPANY_TYPES.SA
      })
    ], CompanyDataDto.prototype, "companyType", 2);
    return CompanyDataDto;
  }
  function WithCompanyUserDataDto(Base) {
    class CompanyUserDataDto extends Base {
    }
    __decorateClass([
      (0, import_class_validator86.IsNotEmpty)(
        isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
      ),
      (0, import_class_validator86.IsString)(),
      ApiProperty({
        description: "User First Name.",
        required: true,
        type: String,
        example: "John"
      }),
      (0, import_class_transformer40.Transform)(sanitizeValue)
    ], CompanyUserDataDto.prototype, "userFirstName", 2);
    __decorateClass([
      (0, import_class_validator86.IsNotEmpty)(
        isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
      ),
      (0, import_class_validator86.IsString)(),
      ApiProperty({
        description: "User Last Name.",
        required: true,
        type: String,
        example: "Doe"
      }),
      (0, import_class_transformer40.Transform)(sanitizeValue)
    ], CompanyUserDataDto.prototype, "userLastName", 2);
    __decorateClass([
      UserFiscalId({ required: true, ApiPropertySwagger })
    ], CompanyUserDataDto.prototype, "userFiscalId", 2);
    __decorateClass([
      (0, import_class_validator86.IsNotEmpty)(
        isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
      ),
      (0, import_class_validator86.IsNumberString)(
        {},
        isFrontend ? { message: "class-validator.isNumber.error" } : void 0
      ),
      ApiProperty({
        description: "User phone number.",
        required: true,
        type: String,
        example: "+5491155555555"
      })
    ], CompanyUserDataDto.prototype, "userPhone", 2);
    __decorateClass([
      (0, import_class_validator86.IsNotEmpty)(
        isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
      ),
      (0, import_class_validator86.IsEmail)(
        {},
        isFrontend ? { message: "errorCode.createUser.email.isEmail" } : void 0
      ),
      ApiProperty({
        description: "User email address.",
        required: true,
        type: String,
        example: "john.doe@mycompany.org"
      })
    ], CompanyUserDataDto.prototype, "userEmail", 2);
    __decorateClass([
      (0, import_class_validator86.IsNotEmpty)(
        isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
      ),
      (0, import_class_validator86.IsEmail)(
        {},
        isFrontend ? { message: "errorCode.createUser.email.isEmail" } : void 0
      ),
      ApiProperty({
        description: "User email address confirm.",
        required: true,
        type: String,
        example: "john.doe@mycompany.org"
      }),
      Match(
        "userEmail",
        isFrontend ? {
          message: "errorCode.createUser.email.emailsDontMatch"
        } : void 0
      )
    ], CompanyUserDataDto.prototype, "userEmailConfirm", 2);
    return CompanyUserDataDto;
  }
  function WithCompanyLegalRepresentativeDataDto(Base) {
    class CreateSignupDto extends Base {
    }
    __decorateClass([
      ValidateNested(CreateLegalRepresentativeDto, { each: true }),
      (0, import_class_validator86.ArrayMinSize)(1, {
        message: "Debe haber al menos un representante legal."
      }),
      (0, import_class_validator86.ArrayMaxSize)(2, {
        message: "Debe haber un m\xE1ximo de dos representantes legales."
      }),
      ApiProperty({
        description: "List of legal representatives",
        type: [CreateLegalRepresentativeDto],
        required: true
      })
    ], CreateSignupDto.prototype, "legalRepresentatives", 2);
    __decorateClass([
      (0, import_class_validator86.IsNotEmpty)(
        isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
      ),
      ValidateNested(CreateBase64DocumentDto),
      ApiProperty({
        description: "Sign up document file to process",
        type: CreateBase64DocumentDto,
        required: true
      })
    ], CreateSignupDto.prototype, "permissionFileDocument", 2);
    __decorateClass([
      (0, import_class_validator86.IsString)(),
      (0, import_class_validator86.IsOptional)(),
      ApiProperty({
        description: "ReCaptcha token",
        type: String,
        required: false
      })
    ], CreateSignupDto.prototype, "reCaptchaToken", 2);
    return CreateSignupDto;
  }
  return {
    CompanyDataDto: WithCompanyDataDto(class {
    }),
    CompanyUserDataDto: WithCompanyUserDataDto(class {
    }),
    CompanyLegalRepresentativeDataDto: WithCompanyLegalRepresentativeDataDto(
      class {
      }
    ),
    CreateSignupDto: WithCompanyDataDto(
      WithCompanyUserDataDto(WithCompanyLegalRepresentativeDataDto(class {
      }))
    )
  };
};

// src/dtos/public/sign-up/explorer.forward-sign-up-document.dto.ts
var import_class_transformer41 = require("class-transformer");
var import_class_validator87 = require("class-validator");
var getExplorerForwardSignUpDocumentDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class ForwardSignUpDocumentDto {
  }
  __decorateClass([
    (0, import_class_validator87.IsUUID)(),
    ApiProperty({
      description: `Admin User UUID.`,
      required: true,
      type: String,
      example: "96c9e11d-74aa-4675-b37d-e218ac1ff2ac"
    })
  ], ForwardSignUpDocumentDto.prototype, "uuid", 2);
  __decorateClass([
    (0, import_class_validator87.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator87.IsEmail)(
      {},
      isFrontend ? { message: "class-validator.email.isEmail" } : void 0
    ),
    ApiProperty({
      description: `Email to forward to.`,
      required: true,
      type: String,
      example: "example@domain.com"
    }),
    (0, import_class_transformer41.Transform)(sanitizeValue)
  ], ForwardSignUpDocumentDto.prototype, "email", 2);
  return ForwardSignUpDocumentDto;
};

// src/dtos/public/sign-up/explorer.get-signup-admin-availability.dto.ts
var import_class_validator88 = require("class-validator");
var getSignupRequestAdminAvailabilityDto = (ApiPropertySwagger) => {
  const ApiProperty = ApiPropertySwagger || function() {
  };
  const isFrontend = typeof window !== "undefined";
  class GetSignupRequestAdminAvailabilityDto {
  }
  __decorateClass([
    (0, import_class_validator88.IsNotEmpty)(
      isFrontend ? { message: "class-validator.isNotEmpty.error" } : void 0
    ),
    (0, import_class_validator88.IsEmail)(
      {},
      isFrontend ? { message: "class-validator.email.isEmail" } : void 0
    ),
    ApiProperty({
      description: `Admin email`,
      required: true,
      type: String,
      example: "example@domain.com"
    })
  ], GetSignupRequestAdminAvailabilityDto.prototype, "email", 2);
  __decorateClass([
    UserFiscalId({ required: true, ApiPropertySwagger })
  ], GetSignupRequestAdminAvailabilityDto.prototype, "fiscalId", 2);
  return GetSignupRequestAdminAvailabilityDto;
};

// src/common/enum/blockchain/transaction-status.enum.ts
var TRANSACTION_STATUS = {
  PENDING: "0",
  CONFIRMED: "1",
  FAILED: "2"
};
var transactionStatus = Object.values(TRANSACTION_STATUS);

// src/common/enum/index.ts
var SortOrder = /* @__PURE__ */ ((SortOrder2) => {
  SortOrder2["ASC"] = "ASC";
  SortOrder2["DESC"] = "DESC";
  return SortOrder2;
})(SortOrder || {});
var CertificateRequestsSortBy = /* @__PURE__ */ ((CertificateRequestsSortBy2) => {
  CertificateRequestsSortBy2["createdAt"] = "createdAt";
  return CertificateRequestsSortBy2;
})(CertificateRequestsSortBy || {});
var CertificateShareRequestsSortBy = /* @__PURE__ */ ((CertificateShareRequestsSortBy2) => {
  CertificateShareRequestsSortBy2["createdAt"] = "createdAt";
  return CertificateShareRequestsSortBy2;
})(CertificateShareRequestsSortBy || {});
var CertificateViewersSortBy = /* @__PURE__ */ ((CertificateViewersSortBy2) => {
  CertificateViewersSortBy2["CREATED_AT"] = "createdAt";
  return CertificateViewersSortBy2;
})(CertificateViewersSortBy || {});

// src/index.ts
__reExport(src_exports, require("reflect-metadata"), module.exports);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CertificateRequestsSortBy,
  CertificateShareRequestsSortBy,
  CertificateViewersSortBy,
  SortOrder,
  TRANSACTION_STATUS,
  getBackofficeRequestChangesDigitalDossierDto,
  getBackofficeUpdateCropPledgeCreditorInformationDto,
  getBackofficeUpdateDigitalDossierBankAccountDto,
  getBackofficeUpdateDigitalDossierBankingInformationDto,
  getBackofficeUpdateDigitalDossierGeneralInformationDto,
  getBackofficeUpdateDigitalDossierTaxInformationDto,
  getBackofficeUpsertCropPledgeDocumentationDto,
  getBackofficeUpsertCropPledgeFarmInformationDto,
  getBackofficeUpsertCropPledgeInformationDto,
  getBackofficeUpsertCropPledgeInsuranceInformationDto,
  getBackofficeUpsertCropPledgeLotAffidavitDto,
  getBackofficeUpsertCropPledgeLotInformationDto,
  getBackofficeUpsertDigitalDossierFormsAndDocsInformationDto,
  getBackofficeUpsertDigitalDossierLegalRepresentantDto,
  getBackofficeUpsertDigitalDossierLegalRepresentantInformationDto,
  getBackofficeUpsertDigitalDossierRepresentantCurrencyCapDto,
  getBackofficeUpsertDigitalDossierRepresentantProductCapDto,
  getBackofficeUpsertProductiveFacilityDto,
  getBackofficeUpsertStorageFacilityDto,
  getChangeRequestSignupDto,
  getChangeRequestUpdateLegalRepDocumentDto,
  getChangeRequestUpdateLegalRepDto,
  getCommonSetCropPledgeCreditorDto,
  getCommonUpdateCropPledgeCreditorInformationDto,
  getCommonUpdateCropPledgeDebtorInformationDto,
  getCommonUpsertCropPledgeFarmDocumentationDto,
  getCommonUpsertCropPledgeFarmInformationDto,
  getCommonUpsertCropPledgeLotAffidavitDto,
  getCommonUpsertCropPledgeLotInformationDto,
  getCommonUpsertProductiveAffidavitDto,
  getCommonUpsertProductiveFacilityDto,
  getCommonUpsertStorageAffidavitDto,
  getCommonUpsertStorageFacilityDto,
  getCreateAdminDto,
  getCreateBase64DocumentDto,
  getCreateCompanyDocumentDto,
  getCreateCompanyDto,
  getCreateCompanyQueriesLoadHistoryDto,
  getCreateLegalRepresentativeDto,
  getCreateSignupDto,
  getCreateUserCompanyDto,
  getCreateUserDto,
  getDigitalDossiersDto,
  getExplorerCreateAccessRequestDto,
  getExplorerForwardSignUpDocumentDto,
  getExplorerRejectCropPledgeDto,
  getExplorerSearchDossierDto,
  getExplorerUpdateAccessRequestDto,
  getExplorerUpdateDigitalDossierFormDocsDto,
  getExplorerUpdateDigitalDossierGeneralInformationDto,
  getExplorerUpdateDigitalDossierLegalRepresentativeInformationDto,
  getExplorerUpdateDigitalDossierTaxInformationDto,
  getExplorerUpdateLegalRepresentativeDto,
  getExplorerUpdateSignupDto,
  getExplorerUpsertCropPledgeDocumentationDto,
  getExplorerUpsertCropPledgeFarmDocumentationDto,
  getExplorerUpsertCropPledgeLFarmInformationDto,
  getExplorerUpsertCropPledgeLotAffidavitDto,
  getExplorerUpsertCropPledgeLotInformationDto,
  getExplorerUpsertDigitalDossierBankAccountDto,
  getExplorerUpsertDigitalDossierBankingInformationDto,
  getExplorerUpsertDigitalDossierFormsAndDocsInformationDto,
  getExplorerUpsertDigitalDossierLegalRepresentantDto,
  getExplorerUpsertDigitalDossierLegalRepresentantInformationDto,
  getOptionalUpsertBase64ExtendedDocumentDto,
  getPaginatedCropPledgesDto,
  getPaginatedSearchDto,
  getReceivedAccessRequestsDto,
  getRejectSignupRequestDto,
  getSentAccessRequestsDto,
  getSignupRequestAdminAvailabilityDto,
  getSignupRequestsDto,
  getUpdateAdminDto,
  getUpdateCompanyDocumentDto,
  getUpdateCompanyDto,
  getUpdateSignupLegalRepresentativeDto,
  getUpdateSignupRequestDto,
  getUpdateSignupUserDto,
  getUpdateUserDto,
  getUpdateUserProfileDto,
  getUpsertBackofficeCompanyContactInformationDto,
  getUpsertBackofficeCompanyEquityInformationDto,
  getUpsertBase64DocumentDto,
  getUpsertBase64ExtendedDocumentDto,
  getUpsertCompanyContactInformationDto,
  getUpsertCompanyEquityInformationDto,
  transactionStatus,
  ...require("reflect-metadata")
});
